<template>
  <div class="pa-3">
    <v-row justify="right" align="center">
      <v-col cols="12" md="4" lg="4" sm="12" align="center" justify="center">
        <v-autocomplete
          filled
          :items="campaignList"
          label="Campaign"
          item-value="id"
          hide-details
          item-text="name"
          v-model="selectedCampaignID"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="8" lg="8" sm="12">
        <div class="d-flex flex-wrap" style="text-align:right;">
          <div style="margin:0px 5px 10px 0px;">
            <v-btn @click="viewReport" right :disabled="!selectedCampaignID">View HTML Report</v-btn>
          </div>
          <div style="margin:0px 5px 10px 0px;">
            <v-btn @click="viewPayoutsReport" right :disabled="!selectedCampaignID">View Payouts Report</v-btn>
          </div>
          <div style="margin:0px 5px 10px 0px;">
            <v-btn @click="getCampaignDataToView(selectedCampaignID)" :disabled="selectedCampaignID === null">View Campaign Brief</v-btn>
          </div>
          <div style="margin:0px 5px 10px 0px;">
            <v-btn @click="exportPDF(selectedCampaignID, campaignData.name, false)" :disabled="!selectedCampaignID">
              Download PDF
              <v-icon right>mdi-pdf-box</v-icon>
            </v-btn>
          </div>
          <div style="margin:0px 5px 10px 0px;">
            <v-btn @click="exportExcel(selectedCampaignID, campaignData.name, false)" :disabled="!selectedCampaignID">
              Download Excel
              <v-icon right>mdi-file-excel</v-icon>
            </v-btn>
          </div>
          <div style="margin:0px 5px 10px 0px;">
            <v-btn :disabled="!selectedCampaignID" @click="quickReload()">
              Reload Page
              <v-icon right>refresh</v-icon>
            </v-btn>
          </div>
          <div style="margin:0px 5px 10px 0px;">
            <v-btn :disabled="!selectedCampaignID" @click="getCampaignReport(selectedCampaignID, true)" color="secondary">
              Refresh Data
              <v-icon right>refresh</v-icon>
            </v-btn>
          </div>
          <div style="margin:0px 5px 10px 0px;">
            <v-btn @click="changeSettings(campaignData)" color="secondary" :disabled="!selectedCampaignID">
              <i class="fas fa-sliders-h"></i> Campaign Settings
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <div>
      <v-row v-if="campaignData">
        <v-col cols="6">
          <v-card color="#363636" dark style="min-height:460px">
            <!-- <v-card-subtitle class="subtitle-1 pb-0">{{ client ? client.name : '' }}</v-card-subtitle> -->
            <v-card-title class="title pt-2 pb-0">
              Campaign Name: {{ campaignData ? campaignData.name : 'N/A' }}
              <v-chip
              color="warning"
              small
              text-color="white"
              v-if="markupCOGSAmount">
                Markup COGS
              </v-chip>
              <v-chip color="error" v-if="campaignData.lockedCOGS" small>
                <span style="color:#fff"><v-icon v-on="on" small left>mdi-lock</v-icon>Locked COGS</span>
              </v-chip>        
              <v-spacer></v-spacer>
              <p class="subtitle-2 font-weight-light"> Current Status: {{ currentCampaignStatusDisplay }}</p>
            </v-card-title>
            <v-card-title class="title">
              Client Name: {{ client ? client.name : 'N/A' }}
            </v-card-title>
            <v-card-subtitle class="subtitle-1 pb-0 pt-2" style="font-size:17px!important">
              IO Number: {{ campaignData ? (campaignData.ioNumbers || 'N/A') : 'N/A' }}
            </v-card-subtitle>
            <v-card-subtitle class="subtitle-1 pb-0" style="font-size:17px!important">
              Budget: ${{ campaignData.budget | thousandSeprator }}
            </v-card-subtitle>
            <v-card-subtitle class="subtitle-1 pb-0" v-if="campaignData.revenueCalculation === 'engagement'" style="font-size:17px!important">
              Calculation Method: Engagement
            </v-card-subtitle>
            <!-- <v-card-subtitle class="subtitle-1 pb-0" v-else>
              Calculation Method: Contents/Outreach
            </v-card-subtitle> -->
            <v-card-subtitle class="subtitle-1 pb-0" style="font-size:17px!important">
              Campaign Period: {{ minLiveDate }} - {{ maxLiveDate }}
            </v-card-subtitle>
            <v-card-subtitle class="subtitle-1 pb-3" style="font-size:17px!important">
              Number of Reviewers: {{ numberOfReviewers }}
            </v-card-subtitle>
            <!-- <v-card-text>
              <v-list-item class="grow pa-0" color="#607d8b">
                <v-list-item-content>
                  <v-list-item-title class="caption">Engagement: {{ campaignData.engagement | thousandSeprator }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title class="caption">Outreach: {{ campaignData.outreach | thousandSeprator }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title class="caption"
                    >Contents: {{ `${campaignData.min_content} - ${campaignData.max_content}` }}</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-content>
                  <v-list-item-title class="caption">Package: ${{ campaignData.budget | thousandSeprator }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text> -->
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-container class="pl-0 pr-0" fill-height fluid grid-list-xl style="padding-top:0">
            <v-layout wrap>
              <v-flex class="pt-0" md6 sm12 lg12>
                <v-card color="#363636" dark>
                  <v-card-text>
                    <div class="outreach-kpi-row">
                      <div class="display-text">
                        <v-card-title class="ma-0 pa-0 headline mb-3 font-weight-medium" style="color:white">Outreach KPI</v-card-title>
                        <p class="ma-0 pa-0 h3">{{ summary.outreach | thousandSeprator }} / {{ campaignData.outreach | thousandSeprator }}</p>
                        <p class="ma-0 pa-0 subtitle-1">{{ summary.outreach_percentage }}%</p>
                      </div>
                      <div class="odometer-gauge">
                        <div class="odometer-arc">
                          <svg class="odometer-arc-svg" viewBox="0 0 170 90" preserveAspectRatio="none">
                            <defs>
                              <linearGradient id="outreachArcGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stop-color="#ef5350"></stop>
                                <stop offset="100%" stop-color="#66bb6a"></stop>
                              </linearGradient>
                            </defs>
                            <path
                              class="odometer-arc-track-path"
                              d="M 10 85 A 75 75 0 0 1 160 85"
                            ></path>
                            <path
                              class="odometer-arc-progress-path"
                              d="M 10 85 A 75 75 0 0 1 160 85"
                              :style="{
                                strokeDasharray: `${outreachArcLength}`,
                                strokeDashoffset: `${outreachArcOffset}`,
                                stroke: 'url(#outreachArcGradient)'
                              }"
                            ></path>
                          </svg>
                          <div
                            class="odometer-needle"
                            :style="{ transform: `translateX(-50%) rotate(${outreachNeedleRotation}deg)` }"
                          ></div>
                          <div class="odometer-arc-center"></div>
                        </div>
                        <div class="odometer-meta">
                          <span class="odometer-percent">{{ outreachRatioPercent }}%</span>
                          <!-- <span class="odometer-label">Target Achieved</span> -->
                        </div>
                        <!-- <div class="odometer-counter" :title="`${outreachCurrent} / ${outreachTarget}`">
                          <span
                            v-for="(digit, index) in outreachOdometerDigits"
                            :key="`odo-${index}-${digit}`"
                            class="odometer-digit"
                          >{{ digit }}</span>
                        </div> -->
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <!-- <v-flex md6 sm12 lg4>
                <v-card color="#363636" dark>
                  <v-card-title>Engagement KPI</v-card-title>
                  <v-card-text v-if="summary.engagement && campaignData.engagement">
                    <p class="ma-0 pa-0 h3">{{ summary.engagement | thousandSeprator }} / {{ campaignData.engagement | thousandSeprator }}</p>
                    <p class="ma-0 pa-0 subtitle-1">{{ summary.engagement_percentage }}%</p>
                  </v-card-text>
                  <v-card-text v-else>
                    <p class="mb-2 pa-0 h3">-</p>
                  </v-card-text>
                </v-card>
              </v-flex> -->
              <v-flex class="pt-0" md12 sm12 lg12>
                <v-card color="#363636" dark>
                  <v-card-text>
                    <div class="contents-kpi-row">
                      <div class="display-text">
                        <v-card-title class="ma-0 pa-0 headline mb-3 font-weight-medium" style="color:white">Contents KPI</v-card-title>
                        <p class="ma-0 pa-0 h3">{{ summary.contents }} / {{ campaignData.min_content }}</p>
                        <p class="ma-0 pa-0 subtitle-1">{{ summary.contents_percentage }}%</p>
                      </div>
                      <div class="contents-progress-gauge">
                        <div class="contents-progress-head">
                          <span class="contents-progress-percent">{{ contentsRatioPercent }}%</span>
                        </div>
                        <div class="contents-progress-track">
                          <div class="contents-progress-fill" :style="{ width: `${contentsProgressFillPercent}%` }"></div>
                        </div>
                        <div class="contents-progress-scale">
                          <span>0%</span>
                          <span>50%</span>
                          <span>100%</span>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex class="pt-0" md12 sm12 lg12>
                <v-row>
                  <v-col cols="12" md="6" lg="6" class="pt-0 pb-0" style="margin-top: 10px;margin-bottom: 10px;">
                    <v-card color="#363636" style="min-height: 135px" dark>
                      <v-card-title class="headline">Outreach + Impressions</v-card-title>
                      <v-card-text>
                        <p class="ma-0 pa-0 h3">{{ outreachImpressionsTotal | thousandSeprator }}</p>
                        <!-- <p class="ma-0 pa-0 subtitle-1">Outreach: {{ summary.outreach | thousandSeprator }} + Impressions: {{ summary.impressions | thousandSeprator }}</p> -->
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6" lg="6" class="pt-0 pb-0" style="margin-top: 10px;margin-bottom: 10px;">
                    <v-card color="#363636" dark>
                      <v-card-title class="headline">COGS KPI</v-card-title>
                      <v-card-text>
                        <p class="ma-0 pa-0 h3">${{ totalCounts.amount | thousandSeprator }} / ${{ budget | thousandSeprator }}</p>
                        <p class="ma-0 pa-0 subtitle-1">{{ cogsPercentage }}%</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-flex>
              <!-- <v-flex md6 sm12 lg4>
                <v-card color="#363636" dark>
                  <v-card-title class="headline">
                    Revenue Recognised
                  </v-card-title>
                  <v-card-text v-if="swtRevenue === 'content'" style="padding-top:0px;">
                      <p class="ma-0 pa-0 h3">${{ revenueByContents | thousandSeprator }} / ${{ campaignData.budget | thousandSeprator }}</p>
                      <p class="ma-0 pa-0 subtitle-1">{{ revenueByContentsPercent }}%</p>
                  </v-card-text>
                  <v-card-text v-else style="padding-top:0px;">
                    <p class="ma-0 pa-0 h3">${{ revenueByEng | thousandSeprator }} / ${{ campaignData.budget | thousandSeprator }}</p>
                    <p class="ma-0 pa-0 subtitle-1">{{ revenueEngPercent }}%</p>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex md6 sm12 lg4>
                <v-card color="#363636" dark>
                  <v-card-title class="headline">
                    UnRecognised Revenue
                  </v-card-title>
                  <v-card-text v-if="swtRevenue === 'content'" style="padding-top:0px;">
                      <p class="ma-0 pa-0 h3">${{ UnRecognisedRevenueContent | thousandSeprator }} / ${{ campaignData.budget | thousandSeprator }}</p>
                      <p class="ma-0 pa-0 subtitle-1">{{ UnRecognisedRevenueContentPercentage }}%</p>
                  </v-card-text>
                  <v-card-text v-else style="padding-top:0px;">
                    <p class="ma-0 pa-0 h3">${{ UnRecognisedRevenueEng | thousandSeprator }} / ${{ campaignData.budget | thousandSeprator }}</p>
                    <p class="ma-0 pa-0 subtitle-1">{{ UnRecognisedRevenueEngPercentage }}%</p>
                  </v-card-text>
                </v-card>
              </v-flex> -->
            </v-layout>
          </v-container>
        </v-col>
      </v-row>
    </div>
    <campaign-summary
    :campaign="campaignData"
    :isInternalView="true"
    :respData="respData"
    @loading-status="handleLoadingStatus"
    @saved="quickReload()"
    v-if="campaignData" />
    <div v-if="selectedCampaignID">
      <report-for-summary v-if="respData && selectedCampaignID" :respData="respData"  :campaignID="selectedCampaignID" @loading-status="handleLoadingStatus"/>
    </div>
    <v-row style="margin-top:10px;">
      <v-col xs="12" sm="10" md="10" lg="10">
        <v-btn rounded color="secondary" @click="addPost()" :disabled="!selectedCampaignID" class="ma-2">Add Content</v-btn>
        <v-btn v-show="posts.length > 0" color="primary" @click="saveLineUp()" :disabled="disableSaveArrange" rounded class="ma-2">Save Posts Arrangement</v-btn>
        <v-btn
          rounded
          color="warning"
          :disabled="!selectedPosts || selectedPosts.length === 0"
          @click="openReportGroupModal()"
          v-show="posts.length > 0"
        >Add to Group ({{selectedPosts.length}})</v-btn>
        <!-- <v-btn rounded color="warning" @click="exportExcelPosts(selectedCampaignID, campaignData.name, false)" :disabled="!selectedCampaignID" dark class="ma-2">Export Excel <v-icon right>mdi-file-excel</v-icon></v-btn> -->
      </v-col>
      <v-col xs="12" sm="2" md="2" lg="2" v-show="posts.length > 0">
        <v-btn-toggle v-model="display" class="float-right" mandatory :value="0" :light="true">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                <v-icon>grid_on</v-icon>
              </v-btn>
            </template>
            <span>Grid View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">
                <v-icon>list</v-icon>
              </v-btn>
            </template>
            <span>List View</span>
          </v-tooltip>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <div fill-height>
      <v-row class="justify-right" v-if="posts.length">
        <div class="float-right">
          <v-col cols="12" sm="12" md="4" lg="4">
            <v-select
              :items="postTypes"
              item-text="title"
              item-value="title"
              label="Content Type"
              v-model="postType"
              filled
              dense
              hide-details
              @change="getFiltered()"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-menu
              ref="monthPicker"
              v-model="monthPicker"
              :close-on-content-click="false"
              :return-value.sync="selectedMonth"
              transition="scale-transition"
              offset-y
              dense
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Live Date"
                  v-model="searchMonth"
                  readonly
                  clearable
                  filled
                  dense
                  hide-details="auto"
                  v-bind="attrs"
                  v-on="on"
                  @change="getFiltered()"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchMonth"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="secondary"
                    @click="monthPicker = false"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    color="secondary"
                    @click="searchMonthOk"
                >
                    OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <v-text-field
              class="mb-5"
              v-model="searchFilter"
              @keyup="getFiltered()"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </div>
      </v-row>
      <!-- Start Grid View -->
      <div style="width:100%;margin-top:10px;margin-bottom:10px;padding:10px" class="no-gutters"  v-if="display === 0">
        <draggable v-model="filteredPosts" class="row clearfix" style="width:100%;" @update="handleDragDropUpdate(filteredPosts)">
          <div :class="{'pa-2 col-sm-12 col-md-4 col-lg-3 col':!post.reportGroup && !isTwitterReport(post), 'pa-2 col-sm-12 col-md-6 col-lg-4 col twitter-grid-column':!post.reportGroup && isTwitterReport(post), 'row mb-2':post.reportGroup}" :style="post.reportGroup?'width:100%':''" v-for="post of filteredPosts" :key="post.id">
            <!-- Start Post Groups Lists -->
            <v-col cols="auto" sm="12" md="12" lg="12" class="pa-3 pr-0 mt-3" v-if="post.reportGroup">
              <v-expansion-panels class="post-group-panel" v-model="post.panel" multiple dark accordion focusable>
                <v-expansion-panel expand>
                  <v-expansion-panel-header>{{post.name}} ({{post.reports.length}})</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row style="margin-top:10px;margin-bottom:10px;" class="no-gutters" v-if="post.reports">
                      <draggable v-model="post.reports" style="width:100%;" @update="handleDragDropUpdate(post.reports)" class="row no-gutters flex-wrap flex-row fill-height" >
                        <v-col v-for="post of post.reports" :key="post.id" cols="12" sm="12" :md="isTwitterReport(post) ? 6 : 4" :lg="isTwitterReport(post) ? 4 : 3" class="pa-2">
                          <v-hover v-slot:default="{ hover }">
                              <v-card
                                  v-if="post.success && !isLinkedInReport(post) && !isTwitterReport(post)"
                                  class="mx-auto campaign-post"
                                  color="#62727b"
                                  dark
                                  max-width="300"
                                  :elevation="hover ? 12 : 2"
                                  :class="{ 'on-hover': hover }"
                                >
                                  <v-card-title class="campaign-post-header">
                                    <v-list-item class="grow pa-0 campaign-post-header-row">
                                      <v-list-item-avatar color="grey darken-3">
                                        <v-img class="elevation-6" :src="post.post_details.owner.profile_pic_url"></v-img>
                                      </v-list-item-avatar>

                                      <v-list-item-content class="campaign-post-owner-content">
                                        <v-list-item-title class="campaign-post-owner-title">
                                          <a class="caption campaign-post-owner-handle" :title="`@${post.profileHandle || post.profile_handle || post.post_details.owner.username}`" :href="getAccountProfileUrl(post)" target="_blank" rel="noopener noreferrer"
                                            >@{{ post.profileHandle || post.profile_handle || post.post_details.owner.username }}</a
                                          >
                                          <!-- <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(post)">edit</v-icon> -->
                                        </v-list-item-title>
                                      </v-list-item-content>
                                      <!-- <v-list-item-action v-if="post.payout_details">${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                                      <v-list-item-action class="campaign-post-type-action">
                                        <v-chip
                                          color="primary"
                                          v-if="post.type"
                                          small
                                        >
                                          {{post.type}}
                                        </v-chip>
                                      </v-list-item-action>
                                    </v-list-item>
                                  </v-card-title>

                                  <v-card-text class="headline font-weight-bold">
                                    <!-- <img
                                      width="100%"
                                      class="elevation-0"
                                      :src="post.media_url ? post.media_url : post.post_details.image"
                                    /> -->
                                    <instagram-post-embed :url="getReportPostUrl(post)" />
                                  </v-card-text>

                                  <v-card-text>
                                    <div class="text-center">
                                      <v-chip
                                      dark
                                      label
                                      class="subheading ma-1">
                                        <span>IMS Status:&nbsp;</span>
                                        <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                                      </v-chip>
                                    </div>
                                    <v-expansion-panels>
                                      <v-expansion-panel v-if="post.currentInsight">
                                        <v-expansion-panel-header>
                                          Post Insights
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-simple-table dark dense v-if="post.currentInsight">
                                            <template v-slot:default>
                                              <tbody>
                                                <tr v-if="post.inputtedInsights && !isTwitterReport(post) && (!isLinkedInReport(post) || post.inputtedInsights.reach != null)">
                                                  <td>{{ isLinkedInReport(post) ? 'Members reached' : 'Reach' }}</td>
                                                  <td>{{ post.inputtedInsights.reach }}</td>
                                                </tr>
                                                <tr v-if="post.currentInsight.views && !isTwitterReport(post) && !isLinkedInReport(post)">
                                                  <td>Plays (Views)</td>
                                                  <td>{{ post.currentInsight.views }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights && (!isTwitterReport(post) && !isLinkedInReport(post) || post.inputtedInsights.impressions != null)">
                                                  <td>Impressions</td>
                                                  <td>{{ post.inputtedInsights.impressions }}</td>
                                                </tr>
                                                <tr v-if="isLinkedInReport(post) && post.inputtedInsights">
                                                  <td>Video views</td>
                                                  <td>{{ post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-' }}</td>
                                                </tr>
                                                <tr v-if="isLinkedInReport(post) && post.inputtedInsights">
                                                  <td>Profile viewers from this post</td>
                                                  <td>{{ post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-' }}</td>
                                                </tr>
                                                <tr>
                                                  <td>{{ isLinkedInReport(post) ? 'Reactions' : 'Likes' }}</td>
                                                  <td>{{ post.currentInsight.like_count }}</td>
                                                </tr>
                                                <tr>
                                                  <td>{{ isTwitterReport(post) ? 'Replies' : 'Comments' }}</td>
                                                  <td>{{ post.currentInsight.comment_count }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights">
                                                  <td>{{ isLinkedInReport(post) ? 'Saves' : (isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)') }}</td>
                                                  <td>{{ post.inputtedInsights.saved }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights && post.inputtedInsights.plays">
                                                  <td>Watch Time</td>
                                                  <td>{{ post.inputtedInsights.plays }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights && post.inputtedInsights.watches">
                                                  <td>Average Watch Time</td>
                                                  <td>{{ post.inputtedInsights.watches }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights">
                                                  <td>{{ isLinkedInReport(post) || isTwitterReport(post) ? 'Reposts' : 'Shares' }}</td>
                                                  <td>{{ post.inputtedInsights.shares }}</td>
                                                </tr>
                                                <tr v-if="post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null">
                                                  <td>Reposts</td>
                                                  <td>{{ post.inputtedInsights.reposts }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights && !isTwitterReport(post) && !isLinkedInReport(post)">
                                                  <td>Views</td>
                                                  <td>{{ post.inputtedInsights.views }}</td>
                                                </tr>
                                              </tbody>
                                            </template>
                                          </v-simple-table>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <v-expansion-panel v-if="post.graphInsight">
                                        <v-expansion-panel-header>
                                          Graph Insights
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-simple-table dark dense>
                                            <template v-slot:default>
                                              <tbody>
                                                <tr>
                                                  <td>Engagement</td>
                                                  <td>{{ post.graphInsight.engagement }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Impressions</td>
                                                  <td>{{ post.graphInsight.impressions }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Reach</td>
                                                  <td>{{ post.graphInsight.reach }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Saved</td>
                                                  <td>{{ post.graphInsight.saved }}</td>
                                                </tr>
                                              </tbody>
                                            </template>
                                          </v-simple-table>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <!-- <v-expansion-panel v-if="post.inputtedInsights">
                                        <v-expansion-panel-header>
                                          Inputted Insights
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-simple-table dark dense>
                                            <template v-slot:default>
                                              <tbody>
                                                <tr>
                                                  <td>Bookmarks</td>
                                                  <td>{{ post.inputtedInsights.saved }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Shares</td>
                                                  <td>{{ post.inputtedInsights.shares }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Views</td>
                                                  <td>{{ post.inputtedInsights.views }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Reach</td>
                                                  <td>{{ post.inputtedInsights.reach }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Impressions</td>
                                                  <td>{{ post.inputtedInsights.impressions }}</td>
                                                </tr>
                                              </tbody>
                                            </template>
                                          </v-simple-table>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel> -->
                                      <v-btn
                                        block
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="updatePostInsightsHandler(post)"
                                      >
                                        Update Insights
                                        <v-icon right>mdi-pencil</v-icon>
                                      </v-btn>
                                      <v-btn
                                        block
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="scrapComments(post.post_details.link, post.id)"
                                      >
                                        Extract Comments
                                        <v-icon right>mdi-refresh</v-icon>
                                      </v-btn>
                                    </v-expansion-panels>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-btn small color="red" @click="removeContent(post.id)">
                                      Remove
                                      <v-icon right>mdi-delete</v-icon>
                                    </v-btn>
                                    <v-btn
                                      small
                                      color="secondary"
                                      :href="post.post_details.link"
                                      :target="'_blank'"
                                    >
                                      View on IG
                                      <v-icon right>mdi-instagram</v-icon>
                                    </v-btn>
                                  </v-card-actions>
                              </v-card>
                              <v-card
                                  v-else-if="post.isOthers || isLinkedInReport(post) || isTwitterReport(post)"
                                  class="mx-auto campaign-post"
                                  color="#62727b"
                                  dark
                                  :max-width="isTwitterReport(post) ? 420 : 300"
                                  :elevation="hover ? 12 : 2"
                                  :class="{ 'on-hover': hover, 'linkedin-campaign-post': isLinkedInReport(post), 'twitter-campaign-post': isTwitterReport(post) }"
                                >
                                  <v-card-title class="campaign-post-header">
                                    <v-list-item class="grow pa-0 campaign-post-header-row">
                                      <v-list-item-avatar color="grey darken-3">
                                        <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                                      </v-list-item-avatar>

                                      <v-list-item-content class="campaign-post-owner-content">
                                        <v-list-item-title class="campaign-post-owner-title">
                                          <a class="caption campaign-post-owner-handle" :title="`@${post.owner.username}`" :href="getAccountProfileUrl(post)" target="_blank" rel="noopener noreferrer"
                                            >@{{ post.owner.username }}</a
                                          >
                                        </v-list-item-title>
                                      </v-list-item-content>
                                      <!-- <v-list-item-action v-if="post.payout_details">${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                                      <v-list-item-action class="campaign-post-type-action">
                                        <v-chip
                                          color="primary"
                                          v-if="post.type"
                                          small
                                        >
                                          {{post.type}}
                                        </v-chip>
                                      </v-list-item-action>
                                    </v-list-item>
                                  </v-card-title>

                                  <v-card-text class="headline font-weight-bold" :class="{ 'twitter-embed-card-text': isTwitterReport(post) }">
                                    <iframe
                                      v-if="isLinkedInReport(post) && getLinkedInEmbedUrl(post)"
                                      class="linkedin-post-embed"
                                      :src="getLinkedInEmbedUrl(post)"
                                      :title="`LinkedIn post by ${post.owner.username}`"
                                      width="100%"
                                      height="300"
                                      frameborder="0"
                                      allowfullscreen
                                    ></iframe>
                                    <div v-else-if="isTwitterReport(post) && getTwitterEmbedUrl(post)" class="twitter-embed-shell">
                                      <iframe
                                        class="twitter-post-embed"
                                        :src="getTwitterEmbedUrl(post)"
                                        :title="`X post by ${post.owner.username}`"
                                        frameborder="0"
                                        allowfullscreen
                                      ></iframe>
                                    </div>
                                    <!-- <img
                                      width="100%"
                                      class="elevation-0"
                                      :src="post.media_url ? post.media_url : post.post_details.image"
                                    /> -->
                                    <div class="igPost-block" style="max-width:350px;" v-if="post.media_url">
                                      <!-- <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                                        <iframe :src="post.media_url" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                                      </div> -->
                                      <custom-media
                                        :className="getMedia(post).className"
                                        :type="getMedia(post).type"
                                        :publicID="getMedia(post).publicID"
                                        :videoID="getMedia(post).videoID"
                                        :URL="getMedia(post).URL"
                                        :width="getMedia(post).width"
                                        :height="getMedia(post).height"
                                        :trans="getMedia(post).trans"
                                        v-if="MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id"
                                      />
                                      <img
                                        width="100%"
                                        class="elevation-0"
                                        v-else-if="post.media_type == 'IMAGE' || MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url"
                                        :src="post.media_type == 'IMAGE' || MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url"
                                      />
                                      <video width="100%" controls v-else-if="post.media_url && MEDIA_URL_TYPE(post.media_url) === 'video'">
                                        <source :src="post.media_url" type="video/mp4">
                                        Your browser does not support HTML5 video.
                                      </video>
                                      <gDrive-post-view :url="post.media_url" v-else-if="MEDIA_URL_TYPE(post.media_url) === 'driveView'" />
                                      <iframe class="media-iframe" width="100%" height="100%" :src="post.media_url" v-if="MEDIA_URL_TYPE(post.media_url) === 'iframe'" scrolling="no" seamless="" allowFullScreen></iframe>
                                    </div>
                                  </v-card-text>

                                  <v-card-text>
                                    <div class="text-center">
                                      <v-chip
                                      dark
                                      label
                                      class="subheading ma-1">
                                        <span>IMS Status:&nbsp;</span>
                                        <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                                      </v-chip>
                                    </div>
                                    <v-expansion-panels>
                                      <v-expansion-panel v-if="post.currentInsight">
                                        <v-expansion-panel-header>
                                          Post Insights
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-simple-table dark dense v-if="post.currentInsight">
                                            <template v-slot:default>
                                              <tbody>
                            <tr v-if="post.inputtedInsights && !isTwitterReport(post) && (!isLinkedInReport(post) || post.inputtedInsights.reach != null)">
                              <td>{{ isLinkedInReport(post) ? 'Members reached' : 'Reach' }}</td>
                              <td>{{ post.inputtedInsights.reach }}</td>
                            </tr>
                            <tr v-if="post.currentInsight.views && !isTwitterReport(post) && !isLinkedInReport(post)">
                              <td>Plays (Views)</td>
                              <td>{{ post.currentInsight.views }}</td>
                            </tr>
                            <tr v-if="post.inputtedInsights && (!isTwitterReport(post) && !isLinkedInReport(post) || post.inputtedInsights.impressions != null)">
                              <td>Impressions</td>
                              <td>{{ post.inputtedInsights.impressions }}</td>
                            </tr>
                            <tr v-if="isLinkedInReport(post) && post.inputtedInsights">
                              <td>Video views</td>
                              <td>{{ post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-' }}</td>
                            </tr>
                            <tr v-if="isLinkedInReport(post) && post.inputtedInsights">
                              <td>Profile viewers from this post</td>
                              <td>{{ post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-' }}</td>
                            </tr>
                            <tr>
                              <td>{{ isLinkedInReport(post) ? 'Reactions' : 'Likes' }}</td>
                              <td>{{ post.currentInsight.like_count }}</td>
                            </tr>
                            <tr>
                              <td>{{ isTwitterReport(post) ? 'Replies' : 'Comments' }}</td>
                              <td>{{ post.currentInsight.comment_count }}</td>
                            </tr>
                            <tr v-if="post.inputtedInsights">
                              <td>{{ isLinkedInReport(post) ? 'Saves' : (isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)') }}</td>
                              <td>{{ post.inputtedInsights.saved }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights && post.inputtedInsights.plays">
                                                  <td>Watch Time</td>
                                                  <td>{{ post.inputtedInsights.plays }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights && post.inputtedInsights.watches">
                                                  <td>Average Watch Time</td>
                                                  <td>{{ post.inputtedInsights.watches }}</td>
                                                </tr>
                            <tr v-if="post.inputtedInsights">
                              <td>{{ isLinkedInReport(post) || isTwitterReport(post) ? 'Reposts' : 'Shares' }}</td>
                              <td>{{ post.inputtedInsights.shares }}</td>
                            </tr>
                            <tr v-if="post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null">
                              <td>Reposts</td>
                              <td>{{ post.inputtedInsights.reposts }}</td>
                            </tr>
                            <tr v-if="post.inputtedInsights && !isTwitterReport(post) && !isLinkedInReport(post)">
                              <td>Views</td>
                                                  <td>{{ post.inputtedInsights.views }}</td>
                                                </tr>
                                              </tbody>
                                            </template>
                                          </v-simple-table>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <v-expansion-panel v-if="post.graphInsight">
                                        <v-expansion-panel-header>
                                          Graph Insights
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-simple-table dark dense>
                                            <template v-slot:default>
                                              <tbody>
                                                <tr>
                                                  <td>Engagement</td>
                                                  <td>{{ post.graphInsight.engagement }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Impressions</td>
                                                  <td>{{ post.graphInsight.impressions }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Reach</td>
                                                  <td>{{ post.graphInsight.reach }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Saved</td>
                                                  <td>{{ post.graphInsight.saved }}</td>
                                                </tr>
                                              </tbody>
                                            </template>
                                          </v-simple-table>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <!-- <v-expansion-panel v-if="post.inputtedInsights">
                                        <v-expansion-panel-header>
                                          Inputted Insights
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-simple-table dark dense>
                                            <template v-slot:default>
                                              <tbody>
                                                <tr>
                                                  <td>Bookmarks</td>
                                                  <td>{{ post.inputtedInsights.saved }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Shares</td>
                                                  <td>{{ post.inputtedInsights.shares }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Views</td>
                                                  <td>{{ post.inputtedInsights.views }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Reach</td>
                                                  <td>{{ post.inputtedInsights.reach }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Impressions</td>
                                                  <td>{{ post.inputtedInsights.impressions }}</td>
                                                </tr>
                                              </tbody>
                                            </template>
                                          </v-simple-table>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel> -->
                                      <v-btn
                                        block
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="updatePostInsightsHandler(post)"
                                      >
                                        Update Insights
                                        <v-icon right>mdi-pencil</v-icon>
                                      </v-btn>
                                    </v-expansion-panels>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-btn small color="red" @click="removeContent(post.id)">
                                      Remove
                                      <v-icon right>mdi-delete</v-icon>
                                    </v-btn>
                                    <v-btn
                                      small
                                      color="secondary"
                                      :href="post.post_details.link"
                                      :target="'_blank'"
                                    >
                                      {{ isLinkedInReport(post) ? 'View on LinkedIn' : (isTwitterReport(post) ? 'View on X' : 'View') }}
                                      <v-icon v-if="isLinkedInReport(post)" right>mdi-linkedin</v-icon>
                                      <img v-else-if="isTwitterReport(post)" src="/static/img/x-logo.svg" width="18px" class="ml-2" style="filter: invert(1);" alt="" aria-hidden="true" />
                                      <v-icon v-else right>mdi-open-in-new</v-icon>
                                    </v-btn>
                                  </v-card-actions>
                              </v-card>
                              <v-card
                                v-else-if="post.isStory"
                                class="mx-auto campaign-post"
                                color="#62727b"
                                dark
                                max-width="300"
                                :elevation="hover ? 12 : 2"
                                :class="{ 'on-hover': hover }"
                              >
<v-card-title class="campaign-post-header">
                                  <v-list-item class="grow pa-0 campaign-post-header-row">
                                    <v-list-item-avatar color="grey darken-3">
                                      <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        <a class="caption" :href="getAccountProfileUrl(post)" target="_blank"
                                          >@{{ post.profileHandle || post.profile_handle || post.owner.username }}</a
                                        >
                                        <!-- <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(post)">edit</v-icon> -->
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                                    <v-list-item-action>
                                        <v-chip
                                          color="primary"
                                          v-if="post.type"
                                          small
                                        >
                                          {{post.type}}
                                        </v-chip>
                                      </v-list-item-action>
                                  </v-list-item>
                                </v-card-title>
                                <v-card-text class="headline font-weight-bold" v-if="post.media_url">
                                  <custom-media
                                    :className="getMedia(post).className"
                                    :type="getMedia(post).type"
                                    :publicID="getMedia(post).publicID"
                                    :videoID="getMedia(post).videoID"
                                    :URL="getMedia(post).URL"
                                    :width="getMedia(post).width"
                                    :height="getMedia(post).height"
                                    :trans="getMedia(post).trans"
                                    v-if="MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id"
                                  />
                                  <img
                                    width="100%"
                                    class="elevation-0"
                                    v-else-if="post.media_type == 'IMAGE' || MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url"
                                    :src="post.media_type == 'IMAGE' || MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url"
                                  />
                                  <video width="100%" controls v-else-if="post.media_url && MEDIA_URL_TYPE(post.media_url) === 'video'">
                                    <source :src="post.media_url" type="video/mp4">
                                    Your browser does not support HTML5 video.
                                  </video>
                                  <gDrive-post-view :url="post.media_url" v-else-if="MEDIA_URL_TYPE(post.media_url) === 'driveView'" />
                                  <iframe class="media-iframe" width="100%" height="100%" :src="post.media_url" v-if="MEDIA_URL_TYPE(post.media_url) === 'iframe'" scrolling="no" seamless="" allowFullScreen></iframe>
                                </v-card-text>
                                <v-card-text class="headline font-weight-bold" v-else>
                                  <div>
                                    <v-alert width="100%">
                                      Media type unsupported!
                                    </v-alert>
                                  </div>
                                </v-card-text>
                                <v-card-text v-if="post.insights">
                                  <div class="text-center">
                                    <v-chip
                                    dark
                                    label
                                    class="subheading ma-1">
                                      <span>IMS Status:&nbsp;</span>
                                      <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                                    </v-chip>
                                  </div>
                                  <v-expansion-panels>
                                    <v-expansion-panel>
                                      <v-expansion-panel-header>
                                        Story Insights
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <v-simple-table dark dense>
                                          <template v-slot:default>
                                            <tbody>
                                              <tr>
                                                <td>Accounts Reached</td>
                                                <td>{{ post.insights.reach }}</td>
                                              </tr>
                                              <tr>
                                                <td>Impressions</td>
                                                <td>{{ post.insights.impressions }}</td>
                                              </tr>
                                              <tr>
                                                <td>Replies</td>
                                                <td>{{ post.insights.replies }}</td>
                                              </tr>
                                              <!-- <tr>
                                                <td>Exits</td>
                                                <td>{{ post.insights.exits }}</td>
                                              </tr>
                                              <tr>
                                                <td>Taps Back</td>
                                                <td>{{ post.insights.taps_back }}</td>
                                              </tr>
                                              <tr>
                                                <td>Taps Forward</td>
                                                <td>{{ post.insights.taps_forward }}</td>
                                              </tr> -->
                                              <tr>
                                                <td>Shares</td>
                                                <td>{{ post.insights.shares }}</td>
                                              </tr>
                                              <tr>
                                                <td>Link Clicks</td>
                                                <td>{{ post.insights.link_clicks }}</td>
                                              </tr>
                                              <tr>
                                                <td>Sticker Taps</td>
                                                <td>{{ post.insights.sticker_taps }}</td>
                                              </tr>
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-btn
                                    block
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="updatePostInsightsHandler(post)"
                                  >
                                    Update Insights
                                    <v-icon right>mdi-pencil</v-icon>
                                  </v-btn>
                                  </v-expansion-panels>
                                </v-card-text>
                                <v-card-actions>
                                  <v-btn small color="red" @click="removeContent(post.id)">
                                    Remove
                                    <v-icon right>mdi-delete</v-icon>
                                  </v-btn>
                                  <v-btn
                                    v-if="post.media_url"
                                    small
                                    color="secondary"
                                    :href="post.media_url"
                                    :target="'_blank'"
                                  >
                                    View Story Media
                                    <v-icon right>mdi-clipboard-play</v-icon>
                                  </v-btn>
                                </v-card-actions>
                              </v-card>


                              <v-card
                                  v-else-if="post.isTikTok"
                                  class="mx-auto campaign-post"
                                  color="#62727b"
                                  dark
                                  max-width="300"
                                  :elevation="hover ? 12 : 2"
                                  :class="{ 'on-hover': hover }"
                                >
                                  <v-card-title>
                                    <v-list-item class="grow pa-0">
                                      <v-list-item-avatar color="grey darken-3">
                                        <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                                      </v-list-item-avatar>
                                      <v-list-item-content>
                                        <v-list-item-title>
                                          <a class="caption" :href="getAccountProfileUrl(post)" target="_blank" rel="noopener noreferrer"
                                            >@{{ post.owner.username }}</a
                                          >
                                        </v-list-item-title>
                                      </v-list-item-content>
                                      <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                                      <v-list-item-action>
                                        <v-chip
                                          color="primary"
                                          v-if="post.type"
                                          small
                                        >
                                          {{post.type}}
                                        </v-chip>
                                      </v-list-item-action>
                                    </v-list-item>
                                  </v-card-title>

                                  <v-card-text class="headline font-weight-bold">
                                    <!-- <img
                                      width="100%"
                                      class="elevation-0"
                                      :src="post.media_url ? post.media_url : post.post_details.image"
                                    /> -->
                                    <div class="igPost-block" style="max-width:350px;" v-if="post.tikTokPost">
                                      <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                                        <iframe :src="post.tikTokPost" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                                      </div>
                                    </div>
                                  </v-card-text>

                                  <v-card-text>
                                    <div class="text-center">
                                      <v-chip
                                      dark
                                      label
                                      class="subheading ma-1">
                                        <span>IMS Status:&nbsp;</span>
                                        <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                                      </v-chip>
                                    </div>
                                    <v-expansion-panels>
                                      <v-expansion-panel>
                                        <v-expansion-panel-header>
                                          Post Insights
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-simple-table dark dense v-if="post.currentInsight">
                                            <template v-slot:default>
                                              <tbody>
                                                <tr v-if="post.inputtedInsights && post.inputtedInsights.plays">
                                                  <td>Total Play Time</td>
                                                  <td>{{ post.inputtedInsights.plays }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights && post.inputtedInsights.watches">
                                                  <td>Average Watch Time</td>
                                                  <td>{{ post.inputtedInsights.watches }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Likes</td>
                                                  <td>{{ post.currentInsight.like_count }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Comments</td>
                                                  <td>{{ post.currentInsight.comment_count }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights">
                                                  <td>Shares</td>
                                                  <td>{{ post.inputtedInsights.shares }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights">
                                                  <td>Favourites (Bookmarks)</td>
                                                  <td>{{ post.inputtedInsights.saved }}</td>
                                                </tr>
                                                <tr v-if="post.currentInsight.views">
                                                  <td>Plays (Views)</td>
                                                  <td>{{ post.currentInsight.views }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights">
                                                  <td>Reach</td>
                                                  <td>{{ post.inputtedInsights.reach }}</td>
                                                </tr>
                                                <tr v-if="post.inputtedInsights">
                                                  <td>Watched Full Video</td>
                                                  <td>{{ post.inputtedInsights.watchedFullVideo }}</td>
                                                </tr>
                                              </tbody>
                                            </template>
                                          </v-simple-table>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <v-expansion-panel v-if="post.graphInsight">
                                        <v-expansion-panel-header>
                                          Graph Insights
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-simple-table dark dense>
                                            <template v-slot:default>
                                              <tbody>
                                                <tr>
                                                  <td>Engagement</td>
                                                  <td>{{ post.graphInsight.engagement }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Impressions</td>
                                                  <td>{{ post.graphInsight.impressions }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Reach</td>
                                                  <td>{{ post.graphInsight.reach }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Saved</td>
                                                  <td>{{ post.graphInsight.saved }}</td>
                                                </tr>
                                              </tbody>
                                            </template>
                                          </v-simple-table>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                      <!-- <v-expansion-panel v-if="post.inputtedInsights">
                                        <v-expansion-panel-header>
                                          Inputted Insights
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <v-simple-table dark dense>
                                            <template v-slot:default>
                                              <tbody>
                                                <tr>
                                                  <td>Bookmarks</td>
                                                  <td>{{ post.inputtedInsights.saved }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Shares</td>
                                                  <td>{{ post.inputtedInsights.shares }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Views</td>
                                                  <td>{{ post.inputtedInsights.views }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Reach</td>
                                                  <td>{{ post.inputtedInsights.reach }}</td>
                                                </tr>
                                                <tr>
                                                  <td>Impressions</td>
                                                  <td>{{ post.inputtedInsights.impressions }}</td>
                                                </tr>
                                              </tbody>
                                            </template>
                                          </v-simple-table>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel> -->
                                      <v-btn
                                        block
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="updatePostInsightsHandler(post)"
                                      >
                                        Update Insights
                                        <v-icon right>mdi-pencil</v-icon>
                                      </v-btn>
                                      <v-btn
                                        block
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="scrapComments(post.post_details.link, post.id)"
                                      >
                                        Extract Comments
                                        <v-icon right>mdi-refresh</v-icon>
                                      </v-btn>
                                      <v-btn
                                        block
                                        v-bind="attrs"
                                        v-on="on"
                                        color="blue-grey"
                                        :disabled="!post.comments || post.comments.length === 0"
                                        @click="openCommentsDialog(post)"
                                      >
                                        View Comments ({{ post.comments ? post.comments.length : 0 }})
                                        <v-icon right>mdi-comment-text-multiple</v-icon>
                                      </v-btn>
                                    </v-expansion-panels>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-btn small color="red" @click="removeContent(post.id)">
                                      Remove
                                      <v-icon right>mdi-delete</v-icon>
                                    </v-btn>
                                    <v-btn
                                      small
                                      color="secondary"
                                      :href="post.post_details.link"
                                      :target="'_blank'"
                                    >
                                      View on TikTok&nbsp;<img src='/static/img/tik-tok-white.png' width="18px" />
                                    </v-btn>
                                  </v-card-actions>
                              </v-card>

                              <!-- Facebook Post -->
                              <v-card
                                v-else-if="post.isFacebook"
                                class="mx-auto campaign-post"
                                color="#62727b"
                                dark
                                max-width="300"
                                :elevation="hover ? 12 : 2"
                                :class="{ 'on-hover': hover }"
                              >
                                <v-card-title class="campaign-post-header">
                                  <v-list-item class="grow pa-0 campaign-post-header-row">
                                    <v-list-item-avatar color="grey darken-3">
                                      <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content class="campaign-post-owner-content">
                                      <v-list-item-title class="campaign-post-owner-title">
                                        <a class="caption campaign-post-owner-handle" :title="`@${post.owner.username}`" :href="'https://www.facebook.com/' + post.owner.username" target="_blank"
                                          >@{{ post.owner.username }}</a
                                        >
                                        <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(post)">edit</v-icon>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                                    <v-list-item-action class="campaign-post-type-action">
                                      <v-chip
                                        color="primary"
                                        v-if="post.type"
                                        small
                                      >
                                        {{post.type}}
                                      </v-chip>
                                    </v-list-item-action>
                                  </v-list-item>
                                </v-card-title>

                                <v-card-text class="headline font-weight-bold">
                                  <!-- <img
                                    width="100%"
                                    class="elevation-0"
                                    :src="post.media_url ? post.media_url : post.post_details.image"
                                  /> -->
                                  <div class="igPost-block" style="max-width:350px;" v-if="post.media_url">
                                    <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                                      <iframe :src="getFbPost(post.media_url)" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                                    </div>
                                  </div>
                                </v-card-text>

                                <v-card-text>
                                  <div class="text-center">
                                    <v-chip
                                    dark
                                    label
                                    class="subheading ma-1">
                                      <span>IMS Status:&nbsp;</span>
                                      <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                                    </v-chip>
                                  </div>
                                  <v-expansion-panels>
                                    <v-expansion-panel v-if="post.insights">
                                      <v-expansion-panel-header>
                                        Post Insights
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <v-simple-table dark dense>
                                          <template v-slot:default>
                                            <tbody>
                                              <tr>
                                                <td>Outreach</td>
                                                <td>{{ post.insights.outreach }}</td>
                                              </tr>
                                              <tr>
                                                <td>Likes</td>
                                                <td>{{ post.insights.like_count }}</td>
                                              </tr>
                                              <tr>
                                                <td>Comments</td>
                                                <td>{{ post.insights.comment_count }}</td>
                                              </tr>
                                              <tr>
                                                <td>Views</td>
                                                <td>{{ post.insights.views }}</td>
                                              </tr>
                                              <tr>
                                                <td>Shares</td>
                                                <td>{{ post.insights.shares }}</td>
                                              </tr>
                                              <tr>
                                                <td>Bookmarks</td>
                                                <td>{{ post.insights.bookmarks }}</td>
                                              </tr>
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-btn
                                      block
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="updatePostInsightsHandler(post)"
                                    >
                                      Update Insights
                                      <v-icon right>mdi-pencil</v-icon>
                                    </v-btn>
                                  </v-expansion-panels>
                                </v-card-text>

                                <v-card-actions>
                                  <v-btn small color="red" @click="removeContent(post.id)">
                                    Remove
                                    <v-icon right>mdi-delete</v-icon>
                                  </v-btn>
                                  <v-btn
                                    small
                                    color="secondary"
                                    :href="post.media_url"
                                    :target="'_blank'"
                                  >
                                    View on Facebook
                                  </v-btn>
                                </v-card-actions>
                              </v-card>

                              <!-- XHS Post -->
                              <v-card
                                v-else-if="post.isXHS"
                                class="mx-auto campaign-post"
                                color="#62727b"
                                dark
                                max-width="300"
                                :elevation="hover ? 12 : 2"
                                :class="{ 'on-hover': hover }"
                              >
                                <v-card-title>
                                  <v-list-item class="grow pa-0">
                                    <v-list-item-avatar color="grey darken-3">
                                      <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        <a class="caption" :href="'https://www.xiaohongshu.com/user/profile/' + post.owner.xhsID" target="_blank"
                                          >@{{ post.owner.fullName || post.owner.username }}</a
                                        >
                                        <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(item)">edit</v-icon>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                                    <v-list-item-action>
                                      <v-chip
                                        color="primary"
                                        v-if="post.type"
                                        small
                                      >
                                        {{post.type}}
                                      </v-chip>
                                    </v-list-item-action>
                                  </v-list-item>
                                </v-card-title>

                                <v-card-text class="headline font-weight-bold">
                                  <!-- <img
                                    width="100%"
                                    class="elevation-0"
                                    :src="post.media_url ? post.media_url : post.post_details.image"
                                  /> -->
                                  <div class="igPost-block" style="max-width:350px;" v-if="post.embed_url">
                                    <custom-media
                                      :type="getMedia(post).type"
                                      :publicID="getMedia(post).publicID"
                                      :videoID="getMedia(post).videoID"
                                      :URL="getMedia(post).URL"
                                      :width="getMedia(post).width"
                                      :height="getMedia(post).height"
                                      :trans="getMedia(post).trans"
                                    />
                                    <!-- <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                                      <iframe :src="post.media_url" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                                    </div> -->
                                  </div>
                                </v-card-text>

                                <v-card-text>
                                  <div class="text-center">
                                    <v-chip
                                    dark
                                    label
                                    class="subheading ma-1">
                                      <span>IMS Status:&nbsp;</span>
                                      <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                                    </v-chip>
                                  </div>
                                  <v-expansion-panels>
                                    <v-expansion-panel v-if="post.insights">
                                      <v-expansion-panel-header>
                                        Post Insights
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <v-simple-table dark dense>
                                          <template v-slot:default>
                                            <tbody>
                                              <tr>
                                                <td>Outreach</td>
                                                <td>{{ post.insights.outreach }}</td>
                                              </tr>
                                              <tr>
                                                <td>Likes</td>
                                                <td>{{ post.insights.like_count }}</td>
                                              </tr>
                                              <tr>
                                                <td>Comments</td>
                                                <td>{{ post.insights.comment_count }}</td>
                                              </tr>
                                              <tr>
                                                <td>Views</td>
                                                <td>{{ post.insights.views }}</td>
                                              </tr>
                                              <tr>
                                                <td>Shares</td>
                                                <td>{{ post.insights.shares }}</td>
                                              </tr>
                                              <tr>
                                                <td>Bookmarks</td>
                                                <td>{{ post.insights.bookmarks }}</td>
                                              </tr>
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-btn
                                      block
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="updatePostInsightsHandler(post)"
                                    >
                                      Update Insights
                                      <v-icon right>mdi-pencil</v-icon>
                                    </v-btn>
                                  </v-expansion-panels>
                                </v-card-text>

                                <v-card-actions>
                                  <v-btn small color="red" @click="removeContent(post.id)">
                                    Remove
                                    <v-icon right>mdi-delete</v-icon>
                                  </v-btn>
                                  <v-btn
                                    small
                                    color="secondary"
                                    :href="post.media_url"
                                    :target="'_blank'"
                                  >
                                    View on XHS
                                  </v-btn>
                                </v-card-actions>
                              </v-card>

                              <!-- Lemon8 Post -->
                              <v-card
                                v-else-if="post.isLemon"
                                class="mx-auto campaign-post"
                                color="#62727b"
                                dark
                                max-width="300"
                                :elevation="hover ? 12 : 2"
                                :class="{ 'on-hover': hover }"
                              >
                                <v-card-title>
                                  <v-list-item class="grow pa-0">
                                    <v-list-item-avatar color="grey darken-3">
                                      <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        <a class="caption"
                                          href=""
                                          >@{{ post.owner.fullName || post.owner.username }}</a
                                        >
                                        <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(item)">edit</v-icon>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                                    <v-list-item-action>
                                      <v-chip
                                        color="primary"
                                        v-if="post.type"
                                        small
                                      >
                                        {{post.type}}
                                      </v-chip>
                                    </v-list-item-action>
                                  </v-list-item>
                                </v-card-title>

                                <v-card-text class="headline font-weight-bold">
                                  <!-- <img
                                    width="100%"
                                    class="elevation-0"
                                    :src="post.media_url ? post.media_url : post.post_details.image"
                                  /> -->
                                  <div class="igPost-block" style="max-width:350px;" v-if="post.embed_url">
                                    <custom-media
                                      :type="getMedia(post).type"
                                      :publicID="getMedia(post).publicID"
                                      :videoID="getMedia(post).videoID"
                                      :URL="getMedia(post).URL"
                                      :width="getMedia(post).width"
                                      :height="getMedia(post).height"
                                      :trans="getMedia(post).trans"
                                    />
                                    <!-- <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                                      <iframe :src="post.media_url" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                                    </div> -->
                                  </div>
                                </v-card-text>

                                <v-card-text>
                                  <div class="text-center">
                                    <v-chip
                                    dark
                                    label
                                    class="subheading ma-1">
                                      <span>IMS Status:&nbsp;</span>
                                      <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                                    </v-chip>
                                  </div>
                                  <v-expansion-panels>
                                    <v-expansion-panel v-if="post.insights">
                                      <v-expansion-panel-header>
                                        Post Insights
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <v-simple-table dark dense>
                                          <template v-slot:default>
                                            <tbody>
                                              <tr>
                                                <td>Outreach</td>
                                                <td>{{ post.insights.outreach }}</td>
                                              </tr>
                                              <tr>
                                                <td>Likes</td>
                                                <td>{{ post.insights.like_count }}</td>
                                              </tr>
                                              <tr>
                                                <td>Comments</td>
                                                <td>{{ post.insights.comment_count }}</td>
                                              </tr>
                                              <tr>
                                                <td>Views</td>
                                                <td>{{ post.insights.views }}</td>
                                              </tr>
                                              <tr>
                                                <td>Shares</td>
                                                <td>{{ post.insights.shares }}</td>
                                              </tr>
                                              <tr>
                                                <td>Bookmarks</td>
                                                <td>{{ post.insights.bookmarks }}</td>
                                              </tr>
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-btn
                                      block
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="updatePostInsightsHandler(post)"
                                    >
                                      Update Insights
                                      <v-icon right>mdi-pencil</v-icon>
                                    </v-btn>
                                  </v-expansion-panels>
                                </v-card-text>

                                <v-card-actions>
                                  <v-btn small color="red" @click="removeContent(post.id)">
                                    Remove
                                    <v-icon right>mdi-delete</v-icon>
                                  </v-btn>
                                  <v-btn
                                    small
                                    color="secondary"
                                    :href="post.media_url"
                                    :target="'_blank'"
                                  >
                                    View on Lemon8
                                  </v-btn>
                                </v-card-actions>
                              </v-card>

                              <!-- Youtube Post -->
                              <v-card
                                v-else-if="post.isYoutube"
                                class="mx-auto campaign-post"
                                color="#62727b"
                                dark
                                max-width="300"
                                :elevation="hover ? 12 : 2"
                                :class="{ 'on-hover': hover }"
                              >
                                <v-card-title>
                                  <v-list-item class="grow pa-0">
                                    <v-list-item-avatar color="grey darken-3">
                                      <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content class="campaign-post-owner-content">
                                      <v-list-item-title class="campaign-post-owner-title">
                                        <a class="caption campaign-post-owner-handle" :title="`@${post.owner.username}`" :href="'https://www.youtube.com/' + post.owner.username" target="_blank"
                                          >@{{ post.owner.username }}</a
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                                    <v-list-item-action class="campaign-post-type-action">
                                      <v-chip
                                        class="campaign-post-type-chip"
                                        color="primary"
                                        v-if="post.type"
                                        small
                                      >
                                        <span class="campaign-post-type-title" :title="post.type">{{post.type}}</span>
                                      </v-chip>
                                    </v-list-item-action>
                                  </v-list-item>
                                </v-card-title>

                                <v-card-text class="headline font-weight-bold">
                                  <!-- <img
                                    width="100%"
                                    class="elevation-0"
                                    :src="post.media_url ? post.media_url : post.post_details.image"
                                  /> -->
                                  <div class="igPost-block" style="max-width:350px;" v-if="post.youtubePost">
                                    <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                                      <iframe :src="post.youtubePost" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                                    </div>
                                  </div>
                                </v-card-text>

                                <v-card-text>
                                  <div class="text-center">
                                    <v-chip
                                    dark
                                    label
                                    class="subheading ma-1">
                                      <span>IMS Status:&nbsp;</span>
                                      <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                                    </v-chip>
                                  </div>
                                  <v-expansion-panels>
                                    <v-expansion-panel v-if="post.currentInsight">
                                      <v-expansion-panel-header>
                                        Post Insights
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <v-simple-table dark dense>
                                          <template v-slot:default>
                                            <tbody>
                                              <tr>
                                                <td>Engagement</td>
                                                <td>{{ post.currentInsight.engagement }}</td>
                                              </tr>
                                              <tr>
                                                <td>Likes</td>
                                                <td>{{ post.currentInsight.like_count }}</td>
                                              </tr>
                                              <tr>
                                                <td>Comments</td>
                                                <td>{{ post.currentInsight.comment_count }}</td>
                                              </tr>
                                              <tr v-if="post.inputtedInsights && post.inputtedInsights.impressions != null">
                                                <td>Impressions</td>
                                                <td>{{ post.inputtedInsights.impressions }}</td>
                                              </tr>
                                              <tr v-if="post.inputtedInsights && post.inputtedInsights.unique_viewers != null">
                                                <td>Unique Viewers</td>
                                                <td>{{ post.inputtedInsights.unique_viewers }}</td>
                                              </tr>
                                              <tr v-if="post.inputtedInsights && post.inputtedInsights.watches != null">
                                                <td>Average Watch Time</td>
                                                <td>{{ post.inputtedInsights.watches }}</td>
                                              </tr>
                                              <tr>
                                                <td>Outreach</td>
                                                <td>{{ post.currentInsight.outreach }}</td>
                                              </tr>
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-btn
                                      block
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="updatePostInsightsHandler(post)"
                                    >
                                      Update Insights
                                      <v-icon right>mdi-pencil</v-icon>
                                    </v-btn>
                                  </v-expansion-panels>
                                </v-card-text>

                                <v-card-actions>
                                  <v-btn small color="red" @click="removeContent(post.id)">
                                    Remove
                                    <v-icon right>mdi-delete</v-icon>
                                  </v-btn>
                                  <v-btn
                                    small
                                    color="secondary"
                                    :href="post.post_details.link"
                                    :target="'_blank'"
                                  >
                                    View on Youtube&nbsp; <i class="fab fa-youtube"></i>
                                  </v-btn>
                                </v-card-actions>
                              </v-card>

                              <v-card
                                v-else-if="post.isMultipleContents"
                                class="mx-auto campaign-post"
                                color="#62727b"
                                dark
                                max-width="300"
                                :elevation="hover ? 12 : 2"
                                :class="{ 'on-hover': hover }"
                              >
<v-card-title>
                                  <v-list-item class="grow pa-0">
                                    <v-list-item-avatar color="grey darken-3">
                                      <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        <a class="caption" :href="getAccountProfileUrl(post)" target="_blank"
                                          >@{{ post.profileHandle || post.profile_handle || post.owner.username }}</a
                                        >
                                      </v-list-item-title>
                                    </v-list-item-content>
                                    <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                                    <v-list-item-action>
                                      <v-chip
                                        color="primary"
                                        v-if="post.type"
                                        small
                                      >
                                        {{post.type}}
                                      </v-chip>
                                    </v-list-item-action>
                                  </v-list-item>
                                </v-card-title>
                                <v-card-text class="headline font-weight-bold">
                                  <custom-media
                                    :type="getMedia(post).type"
                                    :publicID="getMedia(post).publicID"
                                    :videoID="getMedia(post).videoID"
                                    :URL="getMedia(post).URL"
                                    :width="getMedia(post).width"
                                    :height="getMedia(post).height"
                                    :trans="getMedia(post).trans"
                                  />
                                </v-card-text>
                                <v-card-text v-if="post.insights">
                                  <div class="text-center">
                                    <v-chip
                                    dark
                                    label
                                    class="subheading ma-1">
                                      <span>IMS Status:&nbsp;</span>
                                      <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                                    </v-chip>
                                  </div>
                                  <v-expansion-panels>
                                    <v-expansion-panel>
                                      <v-expansion-panel-header>
                                        Story Insights
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <v-simple-table dark dense>
                                          <template v-slot:default>
                                            <tbody>
                                              <tr>
                                                <td>Impressions</td>
                                                <td>{{ post.insights.impressions }}</td>
                                              </tr>
                                              <tr>
                                                <td>Reach</td>
                                                <td>{{ post.insights.reach }}</td>
                                              </tr>
                                              <tr>
                                                <td>Replies</td>
                                                <td>{{ post.insights.replies }}</td>
                                              </tr>
                                              <tr>
                                                <td>Exits</td>
                                                <td>{{ post.insights.exits }}</td>
                                              </tr>
                                              <tr>
                                                <td>Taps Back</td>
                                                <td>{{ post.insights.taps_back }}</td>
                                              </tr>
                                              <tr>
                                                <td>Taps Forward</td>
                                                <td>{{ post.insights.taps_forward }}</td>
                                              </tr>
                                              <tr>
                                                <td>Shares</td>
                                                <td>{{ post.insights.shares }}</td>
                                              </tr>
                                              <tr>
                                                <td>Link Clicks</td>
                                                <td>{{ post.insights.link_clicks }}</td>
                                              </tr>
                                              <tr>
                                                <td>Sticker Taps</td>
                                                <td>{{ post.insights.sticker_taps }}</td>
                                              </tr>
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-btn
                                    block
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="updatePostInsightsHandler(post)"
                                  >
                                    Update Insights
                                    <v-icon right>mdi-pencil</v-icon>
                                  </v-btn>
                                  </v-expansion-panels>
                                </v-card-text>
                                <v-card-actions class="justify-center">
                                  <v-btn small color="red" @click="removeContent(post.id)">
                                    Remove
                                    <v-icon right>mdi-delete</v-icon>
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                              <v-card
                                v-else
                                class="mx-auto campaign-post"
                                color="#62727b"
                                dark
                                max-width="300"
                                :elevation="hover ? 12 : 2"
                                :class="{ 'on-hover': hover }"
                              >
                                <v-card-title>
                                  <v-icon large left>mdi-instagram</v-icon>
                                  <span class="caption font-weight-light">Anonymous User</span>
                                </v-card-title>
                                <v-card-text class="title font-weight-bold">
                                  Post might be deleted or private. Click
                                  <a target="_blank" :href="`https://instagram.com/p/${post.post_details.shortcode}`">Here</a> for more details.
                                </v-card-text>
                                <v-card-actions>
                                  <v-btn small color="red" @click="removeContent(post.id)">
                                    Remove
                                    <v-icon right>mdi-delete</v-icon>
                                  </v-btn>
                                  <v-btn
                                    small
                                    color="secondary"
                                    :href="post.post_details.link"
                                    :target="'_blank'"
                                  >
                                    View on Instagram
                                    <v-icon right>mdi-instagram</v-icon>
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                          </v-hover>
                    </v-col>
                      </draggable>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            <!-- End of Post Groups Lists -->

            <!-- Start Single Posts List  -->
            <!-- <v-row style="margin-top:10px;margin-bottom:10px;" class="no-gutters" v-else> -->
            <div v-else>
              <v-hover v-slot:default="{ hover }">
                  <v-card
                    v-if="post.success && !isLinkedInReport(post) && !isTwitterReport(post)"
                    class="mx-auto campaign-post"
                    color="#62727b"
                    dark
                    max-width="300"
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover }"
                  >
                      <v-card-title class="campaign-post-header">
                        <v-list-item class="grow pa-0 campaign-post-header-row">
                          <v-list-item-avatar color="grey darken-3">
                            <v-img class="elevation-6" :src="post.post_details.owner.profile_pic_url"></v-img>
                          </v-list-item-avatar>

                          <v-list-item-content class="campaign-post-owner-content">
                            <v-list-item-title class="campaign-post-owner-title">
                              <a class="caption campaign-post-owner-handle" :title="`@${post.profileHandle || post.profile_handle || post.post_details.owner.username}`" :href="getAccountProfileUrl(post)" target="_blank" rel="noopener noreferrer"
                                >@{{ post.profileHandle || post.profile_handle || post.post_details.owner.username }}</a
                              >
                              <!-- <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(post)">edit</v-icon> -->
                            </v-list-item-title>
                          </v-list-item-content>
                          <!-- <v-list-item-action v-if="post.payout_details">${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                          <v-list-item-action class="campaign-post-type-action">
                            <v-chip
                              color="primary"
                              v-if="post.type"
                              small
                            >
                              {{post.type}}
                            </v-chip>
                          </v-list-item-action>
                        </v-list-item>
                      </v-card-title>

                      <v-card-text class="headline font-weight-bold">
                        <!-- <img
                          width="100%"
                          class="elevation-0"
                          :src="post.media_url ? post.media_url : post.post_details.image"
                        /> -->
                        <instagram-post-embed :url="getReportPostUrl(post)" />
                      </v-card-text>

                      <v-card-text>
                        <div class="text-center">
                          <v-chip
                          dark
                          label
                          class="subheading ma-1">
                            <span>IMS Status:&nbsp;</span>
                            <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                          </v-chip>
                        </div>
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              Post Insights
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-simple-table dark dense v-if="post.currentInsight">
                                <template v-slot:default>
                                  <tbody>
                                    <tr v-if="post.inputtedInsights && !isTwitterReport(post) && (!isLinkedInReport(post) || post.inputtedInsights.reach != null)">
                                      <td>{{ isLinkedInReport(post) ? 'Members reached' : 'Reach' }}</td>
                                      <td>{{ post.inputtedInsights.reach }}</td>
                                    </tr>
                                    <tr v-if="post.currentInsight.views && !isTwitterReport(post) && !isLinkedInReport(post)">
                                      <td>Plays (Views)</td>
                                      <td>{{ post.currentInsight.views }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights && (!isTwitterReport(post) && !isLinkedInReport(post) || post.inputtedInsights.impressions != null)">
                                      <td>Impressions</td>
                                      <td>{{ post.inputtedInsights.impressions }}</td>
                                    </tr>
                                    <tr v-if="isLinkedInReport(post) && post.inputtedInsights">
                                      <td>Video views</td>
                                      <td>{{ post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-' }}</td>
                                    </tr>
                                    <tr v-if="isLinkedInReport(post) && post.inputtedInsights">
                                      <td>Profile viewers from this post</td>
                                      <td>{{ post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-' }}</td>
                                    </tr>
                                    <tr>
                                      <td>{{ isLinkedInReport(post) ? 'Reactions' : 'Likes' }}</td>
                                      <td>{{ post.currentInsight.like_count }}</td>
                                    </tr>
                                    <tr>
                                      <td>Comments</td>
                                      <td>{{ post.currentInsight.comment_count }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights">
                                      <td>{{ isLinkedInReport(post) ? 'Saves' : (isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)') }}</td>
                                      <td>{{ post.inputtedInsights.saved }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights && post.inputtedInsights.plays">
                                      <td>Watch Time</td>
                                      <td>{{ post.inputtedInsights.plays }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights && post.inputtedInsights.watches">
                                      <td>Average Watch Time</td>
                                      <td>{{ post.inputtedInsights.watches }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights">
                                      <td>{{ isLinkedInReport(post) || isTwitterReport(post) ? 'Reposts' : 'Shares' }}</td>
                                      <td>{{ post.inputtedInsights.shares }}</td>
                                    </tr>
                                    <tr v-if="post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null">
                                      <td>Reposts</td>
                                      <td>{{ post.inputtedInsights.reposts }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights && !isTwitterReport(post) && !isLinkedInReport(post)">
                                      <td>Views</td>
                                      <td>{{ post.inputtedInsights.views }}</td>
                                    </tr>
                                    <!-- <tr>
                                      <td>Engagement</td>
                                      <td>{{ post.currentInsight.engagement }}</td>
                                    </tr>
                                    <tr>
                                      <td>Outreach</td>
                                      <td>{{ post.currentInsight.outreach }}</td>
                                    </tr> -->
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel v-if="post.graphInsight">
                            <v-expansion-panel-header>
                              Graph Insights
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-simple-table dark dense>
                                <template v-slot:default>
                                  <tbody>
                                    <tr>
                                      <td>Engagement</td>
                                      <td>{{ post.graphInsight.engagement }}</td>
                                    </tr>
                                    <tr>
                                      <td>Impressions</td>
                                      <td>{{ post.graphInsight.impressions }}</td>
                                    </tr>
                                    <tr>
                                      <td>Reach</td>
                                      <td>{{ post.graphInsight.reach }}</td>
                                    </tr>
                                    <tr>
                                      <td>Saved</td>
                                      <td>{{ post.graphInsight.saved }}</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <!-- <v-expansion-panel v-if="post.inputtedInsights">
                            <v-expansion-panel-header>
                              Inputted Insights
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-simple-table dark dense>
                                <template v-slot:default>
                                  <tbody>
                                    <tr>
                                      <td>Bookmarks</td>
                                      <td>{{ post.inputtedInsights.saved }}</td>
                                    </tr>
                                    <tr>
                                      <td>Shares</td>
                                      <td>{{ post.inputtedInsights.shares }}</td>
                                    </tr>
                                    <tr>
                                      <td>Views</td>
                                      <td>{{ post.inputtedInsights.views }}</td>
                                    </tr>
                                    <tr>
                                      <td>Reach</td>
                                      <td>{{ post.inputtedInsights.reach }}</td>
                                    </tr>
                                    <tr>
                                      <td>Impressions</td>
                                      <td>{{ post.inputtedInsights.impressions }}</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel> -->
                          <v-btn
                            block
                            v-bind="attrs"
                            v-on="on"
                            @click="updatePostInsightsHandler(post)"
                          >
                            Update Insights
                            <v-icon right>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            block
                            v-bind="attrs"
                            v-on="on"
                            @click="scrapComments(post.post_details.link, post.id)"
                          >
                            Extract Comments
                            <v-icon right>mdi-refresh</v-icon>
                          </v-btn>
                          <v-btn
                            block
                            v-bind="attrs"
                            v-on="on"
                            color="blue-grey"
                            :disabled="!post.comments || post.comments.length === 0"
                            @click="openCommentsDialog(post)"
                          >
                            View Comments ({{ post.comments ? post.comments.length : 0 }})
                            <v-icon right>mdi-comment-text-multiple</v-icon>
                          </v-btn>
                        </v-expansion-panels>
                      </v-card-text>

                      <v-card-actions>
                        <v-btn small color="red" @click="removeContent(post.id)">
                          Remove
                          <v-icon right>mdi-delete</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          color="secondary"
                          :href="post.post_details.link"
                          :target="'_blank'"
                        >
                          View on IG
                          <v-icon right>mdi-instagram</v-icon>
                        </v-btn>
                      </v-card-actions>
                  </v-card>
                  <v-card
                    v-else-if="post.isOthers || isLinkedInReport(post) || isTwitterReport(post)"
                    class="mx-auto campaign-post"
                    color="#62727b"
                    dark
                    :max-width="isTwitterReport(post) ? 420 : 300"
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover, 'linkedin-campaign-post': isLinkedInReport(post), 'twitter-campaign-post': isTwitterReport(post) }"
                  >
                      <v-card-title class="campaign-post-header">
                        <v-list-item class="grow pa-0 campaign-post-header-row">
                          <v-list-item-avatar color="grey darken-3">
                            <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                          </v-list-item-avatar>

                          <v-list-item-content class="campaign-post-owner-content">
                            <v-list-item-title class="campaign-post-owner-title">
                              <a class="caption campaign-post-owner-handle" :title="`@${post.owner.username}`" :href="getAccountProfileUrl(post)" target="_blank" rel="noopener noreferrer"
                                >@{{ post.owner.username }}</a
                              >
                            </v-list-item-title>
                          </v-list-item-content>
                          <!-- <v-list-item-action v-if="post.payout_details">${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                          <v-list-item-action class="campaign-post-type-action">
                            <v-chip
                              color="primary"
                              v-if="post.type"
                              small
                            >
                              {{post.type}}
                            </v-chip>
                          </v-list-item-action>
                        </v-list-item>
                      </v-card-title>

                      <v-card-text class="headline font-weight-bold" :class="{ 'twitter-embed-card-text': isTwitterReport(post) }">
                        <iframe
                          v-if="isLinkedInReport(post) && getLinkedInEmbedUrl(post)"
                          class="linkedin-post-embed"
                          :src="getLinkedInEmbedUrl(post)"
                          :title="`LinkedIn post by ${post.owner.username}`"
                          width="100%"
                          height="300"
                          frameborder="0"
                          allowfullscreen
                        ></iframe>
                        <div v-else-if="isTwitterReport(post) && getTwitterEmbedUrl(post)" class="twitter-embed-shell">
                          <iframe
                            class="twitter-post-embed"
                            :src="getTwitterEmbedUrl(post)"
                            :title="`X post by ${post.owner.username}`"
                            frameborder="0"
                            allowfullscreen
                          ></iframe>
                        </div>
                        <!-- <img
                          width="100%"
                          class="elevation-0"
                          :src="post.media_url ? post.media_url : post.post_details.image"
                        /> -->
                        <div class="igPost-block" style="max-width:350px;" v-if="post.media_url">
                          <!-- <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                            <iframe :src="post.media_url" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                          </div> -->
                          <custom-media
                            :className="getMedia(post).className"
                            :type="getMedia(post).type"
                            :publicID="getMedia(post).publicID"
                            :videoID="getMedia(post).videoID"
                            :URL="getMedia(post).URL"
                            :width="getMedia(post).width"
                            :height="getMedia(post).height"
                            :trans="getMedia(post).trans"
                            v-if="MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id"
                          />
                          <img
                            width="100%"
                            class="elevation-0"
                            v-else-if="post.media_type == 'IMAGE' || MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url"
                            :src="post.media_type == 'IMAGE' || MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url"
                          />
                          <video width="100%" controls v-else-if="post.media_url && MEDIA_URL_TYPE(post.media_url) === 'video'">
                            <source :src="post.media_url" type="video/mp4">
                            Your browser does not support HTML5 video.
                          </video>
                          <gDrive-post-view :url="post.media_url" v-else-if="MEDIA_URL_TYPE(post.media_url) === 'driveView'" />
                          <iframe class="media-iframe" width="100%" height="100%" :src="post.media_url" v-if="MEDIA_URL_TYPE(post.media_url) === 'iframe'" scrolling="no" seamless="" allowFullScreen></iframe>
                        </div>
                      </v-card-text>

                      <v-card-text>
                        <div class="text-center">
                          <v-chip
                          dark
                          label
                          class="subheading ma-1">
                            <span>IMS Status:&nbsp;</span>
                            <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                          </v-chip>
                        </div>
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              Post Insights
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-simple-table dark dense v-if="post.currentInsight">
                                <template v-slot:default>
                                  <tbody>
                                    <tr v-if="post.inputtedInsights && !isTwitterReport(post) && (!isLinkedInReport(post) || post.inputtedInsights.reach != null)">
                                      <td>{{ isLinkedInReport(post) ? 'Members reached' : 'Reach' }}</td>
                                      <td>{{ post.inputtedInsights.reach }}</td>
                                    </tr>
                                    <tr v-if="post.currentInsight.views && !isTwitterReport(post) && !isLinkedInReport(post)">
                                      <td>Plays (Views)</td>
                                      <td>{{ post.currentInsight.views }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights && (!isTwitterReport(post) && !isLinkedInReport(post) || post.inputtedInsights.impressions != null)">
                                      <td>Impressions</td>
                                      <td>{{ post.inputtedInsights.impressions }}</td>
                                    </tr>
                                    <tr v-if="isLinkedInReport(post) && post.inputtedInsights">
                                      <td>Video views</td>
                                      <td>{{ post.inputtedInsights.video_views != null && post.inputtedInsights.video_views !== '' ? post.inputtedInsights.video_views : '-' }}</td>
                                    </tr>
                                    <tr v-if="isLinkedInReport(post) && post.inputtedInsights">
                                      <td>Profile viewers from this post</td>
                                      <td>{{ post.inputtedInsights.profile_viewers != null && post.inputtedInsights.profile_viewers !== '' ? post.inputtedInsights.profile_viewers : '-' }}</td>
                                    </tr>
                                    <tr>
                                      <td>{{ isLinkedInReport(post) ? 'Reactions' : 'Likes' }}</td>
                                      <td>{{ post.currentInsight.like_count }}</td>
                                    </tr>
                                    <tr>
                                      <td>Comments</td>
                                      <td>{{ post.currentInsight.comment_count }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights">
                                      <td>{{ isLinkedInReport(post) ? 'Saves' : (isTwitterReport(post) ? 'Bookmarks' : 'Saves (Bookmarks)') }}</td>
                                      <td>{{ post.inputtedInsights.saved }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights && post.inputtedInsights.plays">
                                      <td>Watch Time</td>
                                      <td>{{ post.inputtedInsights.plays }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights && post.inputtedInsights.watches">
                                      <td>Average Watch Time</td>
                                      <td>{{ post.inputtedInsights.watches }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights">
                                      <td>{{ isLinkedInReport(post) || isTwitterReport(post) ? 'Reposts' : 'Shares' }}</td>
                                      <td>{{ post.inputtedInsights.shares }}</td>
                                    </tr>
                                    <tr v-if="post.postType === 'IGR' && post.inputtedInsights && post.inputtedInsights.reposts != null">
                                      <td>Reposts</td>
                                      <td>{{ post.inputtedInsights.reposts }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights && !isTwitterReport(post) && !isLinkedInReport(post)">
                                      <td>Views</td>
                                      <td>{{ post.inputtedInsights.views }}</td>
                                    </tr>
                                    <!-- <tr>
                                      <td>Engagement</td>
                                      <td>{{ post.currentInsight.engagement }}</td>
                                    </tr>
                                    <tr>
                                      <td>Outreach</td>
                                      <td>{{ post.currentInsight.outreach }}</td>
                                    </tr> -->
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel v-if="post.graphInsight">
                            <v-expansion-panel-header>
                              Graph Insights
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-simple-table dark dense>
                                <template v-slot:default>
                                  <tbody>
                                    <tr>
                                      <td>Engagement</td>
                                      <td>{{ post.graphInsight.engagement }}</td>
                                    </tr>
                                    <tr>
                                      <td>Impressions</td>
                                      <td>{{ post.graphInsight.impressions }}</td>
                                    </tr>
                                    <tr>
                                      <td>Reach</td>
                                      <td>{{ post.graphInsight.reach }}</td>
                                    </tr>
                                    <tr>
                                      <td>Saved</td>
                                      <td>{{ post.graphInsight.saved }}</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <!-- <v-expansion-panel v-if="post.inputtedInsights">
                            <v-expansion-panel-header>
                              Inputted Insights
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-simple-table dark dense>
                                <template v-slot:default>
                                  <tbody>
                                    <tr>
                                      <td>Bookmarks</td>
                                      <td>{{ post.inputtedInsights.saved }}</td>
                                    </tr>
                                    <tr>
                                      <td>Shares</td>
                                      <td>{{ post.inputtedInsights.shares }}</td>
                                    </tr>
                                    <tr>
                                      <td>Views</td>
                                      <td>{{ post.inputtedInsights.views }}</td>
                                    </tr>
                                    <tr>
                                      <td>Reach</td>
                                      <td>{{ post.inputtedInsights.reach }}</td>
                                    </tr>
                                    <tr>
                                      <td>Impressions</td>
                                      <td>{{ post.inputtedInsights.impressions }}</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel> -->
                          <v-btn
                            block
                            v-bind="attrs"
                            v-on="on"
                            @click="updatePostInsightsHandler(post)"
                          >
                            Update Insights
                            <v-icon right>mdi-pencil</v-icon>
                          </v-btn>
                        </v-expansion-panels>
                      </v-card-text>

                      <v-card-actions>
                        <v-btn small color="red" @click="removeContent(post.id)">
                          Remove
                          <v-icon right>mdi-delete</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          color="secondary"
                          :href="post.post_details.link"
                          :target="'_blank'"
                        >
                          {{ isLinkedInReport(post) ? 'View on LinkedIn' : (isTwitterReport(post) ? 'View on X' : 'View') }}
                          <v-icon v-if="isLinkedInReport(post)" right>mdi-linkedin</v-icon>
                          <img v-else-if="isTwitterReport(post)" src="/static/img/x-logo.svg" width="18px" class="ml-2" style="filter: invert(1);" alt="" aria-hidden="true" />
                          <v-icon v-else right>mdi-open-in-new</v-icon>
                        </v-btn>
                      </v-card-actions>
                  </v-card>
                  <v-card
                    v-else-if="post.isStory"
                    class="mx-auto campaign-post"
                    color="#62727b"
                    dark
                    max-width="300"
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover }"
                  >
<v-card-title class="campaign-post-header">
                      <v-list-item class="grow pa-0 campaign-post-header-row">
                        <v-list-item-avatar color="grey darken-3">
                          <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            <a class="caption" :href="getAccountProfileUrl(post)" target="_blank"
                              >@{{ post.profileHandle || post.profile_handle || post.owner.username }}</a
                            >
                            <!-- <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(post)">edit</v-icon> -->
                          </v-list-item-title>
                        </v-list-item-content>
                        <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                      </v-list-item>
                    </v-card-title>
                    <v-card-text class="headline font-weight-bold" v-if="post.media_url">
                      <custom-media
                        :className="getMedia(post).className"
                        :type="getMedia(post).type"
                        :publicID="getMedia(post).publicID"
                        :videoID="getMedia(post).videoID"
                        :URL="getMedia(post).URL"
                        :width="getMedia(post).width"
                        :height="getMedia(post).height"
                        :trans="getMedia(post).trans"
                        v-if="MEDIA_URL_TYPE(post.media_url) === 'cld' && post.public_id"
                      />
                      <img
                        width="100%"
                        class="elevation-0"
                        v-else-if="post.media_type == 'IMAGE' || MEDIA_URL_TYPE(post.media_url) === 'image' || post.thumbnail_url"
                        :src="post.media_type == 'IMAGE' || MEDIA_URL_TYPE(post.media_url) === 'image' ? post.media_url : post.thumbnail_url"
                      />
                      <video width="100%" controls v-else-if="post.media_url && MEDIA_URL_TYPE(post.media_url) === 'video'">
                        <source :src="post.media_url" type="video/mp4">
                        Your browser does not support HTML5 video.
                      </video>
                      <gDrive-post-view :url="post.media_url" v-else-if="MEDIA_URL_TYPE(post.media_url) === 'driveView'" />
                      <iframe class="media-iframe" width="100%" height="100%" :src="post.media_url" v-else-if="MEDIA_URL_TYPE(post.media_url) === 'iframe'" scrolling="no" seamless="" allowFullScreen></iframe>
                    </v-card-text>
                    <v-card-text class="headline font-weight-bold" v-else>
                      <div>
                        <v-alert width="100%">
                          Media type unsupported!
                        </v-alert>
                      </div>
                    </v-card-text>
                    <v-card-text v-if="post.insights">
                      <div class="text-center">
                        <v-chip
                        dark
                        label
                        class="subheading ma-1">
                          <span>IMS Status:&nbsp;</span>
                          <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                        </v-chip>
                      </div>
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            Story Insights
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-simple-table dark dense>
                              <template v-slot:default>
                                <tbody>
                                  <tr>
                                    <td>Accounts Reached</td>
                                    <td>{{ post.insights.reach }}</td>
                                  </tr>
                                  <tr>
                                    <td>Impressions</td>
                                    <td>{{ post.insights.impressions }}</td>
                                  </tr>
                                  <tr>
                                    <td>Replies</td>
                                    <td>{{ post.insights.replies }}</td>
                                  </tr>
                                  <!-- <tr>
                                    <td>Exits</td>
                                    <td>{{ post.insights.exits }}</td>
                                  </tr>
                                  <tr>
                                    <td>Taps Back</td>
                                    <td>{{ post.insights.taps_back }}</td>
                                  </tr>
                                  <tr>
                                    <td>Taps Forward</td>
                                    <td>{{ post.insights.taps_forward }}</td>
                                  </tr> -->
                                  <tr>
                                    <td>Shares</td>
                                    <td>{{ post.insights.shares }}</td>
                                  </tr>
                                  <tr>
                                    <td>Link Clicks</td>
                                    <td>{{ post.insights.link_clicks }}</td>
                                  </tr>
                                  <tr>
                                    <td>Sticker Taps</td>
                                    <td>{{ post.insights.sticker_taps }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-btn
                        block
                        v-bind="attrs"
                        v-on="on"
                        @click="updatePostInsightsHandler(post)"
                      >
                        Update Insights
                        <v-icon right>mdi-pencil</v-icon>
                      </v-btn>
                      </v-expansion-panels>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn small color="red" @click="removeContent(post.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="post.media_url"
                        small
                        color="secondary"
                        :href="post.media_url"
                        :target="'_blank'"
                      >
                        View Story Media
                        <v-icon right>mdi-clipboard-play</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-card
                      v-else-if="post.isTikTok"
                      class="mx-auto campaign-post"
                      color="#62727b"
                      dark
                      max-width="300"
                      :elevation="hover ? 12 : 2"
                      :class="{ 'on-hover': hover }"
                    >
                      <v-card-title>
                        <v-list-item class="grow pa-0">
                          <v-list-item-avatar color="grey darken-3">
                            <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              <a class="caption" :href="getAccountProfileUrl(post)" target="_blank" rel="noopener noreferrer"
                                >@{{ post.owner.username }}</a
                              >
                            </v-list-item-title>
                          </v-list-item-content>
                          <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                          <v-list-item-action>
                            <v-chip
                              color="primary"
                              v-if="post.type"
                              small
                            >
                              {{post.type}}
                            </v-chip>
                          </v-list-item-action>
                        </v-list-item>
                      </v-card-title>

                      <v-card-text class="headline font-weight-bold">
                        <!-- <img
                          width="100%"
                          class="elevation-0"
                          :src="post.media_url ? post.media_url : post.post_details.image"
                        /> -->
                        <div class="igPost-block" style="max-width:350px;" v-if="post.tikTokPost">
                          <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                            <iframe :src="post.tikTokPost" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text>
                        <div class="text-center">
                          <v-chip
                          dark
                          label
                          class="subheading ma-1">
                            <span>IMS Status:&nbsp;</span>
                            <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                          </v-chip>
                        </div>
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              Post Insights
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-simple-table dark dense v-if="post.currentInsight">
                                <template v-slot:default>
                                  <tbody>
                                    <tr v-if="post.inputtedInsights && post.inputtedInsights.plays">
                                      <td>Total Play Time</td>
                                      <td>{{ post.inputtedInsights.plays }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights && post.inputtedInsights.watches">
                                      <td>Average Watch Time</td>
                                      <td>{{ post.inputtedInsights.watches }}</td>
                                    </tr>
                                    <tr>
                                      <td>Likes</td>
                                      <td>{{ post.currentInsight.like_count }}</td>
                                    </tr>
                                    <tr>
                                      <td>Comments</td>
                                      <td>{{ post.currentInsight.comment_count }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights">
                                      <td>Shares</td>
                                      <td>{{ post.inputtedInsights.shares }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights">
                                      <td>Favourites (Bookmarks)</td>
                                      <td>{{ post.inputtedInsights.saved }}</td>
                                    </tr>
                                    <tr v-if="post.currentInsight.views">
                                      <td>Plays (Views)</td>
                                      <td>{{ post.currentInsight.views }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights">
                                      <td>Reach</td>
                                      <td>{{ post.inputtedInsights.reach }}</td>
                                    </tr>
                                    <tr v-if="post.inputtedInsights">
                                      <td>Watched Full Video</td>
                                      <td>{{ post.inputtedInsights.watchedFullVideo }}</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel v-if="post.graphInsight">
                            <v-expansion-panel-header>
                              Graph Insights
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-simple-table dark dense>
                                <template v-slot:default>
                                  <tbody>
                                    <tr>
                                      <td>Engagement</td>
                                      <td>{{ post.graphInsight.engagement }}</td>
                                    </tr>
                                    <tr>
                                      <td>Impressions</td>
                                      <td>{{ post.graphInsight.impressions }}</td>
                                    </tr>
                                    <tr>
                                      <td>Reach</td>
                                      <td>{{ post.graphInsight.reach }}</td>
                                    </tr>
                                    <tr>
                                      <td>Saved</td>
                                      <td>{{ post.graphInsight.saved }}</td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-btn
                            block
                            v-bind="attrs"
                            v-on="on"
                            @click="updatePostInsightsHandler(post)"
                          >
                            Update Insights
                            <v-icon right>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            block
                            v-bind="attrs"
                            v-on="on"
                            @click="scrapComments(post.post_details.link, post.id)"
                          >
                            Extract Comments
                            <v-icon right>mdi-refresh</v-icon>
                          </v-btn>
                          <v-btn
                            block
                            v-bind="attrs"
                            v-on="on"
                            color="blue-grey"
                            :disabled="!post.comments || post.comments.length === 0"
                            @click="openCommentsDialog(post)"
                          >
                            View Comments ({{ post.comments ? post.comments.length : 0 }})
                            <v-icon right>mdi-comment-text-multiple</v-icon>
                          </v-btn>
                        </v-expansion-panels>
                      </v-card-text>

                      <v-card-actions>
                        <v-btn small color="red" @click="removeContent(post.id)">
                          Remove
                          <v-icon right>mdi-delete</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          color="secondary"
                          :href="post.post_details.link"
                          :target="'_blank'"
                        >
                          View on TikTok&nbsp;<img src='/static/img/tik-tok-white.png' width="18px" />
                        </v-btn>
                      </v-card-actions>
                  </v-card>

                  <!-- Facebook Post -->
                  <v-card
                    v-else-if="post.isFacebook"
                    class="mx-auto campaign-post"
                    color="#62727b"
                    dark
                    max-width="300"
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover }"
                  >
                    <v-card-title class="campaign-post-header">
                      <v-list-item class="grow pa-0 campaign-post-header-row">
                        <v-list-item-avatar color="grey darken-3">
                          <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="campaign-post-owner-content">
                          <v-list-item-title class="campaign-post-owner-title">
                            <a class="caption campaign-post-owner-handle" :title="`@${post.owner.username}`" :href="'https://www.facebook.com/' + post.owner.username" target="_blank"
                              >@{{ post.owner.username }}</a
                            >
                            <!-- <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(item)">edit</v-icon> -->
                            <v-menu
                              bottom
                              origin="center center"
                              transition="scale-transition"
                              v-if="post.multipleInfs && post.multipleInfs.length > 1"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  dark
                                  text
                                  v-bind="attrs"
                                  v-on="on"
                                  style="min-width:0;max-width:20px;padding:0;margin-top:-3px;"
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="warning" v-on="on" small>mdi-chevron-down-circle</v-icon>
                                    </template>
                                    <span>Multiple Accounts detected</span>
                                  </v-tooltip>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(obj, i) in post.multipleInfs"
                                  :key="i"
                                  link
                                  @click="changePlatform(obj, i)"
                                >
                                  <v-list-item-title>
                                    <!-- <v-avatar size="35" color="grey lighten-4">
                                      <img
                                        class="elevation-6"
                                        v-bind:src="paserImageUrl(obj.picture)"
                                        alt="avatar"
                                      >
                                    </v-avatar> -->
                                    <a
                                      v-if="obj.xhs"
                                    ><img src="/static/img/xhs-black.png" width="20px" /> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.facebook"
                                    ><v-icon color="#000000" small>mdi-facebook</v-icon> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.tiktok"
                                    ><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.youtube"
                                    ><v-icon>mdi-youtube</v-icon> @{{obj.handle}}</a>
                                    <a
                                      v-else
                                    ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{obj.handle}}</a>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-title>
                        </v-list-item-content>
                        <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                        <v-list-item-action class="campaign-post-type-action">
                          <v-chip
                            color="primary"
                            v-if="post.type"
                            small
                          >
                            {{post.type}}
                          </v-chip>
                        </v-list-item-action>
                      </v-list-item>
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                      <!-- <img
                        width="100%"
                        class="elevation-0"
                        :src="post.media_url ? post.media_url : post.post_details.image"
                      /> -->
                      <div class="igPost-block" style="max-width:350px;" v-if="post.media_url">
                        <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                          <iframe :src="getFbPost(post.media_url)"
                          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                          allowfullscreen="true"
                          scrolling="no"
                          style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                        </div>
                      </div>
                    </v-card-text>

                    <v-card-text>
                      <div class="text-center">
                        <v-chip
                        dark
                        label
                        class="subheading ma-1">
                          <span>IMS Status:&nbsp;</span>
                          <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                        </v-chip>
                      </div>
                      <v-expansion-panels>
                        <v-expansion-panel v-if="post.insights">
                          <v-expansion-panel-header>
                            Post Insights
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-simple-table dark dense>
                              <template v-slot:default>
                                <tbody>
                                  <tr>
                                    <td>Outreach</td>
                                    <td>{{ post.insights.outreach }}</td>
                                  </tr>
                                  <tr>
                                    <td>Likes</td>
                                    <td>{{ post.insights.like_count }}</td>
                                  </tr>
                                  <tr>
                                    <td>Comments</td>
                                    <td>{{ post.insights.comment_count }}</td>
                                  </tr>
                                  <tr>
                                    <td>Views</td>
                                    <td>{{ post.insights.views }}</td>
                                  </tr>
                                  <tr>
                                    <td>Shares</td>
                                    <td>{{ post.insights.shares }}</td>
                                  </tr>
                                  <tr>
                                    <td>Bookmarks</td>
                                    <td>{{ post.insights.bookmarks }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-btn
                          block
                          v-bind="attrs"
                          v-on="on"
                          @click="updatePostInsightsHandler(post)"
                        >
                          Update Insights
                          <v-icon right>mdi-pencil</v-icon>
                        </v-btn>
                      </v-expansion-panels>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn small color="red" @click="removeContent(post.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        color="secondary"
                        :href="post.media_url"
                        :target="'_blank'"
                      >
                        View on Facebook
                      </v-btn>
                    </v-card-actions>
                  </v-card>

                  <!-- XHS Post -->
                  <v-card
                    v-else-if="post.isXHS"
                    class="mx-auto campaign-post"
                    color="#62727b"
                    dark
                    max-width="300"
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover }"
                  >
                    <v-card-title>
                      <v-list-item class="grow pa-0">
                        <v-list-item-avatar color="grey darken-3">
                          <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            <a class="caption" :href="'https://www.xiaohongshu.com/user/profile/' + post.owner.xhsID" target="_blank"
                              >@{{ post.owner.fullName || post.owner.username }}</a
                            >
                            <!-- <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(post)">edit</v-icon> -->
                            <v-menu
                              bottom
                              origin="center center"
                              transition="scale-transition"
                              v-if="post.multipleInfs && post.multipleInfs.length > 1"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  dark
                                  text
                                  v-bind="attrs"
                                  v-on="on"
                                  style="min-width:0;max-width:20px;padding:0;margin-top:-3px;"
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="warning" v-on="on" small>mdi-chevron-down-circle</v-icon>
                                    </template>
                                    <span>Multiple Accounts detected</span>
                                  </v-tooltip>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(obj, i) in post.multipleInfs"
                                  :key="i"
                                  link
                                  @click="changePlatform(obj, i)"
                                >
                                  <v-list-item-title>
                                    <!-- <v-avatar size="35" color="grey lighten-4">
                                      <img
                                        class="elevation-6"
                                        v-bind:src="paserImageUrl(obj.picture)"
                                        alt="avatar"
                                      >
                                    </v-avatar> -->
                                    <a
                                      v-if="obj.xhs"
                                    ><img src="/static/img/xhs-black.png" width="20px" /> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.facebook"
                                    ><v-icon color="#000000" small>mdi-facebook</v-icon> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.tiktok"
                                    ><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.youtube"
                                    ><v-icon>mdi-youtube</v-icon> @{{obj.handle}}</a>
                                    <a
                                      v-else
                                    ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{obj.handle}}</a>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-chip
                            color="primary"
                            v-if="post.type"
                            small
                          >
                            {{post.type}}
                          </v-chip>
                        </v-list-item-action>
                        <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                      </v-list-item>
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                      <!-- <img
                        width="100%"
                        class="elevation-0"
                        :src="post.media_url ? post.media_url : post.post_details.image"
                      /> -->
                      <div class="igPost-block" style="max-width:350px;" v-if="post.embed_url">
                        <!-- <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                          <iframe :src="post.media_url" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                        </div> -->
                        <custom-media
                          :type="getMedia(post).type"
                          :publicID="getMedia(post).publicID"
                          :videoID="getMedia(post).videoID"
                          :URL="getMedia(post).URL"
                          :width="getMedia(post).width"
                          :height="getMedia(post).height"
                          :trans="getMedia(post).trans"
                        />
                      </div>
                    </v-card-text>

                    <v-card-text>
                      <div class="text-center">
                        <v-chip
                        dark
                        label
                        class="subheading ma-1">
                          <span>IMS Status:&nbsp;</span>
                          <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                        </v-chip>
                      </div>
                      <v-expansion-panels>
                        <v-expansion-panel v-if="post.insights">
                          <v-expansion-panel-header>
                            Post Insights
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-simple-table dark dense>
                              <template v-slot:default>
                                <tbody>
                                  <tr>
                                    <td>Outreach</td>
                                    <td>{{ post.insights.outreach }}</td>
                                  </tr>
                                  <tr>
                                    <td>Likes</td>
                                    <td>{{ post.insights.like_count }}</td>
                                  </tr>
                                  <tr>
                                    <td>Comments</td>
                                    <td>{{ post.insights.comment_count }}</td>
                                  </tr>
                                  <tr>
                                    <td>Views</td>
                                    <td>{{ post.insights.views }}</td>
                                  </tr>
                                  <tr>
                                    <td>Shares</td>
                                    <td>{{ post.insights.shares }}</td>
                                  </tr>
                                  <tr>
                                    <td>Bookmarks</td>
                                    <td>{{ post.insights.bookmarks }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-btn
                          block
                          v-bind="attrs"
                          v-on="on"
                          @click="updatePostInsightsHandler(post)"
                        >
                          Update Insights
                          <v-icon right>mdi-pencil</v-icon>
                        </v-btn>
                      </v-expansion-panels>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn small color="red" @click="removeContent(post.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        color="secondary"
                        :href="post.media_url"
                        :target="'_blank'"
                      >
                        View on XHS&nbsp;
                      </v-btn>
                    </v-card-actions>
                  </v-card>

                   <!-- Lemon Post -->
                   <v-card
                    v-else-if="post.isLemon"
                    class="mx-auto campaign-post"
                    color="#62727b"
                    dark
                    max-width="300"
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover }"
                  >
                    <v-card-title>
                      <v-list-item class="grow pa-0">
                        <v-list-item-avatar color="grey darken-3">
                          <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            <a class="caption" href="">@{{ post.owner.fullName || post.owner.username }}</a
                            >
                            <!-- <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(post)">edit</v-icon> -->
                            <v-menu
                              bottom
                              origin="center center"
                              transition="scale-transition"
                              v-if="post.multipleInfs && post.multipleInfs.length > 1"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  dark
                                  text
                                  v-bind="attrs"
                                  v-on="on"
                                  style="min-width:0;max-width:20px;padding:0;margin-top:-3px;"
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="warning" v-on="on" small>mdi-chevron-down-circle</v-icon>
                                    </template>
                                    <span>Multiple Accounts detected</span>
                                  </v-tooltip>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(obj, i) in post.multipleInfs"
                                  :key="i"
                                  link
                                  @click="changePlatform(obj, i)"
                                >
                                  <v-list-item-title>
                                    <!-- <v-avatar size="35" color="grey lighten-4">
                                      <img
                                        class="elevation-6"
                                        v-bind:src="paserImageUrl(obj.picture)"
                                        alt="avatar"
                                      >
                                    </v-avatar> -->
                                    <a
                                      v-if="obj.xhs"
                                    ><img src="/static/img/xhs-black.png" width="20px" /> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.facebook"
                                    ><v-icon color="#000000" small>mdi-facebook</v-icon> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.tiktok"
                                    ><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.youtube"
                                    ><v-icon>mdi-youtube</v-icon> @{{obj.handle}}</a>
                                    <a
                                      v-else
                                    ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{obj.handle}}</a>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-chip
                            color="primary"
                            v-if="post.type"
                            small
                          >
                            {{post.type}}
                          </v-chip>
                        </v-list-item-action>
                        <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                      </v-list-item>
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                      <!-- <img
                        width="100%"
                        class="elevation-0"
                        :src="post.media_url ? post.media_url : post.post_details.image"
                      /> -->
                      <div class="igPost-block" style="max-width:350px;" v-if="post.embed_url">
                        <!-- <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                          <iframe :src="post.media_url" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                        </div> -->
                        <custom-media
                          :type="getMedia(post).type"
                          :publicID="getMedia(post).publicID"
                          :videoID="getMedia(post).videoID"
                          :URL="getMedia(post).URL"
                          :width="getMedia(post).width"
                          :height="getMedia(post).height"
                          :trans="getMedia(post).trans"
                        />
                      </div>
                    </v-card-text>

                    <v-card-text>
                      <div class="text-center">
                        <v-chip
                        dark
                        label
                        class="subheading ma-1">
                          <span>IMS Status:&nbsp;</span>
                          <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                        </v-chip>
                      </div>
                      <v-expansion-panels>
                        <v-expansion-panel v-if="post.insights">
                          <v-expansion-panel-header>
                            Post Insights
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-simple-table dark dense>
                              <template v-slot:default>
                                <tbody>
                                  <tr>
                                    <td>Outreach</td>
                                    <td>{{ post.insights.outreach }}</td>
                                  </tr>
                                  <tr>
                                    <td>Likes</td>
                                    <td>{{ post.insights.like_count }}</td>
                                  </tr>
                                  <tr>
                                    <td>Comments</td>
                                    <td>{{ post.insights.comment_count }}</td>
                                  </tr>
                                  <tr>
                                    <td>Views</td>
                                    <td>{{ post.insights.views }}</td>
                                  </tr>
                                  <tr>
                                    <td>Shares</td>
                                    <td>{{ post.insights.shares }}</td>
                                  </tr>
                                  <tr>
                                    <td>Bookmarks</td>
                                    <td>{{ post.insights.bookmarks }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-btn
                          block
                          v-bind="attrs"
                          v-on="on"
                          @click="updatePostInsightsHandler(post)"
                        >
                          Update Insights
                          <v-icon right>mdi-pencil</v-icon>
                        </v-btn>
                      </v-expansion-panels>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn small color="red" @click="removeContent(post.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        color="secondary"
                        :href="post.media_url"
                        :target="'_blank'"
                      >
                        View on Lemon8&nbsp;
                      </v-btn>
                    </v-card-actions>
                  </v-card>

                  <!-- Youtube Post -->
                  <v-card
                    v-else-if="post.isYoutube"
                    class="mx-auto campaign-post"
                    color="#62727b"
                    dark
                    max-width="300"
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover }"
                  >
                    <v-card-title>
                      <v-list-item class="grow pa-0">
                        <v-list-item-avatar color="grey darken-3">
                          <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content class="campaign-post-owner-content">
                          <v-list-item-title class="campaign-post-owner-title">
                            <a class="caption campaign-post-owner-handle" :title="`@${post.owner.username}`" :href="'https://www.youtube.com/' + post.owner.username" target="_blank"
                              >@{{ post.owner.username }}</a
                            >
                            <!-- <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(post)">edit</v-icon> -->
                            <v-menu
                              bottom
                              origin="center center"
                              transition="scale-transition"
                              v-if="post.multipleInfs && post.multipleInfs.length > 1"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  dark
                                  text
                                  v-bind="attrs"
                                  v-on="on"
                                  style="min-width:0;max-width:20px;padding:0;margin-top:-3px;"
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="warning" v-on="on" small>mdi-chevron-down-circle</v-icon>
                                    </template>
                                    <span>Multiple Accounts detected</span>
                                  </v-tooltip>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(obj, i) in post.multipleInfs"
                                  :key="i"
                                  link
                                  @click="changePlatform(obj, i)"
                                >
                                  <v-list-item-title>
                                    <!-- <v-avatar size="35" color="grey lighten-4">
                                      <img
                                        class="elevation-6"
                                        v-bind:src="paserImageUrl(obj.picture)"
                                        alt="avatar"
                                      >
                                    </v-avatar> -->
                                    <a
                                      v-if="obj.xhs"
                                    ><img src="/static/img/xhs-black.png" width="20px" /> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.facebook"
                                    ><v-icon color="#000000" small>mdi-facebook</v-icon> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.tiktok"
                                    ><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.youtube"
                                    ><v-icon>mdi-youtube</v-icon> @{{obj.handle}}</a>
                                    <a
                                      v-else
                                    ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{obj.handle}}</a>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item-title>
                        </v-list-item-content>
                        <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                        <v-list-item-action class="campaign-post-type-action">
                          <v-chip
                            class="campaign-post-type-chip"
                            color="primary"
                            v-if="post.type"
                            small
                          >
                            <span class="campaign-post-type-title" :title="post.type">{{post.type}}</span>
                          </v-chip>
                        </v-list-item-action>
                      </v-list-item>
                    </v-card-title>

                    <v-card-text class="headline font-weight-bold">
                      <!-- <img
                        width="100%"
                        class="elevation-0"
                        :src="post.media_url ? post.media_url : post.post_details.image"
                      /> -->
                      <div class="igPost-block" style="max-width:350px;" v-if="post.youtubePost">
                        <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 120px;">
                          <iframe :src="post.youtubePost" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                        </div>
                      </div>
                    </v-card-text>

                    <v-card-text>
                      <div class="text-center">
                        <v-chip
                        dark
                        label
                        class="subheading ma-1">
                          <span>IMS Status:&nbsp;</span>
                          <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                        </v-chip>
                      </div>
                      <v-expansion-panels>
                        <v-expansion-panel v-if="post.currentInsight">
                          <v-expansion-panel-header>
                            Post Insights
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-simple-table dark dense>
                              <template v-slot:default>
                                <tbody>
                                  <tr>
                                    <td>Engagement</td>
                                    <td>{{ post.currentInsight.engagement }}</td>
                                  </tr>
                                  <tr>
                                    <td>Likes</td>
                                    <td>{{ post.currentInsight.like_count }}</td>
                                  </tr>
                                  <tr>
                                    <td>Comments</td>
                                    <td>{{ post.currentInsight.comment_count }}</td>
                                  </tr>
                                  <tr v-if="post.inputtedInsights && post.inputtedInsights.impressions != null">
                                    <td>Impressions</td>
                                    <td>{{ post.inputtedInsights.impressions }}</td>
                                  </tr>
                                  <tr v-if="post.inputtedInsights && post.inputtedInsights.unique_viewers != null">
                                    <td>Unique Viewers</td>
                                    <td>{{ post.inputtedInsights.unique_viewers }}</td>
                                  </tr>
                                  <tr v-if="post.inputtedInsights && post.inputtedInsights.watches != null">
                                    <td>Average Watch Time</td>
                                    <td>{{ post.inputtedInsights.watches }}</td>
                                  </tr>
                                  <tr>
                                    <td>Outreach</td>
                                    <td>{{ post.currentInsight.outreach }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-btn
                          block
                          v-bind="attrs"
                          v-on="on"
                          @click="updatePostInsightsHandler(post)"
                        >
                          Update Insights
                          <v-icon right>mdi-pencil</v-icon>
                        </v-btn>
                      </v-expansion-panels>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn small color="red" @click="removeContent(post.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        color="secondary"
                        :href="post.post_details.link"
                        :target="'_blank'"
                      >
                        View on Youtube&nbsp;<i class="fab fa-youtube"></i>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-card
                    v-else-if="post.isMultipleContents"
                    class="mx-auto campaign-post"
                    color="#62727b"
                    dark
                    max-width="300"
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover }"
                  >
<v-card-title>
                      <v-list-item class="grow pa-0">
                        <v-list-item-avatar color="grey darken-3">
                          <v-img class="elevation-6" :src="post.owner.profile_pic_url"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            <a class="caption" :href="getAccountProfileUrl(post)" target="_blank"
                              >@{{ post.profileHandle || post.profile_handle || post.owner.username }}</a
                            >
                            <!-- <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(post)">edit</v-icon> -->
                          </v-list-item-title>
                        </v-list-item-content>
                        <!-- <v-list-item-action>${{ post.payout_details.amount | thousandSeprator }}</v-list-item-action> -->
                        <v-list-item-action>
                          <v-chip
                            color="primary"
                            v-if="post.type"
                            small
                          >
                            {{post.type}}
                          </v-chip>
                        </v-list-item-action>
                      </v-list-item>
                    </v-card-title>
                    <!-- <v-card-text class="headline font-weight-bold" v-if="campaignHelper.isAOKCampaign(campaignData.campaignType)">
                      <gDrive-post-view :url="post.embed_url" />
                    </v-card-text> -->
                    <v-card-text class="headline font-weight-bold">
                      <custom-media
                        :type="getMedia(post).type"
                        :publicID="getMedia(post).publicID"
                        :videoID="getMedia(post).videoID"
                        :URL="getMedia(post).URL"
                        :width="getMedia(post).width"
                        :height="getMedia(post).height"
                        :trans="getMedia(post).trans"
                      />
                    </v-card-text>
                    <v-card-text v-if="post.insights">
                      <div class="text-center">
                        <v-chip
                        dark
                        label
                        class="subheading ma-1">
                          <span>IMS Status:&nbsp;</span>
                          <strong>{{getIMSStatus(post.ims_status, post.payment_status)}}</strong>
                        </v-chip>
                      </div>
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            Story Insights
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-simple-table dark dense>
                              <template v-slot:default>
                                <tbody>
                                  <tr>
                                    <td>Impressions</td>
                                    <td>{{ post.insights.impressions }}</td>
                                  </tr>
                                  <tr>
                                    <td>Reach</td>
                                    <td>{{ post.insights.reach }}</td>
                                  </tr>
                                  <tr>
                                    <td>Replies</td>
                                    <td>{{ post.insights.replies }}</td>
                                  </tr>
                                  <tr>
                                    <td>Exits</td>
                                    <td>{{ post.insights.exits }}</td>
                                  </tr>
                                  <tr>
                                    <td>Taps Back</td>
                                    <td>{{ post.insights.taps_back }}</td>
                                  </tr>
                                  <tr>
                                    <td>Taps Forward</td>
                                    <td>{{ post.insights.taps_forward }}</td>
                                  </tr>
                                  <tr>
                                    <td>Shares</td>
                                    <td>{{ post.insights.shares }}</td>
                                  </tr>
                                  <tr>
                                    <td>Link Clicks</td>
                                    <td>{{ post.insights.link_clicks }}</td>
                                  </tr>
                                  <tr>
                                    <td>Sticker Taps</td>
                                    <td>{{ post.insights.sticker_taps }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-btn
                        block
                        v-bind="attrs"
                        v-on="on"
                        @click="updatePostInsightsHandler(post)"
                      >
                        Update Insights
                        <v-icon right>mdi-pencil</v-icon>
                      </v-btn>
                      </v-expansion-panels>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                      <v-btn small color="red" @click="removeContent(post.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                  <v-card
                    v-else
                    class="mx-auto campaign-post"
                    color="#62727b"
                    dark
                    max-width="300"
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover }"
                  >
                    <v-card-title>
                      <v-icon large left>mdi-instagram</v-icon>
                      <span class="caption font-weight-light">Anonymous User</span>
                    </v-card-title>
                    <v-card-text class="title font-weight-bold">
                      Post might be deleted or private. Click
                      <a target="_blank" :href="`https://instagram.com/p/${post.post_details.shortcode}`">Here</a> for more details.
                    </v-card-text>
                    <v-card-actions>
                      <v-btn small color="red" @click="removeContent(post.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        color="secondary"
                        :href="post.post_details.link"
                        :target="'_blank'"
                      >
                        View on Instagram
                        <v-icon right>mdi-instagram</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
              </v-hover>
            </div>
            <!-- </v-row> -->
            <!-- End of Single Posts List -->
          </div>
        </draggable>
      </div>
      <!-- End of Grid View -->

      <!-- Start Table View -->
      <div style="margin-top:10px;margin-bottom:10px;" class="no-gutters" v-if="display === 1">
        <v-row>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-btn color="success" class="mb-2" :disabled="disableSaveEdit" @click="saveEditingData">Save Changes</v-btn>
            <v-btn color="warning" class="mb-2" v-if="!disableSaveEdit" @click="cancelEdit">Cancel</v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-col style="max-width:50px;float:right;" class="pa-0" cols="12" xs="12" md="2">
                <v-menu
                  :close-on-content-click="false"
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="secondary"
                      v-bind="attrs"
                      v-on="on"
                      @click="openColSettingsModal"
                    >
                      <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                    </v-btn>
                  </template>
                </v-menu>
              </v-col>
            </v-col>
            <!-- <v-row class="float-right">
              <v-col cols="12" sm="12" md="3" lg="3">
                <v-select
                  :items="postTypes"
                  item-text="title"
                  item-value="title"
                  label="Content Type"
                  v-model="postType"
                  filled
                  dense
                  hide-details
                  @change="getFiltered()"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <v-menu
                  ref="monthPicker"
                  v-model="monthPicker"
                  :close-on-content-click="false"
                  :return-value.sync="selectedMonth"
                  transition="scale-transition"
                  offset-y
                  dense
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Live Date"
                      v-model="searchMonth"
                      readonly
                      clearable
                      filled
                      dense
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                      @change="getFiltered()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="searchMonth"
                    type="month"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="secondary"
                        @click="monthPicker = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="secondary"
                        @click="searchMonthOk"
                    >
                        OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field
                  class="mb-5"
                  v-model="searchFilter"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row> -->
          </v-col>
        </v-row>
        <v-data-table
          :headers="computedHeaders"
          :items="filteredPosts"
          :items-per-page="20"
          :no-data-text="'Empty list'"
          show-select
          show-expand
          :expanded.sync="expanded"
          class="elevation-1 report__table"
          :search="searchFilter"
          @toggle-select-all="selectAllPosts"
          :single-select="false"
          v-model="selectedPosts"
          :key="dataTableKey"
          v-sortable-data-table
          @sorted="handleDataTableDragDrop"
          :custom-sort="customSort"
        >
          <!-- start actions area (need to copy inside group contents) -->
          <template v-slot:[`item.instagram`]="{ item }">
            <tr>
              <td class="text-xs-left" style="min-width:210px">
                <label
                  v-if="item.reportGroup"
                >{{ item.instagram }} ({{item.reports.length}})
                </label>
                <a
                  target="_blank"
                  :href="getAccountProfileUrl(item)"
                  v-if="!item.reportGroup && !item.isTikTok && !item.isYoutube && !item.isFacebook && !isLinkedInReport(item) && !isTwitterReport(item) && !item.isXHS && !item.isLemon"
                >@{{ item.instagram }}</a>
                <a
                  target="_blank"
                  :href="getAccountProfileUrl(item)"
                  v-if="!item.reportGroup && item.isTikTok"
                >@{{ item.instagram }}</a>
                <a
                  target="_blank"
                  v-bind:href="'https://youtube.com/' + item.instagram"
                  v-if="!item.reportGroup && item.isYoutube"
                >@{{ item.instagram }}</a>
                <a
                  target="_blank"
                  v-bind:href="'https://facebook.com/' + item.instagram"
                  v-if="!item.reportGroup && item.isFacebook"
                >@{{ item.instagram }}</a>
                <a
                  target="_blank"
                  v-bind:href="'https://www.linkedin.com/in/' + item.instagram"
                  v-if="!item.reportGroup && isLinkedInReport(item)"
                ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{ item.instagram }}</a>
                <a
                  target="_blank"
                  v-bind:href="'https://x.com/' + item.instagram"
                  v-if="!item.reportGroup && isTwitterReport(item)"
                ><img src="/static/img/x-logo.svg" width="14px" class="mr-1" alt="" aria-hidden="true" /> @{{ item.instagram }}</a>
                <a :href="'https://www.xiaohongshu.com/user/profile/' + item.xhsID"
                target="_blank"
                v-if="!item.reportGroup && item.isXHS"
                >@{{ item.fullName }}</a>
                <a v-if="!item.reportGroup && item.isLemon"
                >@{{ item.fullName }}</a>
                <!-- <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(item)">edit</v-icon> -->
                <v-menu
                  bottom
                  origin="center center"
                  transition="scale-transition"
                  v-if="item.multipleInfs && item.multipleInfs.length > 1"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      dark
                      text
                      v-bind="attrs"
                      v-on="on"
                      style="min-width:0;max-width:20px;padding:0;margin-top:-3px;"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon color="warning" v-on="on" small>mdi-chevron-down-circle</v-icon>
                        </template>
                        <span>Multiple Accounts detected</span>
                      </v-tooltip>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(obj, i) in item.multipleInfs"
                      :key="i"
                      link
                      @click="changePlatform(obj, i)"
                    >
                      <v-list-item-title>
                        <!-- <v-avatar size="35" color="grey lighten-4">
                          <img
                            class="elevation-6"
                            v-bind:src="paserImageUrl(obj.picture)"
                            alt="avatar"
                          >
                        </v-avatar> -->
                        <a
                          v-if="obj.xhs"
                        ><img src="/static/img/xhs-black.png" width="20px" /> @{{obj.handle}}</a>
                        <a
                          v-else-if="obj.facebook"
                        ><v-icon color="#000000" small>mdi-facebook</v-icon> @{{obj.handle}}</a>
                        <a
                          v-else-if="obj.tiktok"
                        ><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a>
                        <a
                          v-else-if="obj.youtube"
                        ><v-icon>mdi-youtube</v-icon> @{{obj.handle}}</a>
                        <a
                          v-else
                        ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{obj.handle}}</a>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.media_url`]="{ item }">
            <div v-if="!item.reportGroup">
              <tr>
                <td class="text-xs-left" style="min-width:100px">
                  <p v-if="item.media_url==='-' || item.media_url===''">-</p>
                  <v-btn
                    v-else
                    small
                    text
                    color="secondary"
                    elevation="0"
                    :href="item.media_url"
                    :target="'_blank'"
                  >
                    View Media
                  </v-btn>
                </td>
              </tr>
            </div>
          </template>
          <template v-slot:[`item.typeName`]="{ item }">
            <div v-if="!item.reportGroup">
              <tr>
                <td class="text-xs-left">{{item.typeName}}</td>
              </tr>
            </div>
            <div v-else>
              <tr>
                <td class="text-xs-left" style="display:none;">{{item.typeName}}</td>
              </tr>
            </div>
          </template>
          <template v-slot:[`item.live_date`]="{ item }">
            <div v-if="!item.reportGroup">
              <div class="item-edit" @click="openEditItem(item, 'liveDate')" v-if="item.liveDateEdit === false">
                <td class="text-xs-left" style="min-width:75px">{{item.live_date}}</td>
              </div>
              <div v-else>
                <v-text-field
                  class="mt-3"
                  v-model="item.live_date"
                  solo
                  v-on="on"
                  style="width:290px;float:left;"
                ></v-text-field>
                <!-- <v-menu
                  ref="datePicker"
                  v-model="item.liveCal"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      class="mt-3"
                      v-model="item.live_date"
                      append-icon="event"
                      solo
                      v-on="on"
                      style="width:290px;float:left;"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    type="date"
                    v-model="item.live_date"
                    @input="item.liveCal = false"
                  ></v-date-picker>
                </v-menu> -->
              </div>
            </div>
          </template>
          <template v-slot:[`item.outreach`]="{ item }">
            <tr>
              <td class="text-xs-left" style="min-width:75px">{{item.outreach | thousandSeprator}}</td>
            </tr>
          </template>
          <template v-slot:[`item.due_date`]="{ item }">
            <div v-if="!item.reportGroup">
              <div class="item-edit" @click="openEditItem(item, 'dueDate')" v-if="item.dueDateEdit === false">
                <td class="text-xs-left" style="min-width:75px">{{item.due_date}}</td>
              </div>
              <div v-else>
                <v-text-field
                  class="mt-3"
                  v-model="item.due_date"
                  solo
                  v-on="on"
                  style="width:290px;float:left;"
                ></v-text-field>
                <!-- <v-menu
                  ref="datePicker"
                  v-model="item.dueCal"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      class="mt-3"
                      v-model="item.due_date"
                      append-icon="event"
                      readonly
                      solo
                      v-on="on"
                      style="width:290px;float:left;"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    type="date"
                    v-model="item.due_date"
                    @input="item.dueCal = false"
                  ></v-date-picker>
                </v-menu> -->
              </div>
            </div>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <div v-if="!item.reportGroup">
              <div v-if="item.amountLocked">
                <div class="item-edit">
                  <td class="text-xs-left" style="min-width:75px">-</td>
                </div>
              </div>
              <div v-else>
                <div>
                  <td class="text-xs-left" style="min-width:75px">${{item.amount | thousandSeprator}}</td>
                </div>
                <!-- <div class="item-edit" @click="openEditItem(item, 'amount')" v-if="item.amountEdit === false">
                  <td class="text-xs-left" style="min-width:75px">${{item.amount | thousandSeprator}}</td>
                </div>
                <div v-else>
                  <td class="text-xs-left">
                    <v-text-field
                      class="mt-3"
                      style="width:150px;"
                      solo
                      type="number"
                      v-model="item.amount"
                    ></v-text-field>
                  </td>
                </div> -->
              </div>
            </div>
          </template>
          <!-- <template v-slot:[`item.bank_reference`]="{ item }">
            <div v-if="!item.reportGroup">
              <div class="item-edit" @click="openEditItem(item, 'bankRef')" v-if="item.bankRefEdit === false">
                <td v-if="item.bank_reference">
                  <v-tooltip bottom v-if="item.bank_name">
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                      >
                        <span>{{item.bank_reference}}</span>
                      </span>
                    </template>
                    <span>{{item.bank_name}}</span>
                  </v-tooltip>
                  <span v-else>{{item.bank_reference}}</span>
                </td>
                <td class="text-xs-left" style="min-width:120px" v-else></td>
              </div>
              <div v-else>
                <td class="text-xs-left">
                  <v-text-field
                    class="mt-3"
                    style="width:200px;"
                    solo
                    v-model="item.bank_reference"
                  ></v-text-field>
                </td>
              </div>
            </div>
          </template> -->
          <template v-slot:[`item.ims_status`]="{ item }">
            <div v-if="!item.reportGroup">
              <div @click="openEditItem(item, 'imsStatus')" v-if="item.imsStatusEdit === false">
                <td class="text-xs-left" style="min-width:75px" v-if="!item.noPayout">
                  {{getIMSStatus(item.ims_status, item.payment_status)}}
                </td>
              </div>
              <div v-else>
                <td class="text-xs-left" style="min-width:75px">
                  <v-select
                    v-model="item.ims_status"
                    :items="imsStatusOptions"
                    item-value="status"
                    item-text="display"
                    label="IMS Status"
                  ></v-select>
                </td>
              </div>
            </div>
          </template>
          <template v-slot:[`item.payment_status`]="{ item }">
            <div v-if="!item.reportGroup">
              <div>
                <td class="text-xs-left" style="min-width:50px">{{getPaymentStatus(item.payment_status)}}</td>
              </div>
              <!-- <div @click="openEditItem(item, 'paymentStatus')" v-if="item.paymentStatusEdit === false">
                <td class="text-xs-left" style="min-width:50px">{{getPaymentStatus(item.payment_status)}}</td>
              </div>
              <div v-else>
                <td class="text-xs-left" style="min-width:50px">
                  <v-select
                    v-model="item.payment_status"
                    :items="paymentStatusOptions"
                    item-value="status"
                    item-text="display"
                    label="Payment Status"
                  ></v-select>
                </td>
              </div> -->
            </div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <td v-if="item.reportGroup">
              <v-btn @click.stop="deleteReportGroup(item.id, item.name)" small color="red">
                Remove Group
                <v-icon small>delete</v-icon>
              </v-btn>
            </td>
            <td v-else>
              <div v-if="item.type === 'Post'">
                <v-btn small color="red" @click="removeContent(item.id)">
                  Remove
                  <v-icon right>mdi-delete</v-icon>
                </v-btn>
                <v-btn
                  small
                  color="secondary"
                  :href="item.post_details.link"
                  :target="'_blank'"
                >
                  View on IG
                  <v-icon right>mdi-instagram</v-icon>
                </v-btn>
              </div>
              <div v-else-if="item.type === 'Story'">
                <v-btn small color="red" @click="removeContent(item.id)">
                  Remove
                  <v-icon right>mdi-delete</v-icon>
                </v-btn>
                <v-btn
                  v-if="item.media_url"
                  small
                  color="secondary"
                  :href="item.media_url"
                  :target="'_blank'"
                >
                  View Story Media
                  <v-icon right>mdi-clipboard-play</v-icon>
                </v-btn>
              </div>
              <div v-else-if="item.type === 'TikTok'">
                <v-btn small color="red" @click="removeContent(item.id)">
                  Remove
                  <v-icon right>mdi-delete</v-icon>
                </v-btn>
                <v-btn
                  v-if="item.media_url"
                  small
                  color="secondary"
                  :href="item.media_url"
                  :target="'_blank'"
                >
                  View TikTok Media
                  <v-icon right>mdi-clipboard-play</v-icon>
                </v-btn>
              </div>
              <div v-else-if="isLinkedInReport(item) || item.type === 'LinkedIn Post'">
                <v-btn small color="red" @click="removeContent(item.id)">
                  Remove
                  <v-icon right>mdi-delete</v-icon>
                </v-btn>
                <v-btn
                  small
                  color="secondary"
                  :href="item.post_details ? item.post_details.link : ''"
                  :target="'_blank'"
                >
                  View on LinkedIn
                  <v-icon right>mdi-linkedin</v-icon>
                </v-btn>
              </div>
              <div v-else-if="isTwitterReport(item) || item.type === 'X (Twitter) Post' || item.type === 'X Post'">
                <v-btn small color="red" @click="removeContent(item.id)">
                  Remove
                  <v-icon right>mdi-delete</v-icon>
                </v-btn>
                <v-btn small color="secondary" :href="getReportPostUrl(item)" target="_blank">
                  View on X
                  <img src="/static/img/x-logo.svg" width="18px" class="ml-2" style="filter: invert(1);" alt="" aria-hidden="true" />
                </v-btn>
              </div>
              <div v-else-if="item.type === 'Others'">
                <v-btn small color="red" @click="removeContent(item.id)">
                  Remove
                  <v-icon right>mdi-delete</v-icon>
                </v-btn>
              </div>
              <div v-else-if="item.type === 'facebook'">
                <v-btn small color="red" @click="removeContent(item.id)">
                  Remove
                  <v-icon right>mdi-delete</v-icon>
                </v-btn>
                <v-btn
                  v-if="item.media_url"
                  small
                  color="secondary"
                  :href="item.media_url"
                  :target="'_blank'"
                >
                  View Facebook Post
                  <v-icon right>mdi-facebook</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn small color="red" @click="removeContent(item.id)">
                  Remove
                  <v-icon right>mdi-delete</v-icon>
                </v-btn>
                <v-btn
                  small
                  color="secondary"
                  v-if="item.isYoutube || item.platform === 'instagram'"
                  :href="item.post_details ? item.post_details.link : ''"
                  :target="'_blank'"
                >
                  <span v-if="item.isYoutube">
                    View on Youtube&nbsp;<i class="fab fa-youtube"></i>
                  </span>
                  <span v-if="item.platform === 'instagram'">
                    View on Instagram
                    <v-icon right>mdi-instagram</v-icon>
                  </span>
                </v-btn>
              </div>
            </td>
          </template>
          <!-- end of actions area -->
          <template v-slot:[`item.data-table-expand`]="{item, expand, isExpanded}">
            <span v-if="item.reportGroup">
              <v-icon @click="expand(false)" v-if="isExpanded">mdi-chevron-up</v-icon>
              <v-icon @click="expand(true)" v-else>mdi-chevron-down</v-icon>
            </span>
            <v-icon v-else>mdi-file-chart</v-icon>
          </template>
          <template v-slot:[`item.data-table-select`]="{item}">
            <td class="text-xs-left" style="min-width:50px">
              <v-layout wrap>
                <v-flex xs6 md6>
                  <v-checkbox
                    v-model="selectedPosts"
                    label=""
                    :value="item"
                    v-if="!item.reportGroup"
                    color="grey darken-2"
                  ></v-checkbox>
                  <v-icon v-else>mdi-file-multiple</v-icon>
                </v-flex>
                <v-flex xs6 md6>
                  <v-btn
                    class="btn-reload"
                    text
                    x-small
                    color="warning"
                    @click="refreshReportInf(item.id)"
                    v-if="!item.reportGroup"
                  >
                    <v-icon dark small>
                      mdi-reload
                    </v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </td>
          </template>
          <!-- Expanded Item Section (Place copied ungroup contents) -->
          <template v-slot:expanded-item="{ headers, item }" style="box-shadow:none;">
            <td :colspan="headers.length" style="border:none;padding:20px;" v-if="item.filteredReports">
              <v-data-table
                :headers="headers"
                :items="item.filteredReports"
                class="elevation-1"
                show-select
                :single-select="false"
                v-model="selectedPosts"
                v-sortable-data-table
                @sorted="handleDataTableDragDrop"
                :custom-sort="customSort"
                :search="searchFilter"
              >
                <template v-slot:[`item.data-table-select`]="{item}">
                  <td class="text-xs-left" style="min-width:50px">
                    <v-layout wrap>
                      <v-flex xs6 md6>
                        <v-checkbox
                          v-model="selectedPosts"
                          label=""
                          :value="item"
                          color="grey darken-2"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs6 md6>
                        <v-btn
                          class="btn-reload"
                          text
                          x-small
                          color="warning"
                          @click="refreshReportInf(item.id)"
                        >
                          <v-icon dark small>
                            mdi-reload
                          </v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
                <template v-slot:[`item.instagram`]="{ item }">
                  <tr>
                    <td class="text-xs-left" style="min-width:100px">
                      <label
                        v-if="item.reportGroup"
                      >{{ item.instagram }}</label>
                      <a
                        target="_blank"
                        :href="getAccountProfileUrl(item)"
                        v-if="!item.reportGroup && !item.isTikTok && !item.isYoutube && !item.isFacebook && !isLinkedInReport(item) && !isTwitterReport(item) && !item.isLemon"
                      >@{{ item.instagram }}</a>
                      <a
                        target="_blank"
                        v-bind:href="'https://youtube.com/' + item.instagram"
                        v-if="!item.reportGroup && item.isYoutube"
                      >@{{ item.instagram }}</a>
                      <a
                        target="_blank"
                        :href="getAccountProfileUrl(item)"
                        v-if="!item.reportGroup && item.isTikTok"
                      >@{{ item.instagram }}</a>
                      <a
                        target="_blank"
                        v-bind:href="'https://facebook.com/' + item.instagram"
                        v-if="!item.reportGroup && item.isFacebook"
                      >@{{ item.instagram }}</a>
                      <a
                        target="_blank"
                        v-bind:href="'https://www.linkedin.com/in/' + item.instagram"
                        v-if="!item.reportGroup && isLinkedInReport(item)"
                      ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{ item.instagram }}</a>
                      <a
                        target="_blank"
                        v-bind:href="'https://x.com/' + item.instagram"
                        v-if="!item.reportGroup && isTwitterReport(item)"
                      ><img src="/static/img/x-logo.svg" width="14px" class="mr-1" alt="" aria-hidden="true" /> @{{ item.instagram }}</a>
                      <a
                        target="_blank"
                        href=""
                        v-if="!item.reportGroup && item.isLemon"
                      >@{{ item.instagram }}</a>
                      <!-- <v-icon class="cursor-pointer" color="warning" x-small @click="openEditHandleModal(item)">edit</v-icon> -->
                      <v-menu
                        bottom
                        origin="center center"
                        transition="scale-transition"
                        v-if="item.multipleInfs && item.multipleInfs.length > 1"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            dark
                            text
                            v-bind="attrs"
                            v-on="on"
                            style="min-width:0;max-width:20px;padding:0;margin-top:-3px;"
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon color="warning" v-on="on" small>mdi-chevron-down-circle</v-icon>
                              </template>
                              <span>Multiple Accounts detected</span>
                            </v-tooltip>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="(obj, i) in item.multipleInfs"
                            :key="i"
                            link
                            @click="changePlatform(obj, i)"
                          >
                            <v-list-item-title>
                              <!-- <v-avatar size="35" color="grey lighten-4">
                                <img
                                  class="elevation-6"
                                  v-bind:src="paserImageUrl(obj.picture)"
                                  alt="avatar"
                                >
                              </v-avatar> -->
                              <a
                                v-if="obj.xhs"
                              ><img src="/static/img/xhs-black.png" width="20px" /> @{{obj.handle}}</a>
                              <a
                                v-else-if="obj.facebook"
                              ><v-icon color="#000000" small>mdi-facebook</v-icon> @{{obj.handle}}</a>
                              <a
                                v-else-if="obj.tiktok"
                              ><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a>
                              <a
                                v-else-if="obj.youtube"
                              ><v-icon>mdi-youtube</v-icon> @{{obj.handle}}</a>
                              <a
                                v-else
                              ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{obj.handle}}</a>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.media_url`]="{ item }">
                  <div v-if="!item.reportGroup">
                    <tr>
                      <td class="text-xs-left" style="min-width:100px">
                        <p v-if="item.media_url==='-' || item.media_url===''">-</p>
                        <v-btn
                          v-else
                          small
                          text
                          color="secondary"
                          elevation="0"
                          :href="item.media_url"
                          :target="'_blank'"
                        >
                          View Media
                        </v-btn>
                      </td>
                    </tr>
                  </div>
                </template>
                <template v-slot:[`item.type`]="{ item }">
                  <div v-if="!item.reportGroup">
                    <tr>
                      <td class="text-xs-left" style="min-width:120px">{{item.typeName}}</td>
                    </tr>
                  </div>
                </template>
                <template v-slot:[`item.live_date`]="{ item }">
                  <div v-if="!item.reportGroup">
                    <div class="item-edit" @click="openEditItem(item, 'liveDate')" v-if="item.liveDateEdit === false">
                      <td class="text-xs-left" style="min-width:75px">{{item.live_date}}</td>
                    </div>
                    <div v-else>
                      <v-text-field
                        class="mt-3"
                        v-model="item.live_date"
                        solo
                        v-on="on"
                        style="width:290px;float:left;"
                      ></v-text-field>
                      <!-- <v-menu
                        ref="datePicker"
                        v-model="item.liveCal"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            class="mt-3"
                            v-model="item.live_date"
                            append-icon="event"
                            solo
                            v-on="on"
                            style="width:290px;float:left;"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          type="date"
                          v-model="item.live_date"
                          @input="item.liveCal = false"
                        ></v-date-picker>
                      </v-menu> -->
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.outreach`]="{ item }">
                  <tr>
                    <td class="text-xs-left" style="min-width:75px">{{item.outreach | thousandSeprator}}</td>
                  </tr>
                </template>
                <template v-slot:[`item.due_date`]="{ item }">
                  <div v-if="!item.reportGroup">
                    <div class="item-edit" @click="openEditItem(item, 'dueDate')" v-if="item.dueDateEdit === false">
                      <td class="text-xs-left" style="min-width:75px">{{item.due_date}}</td>
                    </div>
                    <div v-else>
                      <v-text-field
                        class="mt-3"
                        v-model="item.due_date"
                        solo
                        v-on="on"
                        style="width:290px;float:left;"
                      ></v-text-field>
                      <!-- <v-menu
                        ref="datePicker"
                        v-model="item.dueCal"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            class="mt-3"
                            v-model="item.due_date"
                            append-icon="event"
                            readonly
                            solo
                            v-on="on"
                            style="width:290px;float:left;"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          type="date"
                          v-model="item.due_date"
                          @input="item.dueCal = false"
                        ></v-date-picker>
                      </v-menu> -->
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  <div v-if="!item.reportGroup">
                    <div v-if="item.amountLocked">
                      <div class="item-edit">
                        <td class="text-xs-left" style="min-width:75px">-</td>
                      </div>
                    </div>
                    <div v-else>
                      <div class="item-edit" @click="openEditItem(item, 'amount')" v-if="item.amountEdit === false">
                        <td class="text-xs-left" style="min-width:75px">${{item.amount | thousandSeprator}}</td>
                      </div>
                      <div v-else>
                        <td class="text-xs-left">
                          <v-text-field
                            class="mt-3"
                            style="width:150px;"
                            solo
                            type="number"
                            v-model="item.amount"
                          ></v-text-field>
                        </td>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- <template v-slot:[`item.bank_reference`]="{ item }">
                  <div v-if="!item.reportGroup">
                    <div class="item-edit" @click="openEditItem(item, 'bankRef')" v-if="item.bankRefEdit === false">
                      <td v-if="item.bank_reference">
                        <v-tooltip bottom v-if="item.bank_name">
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="on"
                            >
                              <span>{{item.bank_reference}}</span>
                            </span>
                          </template>
                          <span>{{item.bank_name}}</span>
                        </v-tooltip>
                        <span v-else>{{item.bank_reference}}</span>
                      </td>
                      <td class="text-xs-left" style="min-width:120px" v-else></td>
                    </div>
                    <div v-else>
                      <td class="text-xs-left">
                        <v-text-field
                          class="mt-3"
                          style="width:200px;"
                          solo
                          v-model="item.bank_reference"
                        ></v-text-field>
                      </td>
                    </div>
                  </div>
                </template> -->
                <template v-slot:[`item.ims_status`]="{ item }">
                  <div v-if="!item.reportGroup">
                    <div @click="openEditItem(item, 'imsStatus')" v-if="item.imsStatusEdit === false && !item.noPayout">
                      <td class="text-xs-left" style="min-width:75px">{{getIMSStatus(item.ims_status, item.payment_status)}}</td>
                    </div>
                    <div v-else>
                      <td class="text-xs-left" style="min-width:75px">
                        <v-select
                          v-model="item.ims_status"
                          :items="imsStatusOptions"
                          item-value="status"
                          item-text="display"
                          label="IMS Status"
                        ></v-select>
                      </td>
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.payment_status`]="{ item }">
                  <div v-if="!item.reportGroup">
                    <div @click="openEditItem(item, 'paymentStatus')" v-if="item.paymentStatusEdit === false">
                      <td class="text-xs-left" style="min-width:50px">{{getPaymentStatus(item.payment_status)}}</td>
                    </div>
                    <div v-else>
                      <td class="text-xs-left" style="min-width:50px">
                        <v-select
                          v-model="item.payment_status"
                          :items="paymentStatusOptions"
                          item-value="status"
                          item-text="display"
                          label="Payment Status"
                        ></v-select>
                      </td>
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <td v-if="item.reportGroup">
                    <v-btn @click.stop="deleteReportGroup(item.id, item.name)" small color="red">
                      Remove Group
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </td>
                  <td v-else>
                    <div v-if="item.type === 'Post'">
                      <v-btn small color="red" @click="removeContent(item.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        color="secondary"
                        :href="item.post_details.link"
                        :target="'_blank'"
                      >
                        View on IG
                        <v-icon right>mdi-instagram</v-icon>
                      </v-btn>
                    </div>
                    <div v-else-if="item.type === 'Story'">
                      <v-btn small color="red" @click="removeContent(item.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="item.media_url"
                        small
                        color="secondary"
                        :href="item.media_url"
                        :target="'_blank'"
                      >
                        View Story Media
                        <v-icon right>mdi-clipboard-play</v-icon>
                      </v-btn>
                    </div>
                    <div v-else-if="item.type === 'TikTok'">
                      <v-btn small color="red" @click="removeContent(item.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="item.media_url"
                        small
                        color="secondary"
                        :href="item.media_url"
                        :target="'_blank'"
                      >
                        View TikTok Media
                        <v-icon right>mdi-clipboard-play</v-icon>
                      </v-btn>
                    </div>
                    <div v-else-if="isLinkedInReport(item) || item.type === 'LinkedIn Post'">
                      <v-btn small color="red" @click="removeContent(item.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        color="secondary"
                        :href="item.post_details ? item.post_details.link : ''"
                        :target="'_blank'"
                      >
                        View on LinkedIn
                        <v-icon right>mdi-linkedin</v-icon>
                      </v-btn>
                    </div>
                    <div v-else-if="isTwitterReport(item) || item.type === 'X (Twitter) Post' || item.type === 'X Post'">
                      <v-btn small color="red" @click="removeContent(item.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn small color="secondary" :href="getReportPostUrl(item)" target="_blank">
                        View on X
                        <img src="/static/img/x-logo.svg" width="18px" class="ml-2" style="filter: invert(1);" alt="" aria-hidden="true" />
                      </v-btn>
                    </div>
                    <div v-else-if="item.type === 'facebook'">
                      <v-btn small color="red" @click="removeContent(item.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="item.media_url"
                        small
                        color="secondary"
                        :href="item.media_url"
                        :target="'_blank'"
                      >
                        View Facebook Post
                        <v-icon right>mdi-facebook</v-icon>
                      </v-btn>
                    </div>
                    <div v-else>
                      <v-btn small color="red" @click="removeContent(item.id)">
                        Remove
                        <v-icon right>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        color="secondary"
                        :href="item.post_details ? item.post_details.link : ''"
                        :target="'_blank'"
                      >
                      <span v-if="item.isYoutube">
                        View on Youtube&nbsp;<i class="fab fa-youtube"></i>
                      </span>
                      <span v-else>
                        View on Instagram
                        <v-icon right>mdi-instagram</v-icon>
                      </span>
                      </v-btn>
                    </div>
                  </td>
                </template>
              </v-data-table>
            </td>
          </template>
          <!-- Expanded Item Section -->
          <template slot="body.append">
            <tr>
              <th class="text-center font-weight-bold"><strong>Total</strong></th>
              <th class="text-center"></th>
              <th class="text-center"></th>
              <th class="text-center font-weight-bold">{{totalCounts.contents | thousandSeprator}}</th>
              <th class="text-center"></th>
              <th class="text-center"></th>
              <th class="text-center font-weight-bold">{{summary.outreach | thousandSeprator}}</th>
              <th class="text-center"></th>
              <th class="text-center font-weight-bold"></th>
              <th class="text-center"></th>
              <th class="text-center"></th>
            </tr>
          </template>
        </v-data-table>
      </div>
      <!-- End of Table View -->
    </div>
    <div v-if="selectedCampaignID">
      <!-- <line-chart v-if="!isLoading" :chart-data="reportChartData" :options="options" /> -->
      <report-payout-lists :campaignID="selectedCampaignID" />
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
    <add-post-to-campaign
      :selectedPostIds="selectedPostIds"
      v-model="addPostToCampaign"
      :value="addPostToCampaign"
      :campaign="campaignDataView"
      :campaignPayouts="campaignPayouts"
      @done="quickReload()"
      @addedReport="addReportManually"
    ></add-post-to-campaign>
    <view-campaign-modal
      v-model="viewCampaignModalDialog"
      :value="viewCampaignModalDialog"
      :campaignData="viewCampaignData"
    ></view-campaign-modal>
    <update-insights-modal
      v-model="postInsightdialog"
      :value="postInsightdialog"
      :post="updatePostInsightsData"
      :campaign="campaignData"
      @done="quickReload()"
      :imagesToView="campaignPayout"
    ></update-insights-modal>
    <!-- Report Group Modal -->
    <report-group-modal
    :selectedPosts="selectedPosts"
    :campaignID="selectedCampaignID"
    @saved="savedReportGroup"
    v-model="reportGroupDialog"/>
    <!-- Edit Report Handle Modal -->
    <edit-report-handle-modal 
    v-model="editReportHandleDialog"
    :report="editHandleReport"
    @saved="quickReload()"
    />
    <!-- Table Cols Show Hide Modal -->
    <table-cols-show-hide-modal
      v-model="colSettingsDialog"
      title="Table Settings"
      :items="tableColsItems"
      @updated="updateTableCols"
    />
    <campaign-settings
    :campaign="campaignData"
    @saved="quickReload()"
    v-model="campaignSettingsDialog" />
    <v-dialog 
      v-model="isScrapLoading" 
      persistent 
      width="300"
    >
      <v-card 
        color="primary" 
        dark
      >
        <v-card-text class="pa-4 text-center">
          <v-progress-linear
            indeterminate
            color="white"
            height="6"
            class="mb-3"
          ></v-progress-linear>
          <div class="subtitle-1" style="color:white;">{{ scrapingStatusMessage }}</div> 
        </v-card-text>
      </v-card>
    </v-dialog>
    <view-post-comments-modal
      :value="viewCommentsDialog"
      :comments="selectedPostComments"
      @close="viewCommentsDialog = false"
    />
  </div>
</template>

<script>
/* eslint-disable */
import LineChart from '../../charts/LineChart.js';
import moment from 'moment'
import utils from '../../../utils';
import config from '../../../config';
import campaignConfig from './config';
import campaignAPIs from './campaignAPIs';
import influencerAPIs from '../Influencer/influencerAPIs';
import campaignHelper from './campaignHelper';
import { getReportPlatform, getReportProfileUrl, isLinkedInReport as reportIsLinkedIn, isTwitterReport as reportIsTwitter } from '@/utils/reportPlatform'
import Loading from 'vue-loading-overlay';
import AddPostToCampaign from '../../scoped/campaign/AddPostToCampaign';
import GDrivePostView from '../../scoped/gdrive/GDrivePostView';
import EditReportHandleModal from '../../scoped/campaign/EditReportHandleModal';
import 'vue-loading-overlay/dist/vue-loading.css';
import ViewCampaignModal from './ViewCampaignModal';
import UpdateInsightsModal from '../../scoped/campaign/UpdateInsightsModal';
import ReportGroupModal from './ReportGroupModal'
import CampaignSummary from '../../reports/CampaignSummary';
import CustomMedia from '../../scoped/custom/CustomMedia';
import InstagramPostEmbed from '../../reports/InstagramPostEmbed.vue'
import ReportPayoutLists from './ReportInternal/ReportPayoutLists'
import ReportForSummary from '../../reports/ReportForSummary.vue'
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import CampaignSettings from './CampaignSettingsModal';
import userAPIs from '../User/userAPIs';
import draggable from 'vuedraggable'
import { mapState, mapGetters } from 'vuex';
// NEW IMPORT
import ViewPostCommentsModal from './ReportInternal/ViewPostCommentsModal';
// Default SortableJS
import Sortable from 'sortablejs'
export default {
  components: { InstagramPostEmbed, LineChart, Loading, AddPostToCampaign, ViewPostCommentsModal, ViewCampaignModal, TableColsShowHideModal, UpdateInsightsModal, ReportGroupModal, EditReportHandleModal, CampaignSettings, CampaignSummary, draggable, GDrivePostView, CustomMedia, ReportPayoutLists, ReportForSummary },
  data() {
    return {
      postInsightdialog: false,
      campaignSettingsDialog: false,
      updatePostInsightsData: null,
      respData: null,
      // Chart settings
      reportChartData: {
        labels: [],
        datasets: []
      },
      options: {
        fill: false,
        responsive: true,
        maintainAspectRatio: false
      },
      // keep the selected post id to avoid duplicated
      selectedPostIds: new Map(),
      // Posts of campaigns
      posts: [],
      filteredPosts: [],
      postTypes: campaignHelper.getDeliverableNames(),
      postType: '',
      // Use for add post modal
      campaignDataView: null,
      campaignData: null,
      viewCampaignData: null,
      viewCampaignModalDialog: false,
      reportHistory: [],
      client: {},
      addPostToCampaign: false,
      // Current report
      summary: {},
      isLoading: false,
      display: '',
      // List ongoing campaings
      campaignList: [],
      // Current selected campaign
      selectedCampaignID: null,
      // Drag and Drop Items
      lineUpItems: [],
      lineUpGroupItems: [],
      campaignPayouts: [],
      campaignPayout: null,
      payoutUploads: [],
      disableSaveArrange: true,
      swtRevenue: 'content',
      revenueSubText: 'by content',
      headers: [
        {value: 'instagram', text: 'Handle', sortable: true, class: 'report-handle-column', cellClass: 'report-handle-column'},
        {value: 'media_url', text: 'Content Link', sortable: true},
        {value: 'typeName', text: 'Content Type', sortable: true},
        {value: 'live_date', text: 'Live Date', sortable: true},
        {value: 'outreach', text: 'Outreach', sortable: true},
        {value: 'due_date', text: 'Due Date', sortable: true},
        {value: 'tier', text: 'Tier', sortable: true},
        {value: 'engagement', text: 'Engagement', sortable: true},
        {value: 'newEngagementRate', text: 'Engagement Rate (by Outreach)', sortable: true},
        {value: 'engagementRateSD', text: 'Avg. Engagement Rate', sortable: true},
        {value: 'medianEngagement', text: 'Median Engagement Rate', sortable: true},
        {value: 'avgLikes', text: 'Average Likes', sortable: true},
        {value: 'avgComments', text: 'Average Comments', sortable: true},
        {value: 'avgWatchTime', text: 'Average Watch Time', sortable: true},
        {value: 'avgViews', text: 'Average Views', sortable: true},
        {value: 'plays', text: 'Total Play Time', sortable: true},
        {value: 'likes', text: 'Likes', sortable: true},
        {value: 'comments', text: 'Comments', sortable: true},
        {value: 'bookmarks', text: 'Bookmarks', sortable: true},
        {value: 'shares', text: 'Shares', sortable: true},
        {value: 'views', text: 'Plays', sortable: true},
        {value: 'impressions', text: 'Impressions', sortable: true},
        {value: 'reach', text: 'Accounts reached', sortable: true},
        {value: 'storyExits', text: 'Story Exits', sortable: true},
        {value: 'storyImpressions', text: 'Story Impressions', sortable: true},
        {value: 'storyReach', text: 'Story Reach', sortable: true},
        {value: 'storyReplies', text: 'Story Replies', sortable: true},
        {value: 'storyTapsBack', text: 'Story Taps Back', sortable: true},
        {value: 'storyTapsForward', text: 'Story Taps Forward', sortable: true},
        {value: 'storyShares', text: 'Story Shares', sortable: true},
        {value: 'storyLinkClicks', text: 'Story Link Clicks', sortable: true},
        {value: 'storyStickerTaps', text: 'Story Sticker Taps', sortable: true},
        {value: 'playRateByOutreach', text: 'Play Rate (by Outreach)', sortable: true},
        {value: 'interactionRatePlays', text: 'Engagement Rate by Plays', sortable: true},
        {value: 'engRateReach', text: 'Engagement Rate (by Account Reached)', sortable: true},
        // {value: 'amount', text: 'Amount', sortable: true},
        // {value: 'bank_reference', text: 'Bank Reference', sortable: true},
        // {value: 'ims_status', text: 'IMS Status', sortable: true},
        {value: 'payment_status', text: 'Payment Status', sortable: true},
        { value: 'action', text: 'Actions', sortable: false, groupable: false }
      ],
      defaultHideCols: [
        'tier',
        'engagement',
        'newEngagementRate',
        'engagementRateSD',
        'medianEngagement',
        'avgLikes',
        'avgComments',
        'avgWatchTime',
        'avgViews',
        'plays',
        'likes',
        'comments',
        'bookmarks',
        'shares',
        'views',
        'impressions',
        'reach',
        'storyExits',
        'storyImpressions',
        'storyReach',
        'storyReplies',
        'storyTapsBack',
        'storyTapsForward',
        'storyShares',
        'storyLinkClicks',
        'storyStickerTaps',
        'playRateByOutreach',
        'interactionRatePlays',
        'engRateReach'
      ],
      selectedPosts: [],
      liveDates: [],
      imsStatuses: campaignConfig.imsStatuses,
      totalCounts: {
        contents: 0,
        outreach: 0,
        amount: 0
      },
      reportGroupDialog: false,
      disableSaveEdit: true,
      searchFilter: '',
      campaignHelper,
      cldConfig: config.cldConfig,
      cld: null,
      searchMonth: '',
      selectedMonth: '',
      monthPicker: false,
      reviewers: new Set(),
      editReportHandleDialog: false,
      editHandleReport: null,
      tableColsItems: [],
      colStatuses: {},
      colSettingsDialog: false,
      // --- New Data Properties for Scraping ---
      scrapedCommentsDialog: false, // Still needed for internal logic, even if the "View" button is removed
      currentScrapedComments: null,
      currentPostToScrape: null,
      // Renamed global scraping status flag
      isScrapLoading: false, 
      // This property will hold the status message (replaces localStorage)
      scrapingStatusMessage: '',
      // ----------------------------------------
      // --- NEW: Comments Dialog States ---
      viewCommentsDialog: false, // Toggles visibility of the new dialog
      selectedPostComments: [], // Data bound to the new dialog
      // -----------------------------------
    };
  },
  watch: {
    selectedCampaignID(value) {
      this.getCampaignReport(value, false);
      this.getAllCampaignPayouts()
    },
    display(oldValue, newValue) {
      if (oldValue !== '' && newValue !== '') {
        if (newValue === 1) {
          this.setPostIds()
        }
      }
    }
  },
  async mounted() {
    // this.cld = window.cloudinary.Cloudinary.new({ cloud_name: this.cldConfig.CLOUD_NAME });
    this.init();
    this.fetchCampaignList();
    await this.getUserProfile()
    /* eslint-env jquery */
    // setInterval(() => {
    //   $('.report__table').hover(function() {
    //     // console.log(true)
    //     console.log($('.v-data-table__wrapper').scrollLeft())
    //     $('.v-footer-wrapper').scrollLeft($('.v-data-table__wrapper').scrollLeft())
    //     // if($('.v-data-table__wrapper').scrollLeft() >= 25) {
    //     // }
    //   });
    // }, 100)
  },
  methods: {
    isLinkedInReport(post) {
      return reportIsLinkedIn(post)
    },
    isTwitterReport(post) {
      return reportIsTwitter(post)
    },
    getAccountProfileUrl(post) {
      return getReportProfileUrl(post, getReportPlatform(post) || (post.isTikTok ? 'tiktok' : 'instagram'))
    },
    getLinkedInProfileUrl(handle) {
      const value = String(handle || '').trim()
      if (/^https?:\/\/(?:www\.)?linkedin\.com\/in\//i.test(value)) return value
      const profileMatch = value.match(/(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([^/?#]+)/i)
      const profileHandle = (profileMatch ? profileMatch[1] : value)
        .replace(/^@+/, '')
        .replace(/^\/+|\/+$/g, '')
      return profileHandle ? `https://www.linkedin.com/in/${encodeURIComponent(profileHandle)}` : '#'
    },
    getReportPostUrl(post) {
      if (!post) return ''
      const rawUrl = post.postLink || post.postURL || post.post_details || ''
      return typeof rawUrl === 'string'
        ? rawUrl
        : (rawUrl.link || rawUrl.url || rawUrl.href || '')
    },
    getLinkedInEmbedUrl(post) {
      if (!post) return ''
      const postUrl = this.getReportPostUrl(post)
      if (!postUrl) return ''
      if (/^https:\/\/www\.linkedin\.com\/embed\/feed\/update\//i.test(postUrl)) return postUrl
      let decodedUrl = postUrl
      try {
        decodedUrl = decodeURIComponent(postUrl)
      } catch (error) {
        decodedUrl = postUrl
      }
      const urnMatch = decodedUrl.match(/urn:li:(activity|share|ugcPost):(\d+)/i)
      const publicPostMatch = decodedUrl.match(/\/posts\/[^?#]*-(activity|share|ugcPost)-(\d+)(?:-[^/?#]+)?\/?(?:[?#]|$)/i)
      const postIdentifier = urnMatch || publicPostMatch
      if (!postIdentifier) return ''
      const urnType = postIdentifier[1].toLowerCase() === 'ugcpost' ? 'ugcPost' : postIdentifier[1].toLowerCase()
      return `https://www.linkedin.com/embed/feed/update/urn:li:${urnType}:${postIdentifier[2]}`
    },
    getTwitterEmbedUrl(post) {
      if (!post) return ''
      const postUrl = this.getReportPostUrl(post)
      const match = String(postUrl).match(/(?:x|twitter)\.com\/[^/?#]+\/status\/(\d+)/i)
      return match ? `https://platform.twitter.com/embed/Tweet.html?id=${match[1]}&theme=dark` : ''
    },
    MEDIA_URL_TYPE(mediaUrl) {
      const videos = ['mp4', 'MP4', 'mov', 'MOV', '3gp', '3GP', 'ogg', 'OGG', 'mpeg4', 'MPEG4']
      const images = ['jpg', 'JPG', 'jpeg', 'JPEG,', 'gif', 'GIF', 'png', 'PNG', 'svg', 'SVG', 'webp', 'WEBP']
      if (!mediaUrl) return ''
      if (!mediaUrl.includes('http') || !mediaUrl.includes('.com') || !mediaUrl.includes('www')) return ''
      const url = new URL(mediaUrl)
      const extension = url.pathname.split('.')[4] // our media url come with long lengh and array[4] only return the extension
      if (videos.includes(extension)) {
        return 'video'
      } else if (images.includes(extension)) {
        return 'image'
      } else if (url.hostname === 'drive.google.com') {
        if (campaignHelper.isAOKCampaign(this.campaignData.campaignType)) {
          return 'driveView'
        }
        return 'iframe'
      } else if (url.hostname === 'res.cloudinary.com') {
        return 'cld'
      }
    },
    updatePostInsightsHandler(post) {
      this.updatePostInsightsData = post
      this.campaignPayout = null
      if (this.campaignPayouts) {
        this.campaignPayouts.forEach(cPayout => {
          if (cPayout.handle === post.instagram || cPayout.influencerID === post.influencerID) {
            this.campaignPayout = cPayout
          }
        })
        // this.campaignPayouts.forEach(cPayout => {
        //   if (cPayout.deliverablePosts) {
        //     cPayout.deliverablePosts.forEach(element => {
        //       if (element.type === 'TTP') {
        //         element.posts.forEach(elementPost => {
        //           elementPost.images.forEach(elementImage => {
        //             if (elementImage.url) {
        //               this.payoutUploads.push(elementImage.url)
        //             }
        //           })
        //         })
        //       }
        //     })
        //   }
        // })
      }
      this.postInsightdialog = true
    },
    init() {
      this.summary = {
        outreach: 0,
        engagement: 0,
        revenue: 0,
        contents: 0,
        contents_percentage: 0,
        revenue_percentage: 0,
        outreach_percentage: 0,
        engagement_percentage: 0
      };
      this.postTypes.unshift({name: '', title: 'All'})
    },
    removeContent(postID) {
      if (postID) {
        this.$swal({
          title: 'Please Confirm',
          text: 'Do you want to remove it from the report?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, remove it!'
        }).then((result) => {
          if (result.value) {
            campaignAPIs
              .deleteContentFromReport(postID)
              .then(() => {
                this.$swal({
                  title: 'Success',
                  text: 'Removed Successfully from report',
                  type: 'success'
                });
                this.quickReload()
              })
              .catch(err => {
                this.$swal({
                  title: 'Error',
                  text: err,
                  type: 'error'
                });
                console.log('error')
              })
          }
        })
      }
    },
    addPost() {
      this.addPostToCampaign = true;
      this.campaignDataView = Object.assign({}, this.campaignData);
    },
    quickReload() {
      this.getCampaignReport(this.selectedCampaignID, false);
    },
    async addReportManually(reports) {
      reports = this.normalizeReportRows(reports)
      if (!reports.length) return false
      this.posts.push(...reports)
      this.setPostIds()
      this.filteredPosts = this.posts.map(p => p)
    },
    postChanged(isChanged) {
      if (isChanged) {
        this.quickReload()
      }
    },
    fetchCampaignList() {
      campaignAPIs
        .getAllCampaignsNoStatus() // In future, Campaign status could be change
        .then(response => {
          // let results = [];
          let campaigns = response
          campaigns = campaigns.filter(c => (c.status === config.campaignStatus.ONGOING ||
          c.status === config.campaignStatus.PAIRING_INFLUENCER ||
          c.status === config.campaignStatus.REVIEW ||
          c.status === config.campaignStatus.COMPLETE))
          this.campaignList = campaigns.map(element => {
            // let campaign = {
            //   name: element.name,
            //   id: element.id
            // };
            // results.push(campaign);
            return {
              name: element.ioNumbers ? `${element.ioNumbers} - ${element.name}` : element.name,
              id: element.id
            };
          });
          // this.campaignList = results.sort((a, b) => {
          //   if (a.name > b.name) {
          //     return -1;
          //   }
          //   if (a.name < b.name) {
          //     return 1;
          //   }
          //   return 0;
          // });
          if (this.$route.query.id) {
            this.selectedCampaignID = this.$route.query.id
            this.quickReload()
          }
        })
        .catch(err => {
          console.log('Error:' + err);
        });

      // campaignAPIs
      //   .getAllCampaigns(config.campaignStatus.COMPLETE, true) // Add Complete Campaign List
      //   .then(response => {
      //     response.data.campaigns.forEach(element => {
      //       let completeCampaign = {
      //         name: element.name,
      //         id: element.id
      //       };
      //       this.campaignList.push(completeCampaign)
      //     });
      //   })
      //   .catch(err => {
      //     console.log('Error:' + err);
      //   });
    },
    generateChart() {
      // Reset the chart
      let labels = [];
      let datasets = [];
      let history = Object.assign(this.reportHistory);
      history.push({ report_date: utils.func.getDate(), data: Object.assign({}, this.summary) });
      let engagements = [];
      let outreaches = [];
      let revenues = [];
      history.forEach(report => {
        labels.push(report.report_date);
        let data = report.data;
        engagements.push(data.engagement);
        outreaches.push(data.outreach);
        revenues.push(data.revenue);
      });
      let engagementDataset = {
        label: 'Engagement',
        fill: false,
        borderColor: '#64dd17',
        data: engagements
      };
      let outreachDataset = {
        label: 'Outreach',
        fill: false,
        borderColor: '#0094cc',
        data: outreaches
      };
      let revenueDataset = {
        label: 'Revenue',
        fill: false,
        borderColor: '#ff3d00',
        data: revenues
      };
      datasets.push(engagementDataset);
      datasets.push(outreachDataset);
      datasets.push(revenueDataset);
      // Display the current chart value
      this.reportChartData.labels = Object.assign([], labels);
      this.reportChartData.datasets = Object.assign([], datasets);
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    exportPDF(campaignID, campaignName, force) {
      this.isLoading = true;
      campaignAPIs
        .generateCampaignReportPDF(campaignID, campaignName, force)
        .then(() => {
          this.isLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            title: 'Error',
            text: error,
            type: 'error'
          });
          this.isLoading = false;
        });
    },
    refreshReportInf(reportID = null) {
      this.isLoading = true;
      campaignAPIs
        .generateCampaignReport(this.selectedCampaignID, null, true, 'json', reportID)
        .then(async response => {
          if (response && response.success) {
            this.getCampaignReport(this.selectedCampaignID, false, 'json', null)
          }
        })
        .catch(error => {
          this.isLoading = false;
          console.error(error);
        });
    },
    getCampaignReport(campaignID, force = false, format = 'json', reportID = null) {
      this.isLoading = true;
      campaignAPIs
        .generateCampaignReport(campaignID, null, force, format, reportID)
        .then(async response => {
          if (response && response.success) {
            let data = this.normalizeCampaignReportData(response.data)
            this.respData = data;
            this.summary = Object.assign({}, data.summary);
            if (this.summary.outreach) {
              this.summary.outreach = Number(this.summary.outreach)
            }
            // this.posts = Object.assign([], data.posts).sort((a, b) => b.success - a.success);
            this.posts = [];
            this.posts = data.posts.sort((a, b) => a.lineUpIndex - b.lineUpIndex);
            this.campaignData = Object.assign({}, data.campaign_details);
            this.campaignData.angles = this.campaignData.angles ? campaignHelper.fixAnglesData(this.campaignData.angles) : []
            this.campaignData.segment = this.campaignData.segment || campaignHelper.getDefaultSegments()
            this.campaignData.lineUp = this.campaignData.lineUp || []
            this.campaignData.startDate = this.campaignData.startDate || ''
            this.campaignData.endDate = this.campaignData.endDate || ''
            this.campaignData.optionalRemarks = this.campaignData.optionalRemarks || ''
            this.campaignData.AINotableComments = []
            if (this.campaignData.commentAnalysisResult) {
              this.campaignData.AINotableComments = this.campaignData.commentAnalysisResult.notableComments
            }
            this.reportHistory = Object.assign([], data.report_history);
            this.client = Object.assign({}, data.client);
            this.generateChart();
            this.switchRevenue();
            this.isLoading = false;
            this.setFilteredReports()
            await this.setPostIds();
            await this.setMultipleInfs();
            // await this.setIGPosts();
            this.isLoading = true;
            this.isLoading = false;
            this.setPostTypes();
            this.selectedPosts = []
            this.filteredPosts = []
            this.filteredPosts = this.posts.map(p => p)
            // this.display = 1
            /* eslint-env jquery */
            setInterval(() => {
              $('.v-data-table__wrapper').scroll(function() {
                $('.v-footer-wrapper').scrollLeft($('.v-data-table__wrapper').scrollLeft())
              });
            }, 1000)
          } else {
            this.resetCampaignReportData()
            this.$swal({
              title: 'Error',
              text: (response && response.message) || 'Unable to load campaign report',
              type: 'error'
            });
          }
        })
        .catch(error => {
          this.resetCampaignReportData()
          this.isLoading = false;
          console.error(error);
        });
    },
    normalizeCampaignReportData(data) {
      data = data || {}
      return {
        summary: data.summary || {},
        posts: this.normalizeReportRows(data.posts),
        campaign_details: data.campaign_details || {},
        report_history: Array.isArray(data.report_history) ? data.report_history : [],
        client: data.client || {}
      }
    },
    normalizeReportRows(posts) {
      if (!Array.isArray(posts)) return []
      return posts.filter(Boolean).map(post => {
        const normalizeLinkedInReport = report => {
          const platform = getReportPlatform(report)
          const normalizePostUrl = value => {
            if (typeof value === 'string') return value
            if (!value || typeof value !== 'object') return ''
            return value.link || value.url || value.href || ''
          }
          const isLinkedIn = platform === 'linkedin'
          const isTwitter = platform === 'twitter'
          if (isLinkedIn) {
            const insightHistory = Array.isArray(report.insights) ? report.insights : []
            const latestInsight = insightHistory[insightHistory.length - 1]
            const insights = latestInsight && latestInsight.data ? latestInsight.data : (report.insights || {})
            report.insightHistory = insightHistory
            report.insights = insights
            report.platform = 'linkedin'
            report.postType = report.postType || 'LIP'
            report.typeName = 'LinkedIn Post'
            report.currentInsight = Object.assign({}, report.currentInsight || {}, {
              like_count: insights.like_count != null ? insights.like_count : (report.currentInsight || {}).like_count,
              comment_count: insights.comment_count != null ? insights.comment_count : (report.currentInsight || {}).comment_count,
              impressions: insights.impressions != null ? insights.impressions : (report.currentInsight || {}).impressions,
              reach: insights.reach != null ? insights.reach : (insights.outreach != null ? insights.outreach : (report.currentInsight || {}).reach),
              saved: insights.saved != null ? insights.saved : (insights.bookmarks != null ? insights.bookmarks : (report.currentInsight || {}).saved)
            })
            report.inputtedInsights = Object.assign({}, report.inputtedInsights || {}, {
              shares: insights.shares != null ? insights.shares : (report.inputtedInsights || {}).shares,
              saved: insights.saved != null ? insights.saved : (insights.bookmarks != null ? insights.bookmarks : (report.inputtedInsights || {}).saved),
              impressions: insights.impressions != null ? insights.impressions : (report.inputtedInsights || {}).impressions,
              reach: insights.reach != null ? insights.reach : (insights.outreach != null ? insights.outreach : (report.inputtedInsights || {}).reach),
              video_views: insights.video_views != null ? insights.video_views : (report.inputtedInsights || {}).video_views,
              profile_viewers: insights.profile_viewers != null ? insights.profile_viewers : (report.inputtedInsights || {}).profile_viewers
            })
            report.postLink = normalizePostUrl(report.postURL) ||
              normalizePostUrl(report.postLink) ||
              normalizePostUrl(report.post_details) || ''
            if (!report.type || report.type === 'Others' || report.type === 'Other Post') {
              report.type = 'LinkedIn Post'
            }
          }
          if (isTwitter) {
            const insightHistory = Array.isArray(report.insights) ? report.insights : []
            const latestInsight = insightHistory[insightHistory.length - 1]
            const insightData = latestInsight && latestInsight.data ? latestInsight.data : (report.insights || {})
            const insights = Object.assign({}, insightData, report.currentInsight || {}, report.inputtedInsights || {})
            report.insightHistory = insightHistory
            report.insights = insights
            report.platform = 'twitter'
            report.postType = report.postType || 'XTP'
            report.typeName = 'X (Twitter) Post'
            report.type = 'X (Twitter) Post'
            report.currentInsight = Object.assign({}, report.currentInsight || {}, {
              like_count: insights.like_count != null ? insights.like_count : (report.currentInsight || {}).like_count,
              comment_count: insights.comment_count != null ? insights.comment_count : (report.currentInsight || {}).comment_count,
              impressions: insights.impressions != null ? insights.impressions : (insights.views != null ? insights.views : (report.currentInsight || {}).impressions),
              views: insights.views != null ? insights.views : (report.currentInsight || {}).views
            })
            report.inputtedInsights = Object.assign({}, report.inputtedInsights || {}, {
              shares: insights.shares != null ? insights.shares : (report.inputtedInsights || {}).shares,
              saved: insights.saved != null ? insights.saved : (report.inputtedInsights || {}).saved,
              impressions: insights.impressions != null ? insights.impressions : (insights.views != null ? insights.views : (report.inputtedInsights || {}).impressions),
              views: insights.views != null ? insights.views : (report.inputtedInsights || {}).views
            })
            report.postLink = normalizePostUrl(report.postURL) ||
              normalizePostUrl(report.postLink) ||
              normalizePostUrl(report.post_details) || ''
          }
          return report
        }
        if (post.reportGroup) {
          post.reports = Array.isArray(post.reports) ? post.reports.filter(Boolean).map(normalizeLinkedInReport) : []
          post.filteredReports = Array.isArray(post.filteredReports)
            ? post.filteredReports.filter(Boolean).map(normalizeLinkedInReport)
            : post.reports.map(report => report)
        }
        return normalizeLinkedInReport(post)
      })
    },
    resetCampaignReportData() {
      this.respData = null
      this.summary = {}
      this.posts = []
      this.filteredPosts = []
      this.reportHistory = []
      this.client = {}
      this.isLoading = false
    },
    async setPostIds() {
      this.selectedPosts = []
      this.reviewers = new Set()
      this.totalCounts.contents = 0
      this.totalCounts.amount = 0
      this.selectedPostIds = new Map(); // Init new map
      for (let element of this.posts) {
        if (!element) continue
        element.searchable = ''
        if (element.reportGroup) {
          element.panel = [0]
          element.typeName = ''
          let reports = Array.isArray(element.reports) ? element.reports : []
          for (let elementOne of reports) {
            this.reviewers.add(elementOne.instagram ? elementOne.instagram.toLowerCase() : '')
            element.typeName += ` ${elementOne.instagram} ${elementOne.typeName} `
            elementOne = this.beautifyPostData(elementOne)
          }
        } else {
          this.reviewers.add(element.instagram ? element.instagram.toLowerCase() : '')
          element.searchable += `${element.instagram} ${element.typeName} `
          element = this.beautifyPostData(element)
        }
      }
      this.totalCounts.amount = parseFloat(this.totalCounts.amount).toFixed(2)
    },
    async setFilteredReports() {
      // set post types
      for (let element of this.posts) {
        if (element.reportGroup) {
          let reports = Array.isArray(element.reports) ? element.reports : []
          element.filteredReports = reports.map(r => r)
        }
      }
    },
    async setPostTypes() {
      // set post types
      for (let element of this.posts) {
        if (element.reportGroup) {
          let reports = Array.isArray(element.reports) ? element.reports : []
          for (let elementOne of reports) {
            elementOne = await this.getPostType(elementOne)
          }
          element.filteredReports = reports.map(r => r)
        } else {
          element = await this.getPostType(element)
        }
      }
    },
    async getPostType(elementOne) {
      let storyInsights = {
        impressions: 0,
        reach: 0,
        replies: 0,
        exits: 0,
        taps_back: 0,
        taps_forward: 0,
        shares: 0,
        link_clicks: 0,
        sticker_taps: 0
      }
      if (!elementOne.isStory && !elementOne.isTikTok && !elementOne.isYoutube && !elementOne.isOthers && !this.isLinkedInReport(elementOne) && !this.isTwitterReport(elementOne) && elementOne.post_details && elementOne.post_details.shortcode) {
        this.selectedPostIds.set(elementOne.post_details.shortcode, 1);
      } else if (elementOne.isTikTok && elementOne.post_details && elementOne.post_details.shortcode) {
        elementOne.tikTokPost = campaignHelper.getTikTokPost(elementOne.post_details.shortcode)
      } else if (elementOne.isYoutube && elementOne.post_details && elementOne.post_details.shortcode) {
        elementOne.youtubePost = campaignHelper.getYoutubePost(elementOne.post_details.shortcode)
      } else if (elementOne.isMultipleContents && !elementOne.insights) {
        elementOne.insights = Object.assign({}, storyInsights)
        // if (elementOne.media_type === 'video' && elementOne.public_id) {
        //   this.renderVideo(elementOne.public_id)
        // }
      }
      return elementOne
    },
    beautifyPostData(elementOne) {
      elementOne = this.setDefaultEditFields(elementOne)
      this.calculateTotals(elementOne)
      if (elementOne.live_date !== undefined && elementOne.live_date !== '' && elementOne.live_date !== null) {
        if (elementOne.live_date === 'Invalid date') {
          elementOne.live_date = ''
        }
        if (elementOne.live_date.includes('/')) {
          elementOne.live_date = this.parseDate(elementOne.live_date)
        }
        this.liveDates.push(this.refreshJSON(elementOne.live_date))
        elementOne.live_date = this.formatDate(elementOne.live_date)
      }
      if (elementOne.due_date === 'Invalid date') {
        elementOne.due_date = ''
      }
      elementOne.due_date = this.formatDate(elementOne.due_date)
    },
    exportExcel(campaignID, campaignName, force = false) {
      this.isLoading = true;
      campaignAPIs
        .generateCampaignReportExcel(campaignID, campaignName, force)
        .then(() => {
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error)
        })
    },
    exportExcelPosts(campaignID, campaignName, force = false) {
      this.isLoading = true;
      campaignAPIs
        .generateCampaignReportExcelonPosts(campaignID, campaignName, force)
        .then(() => {
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error)
        })
    },
    getCampaignDataToView(campaignID) {
      this.isLoading = true;
      campaignAPIs
        .getCampaign(campaignID)
        .then(response => {
          this.viewCampaignData = response;
          this.viewCampaignModalDialog = true;
          this.isLoading = false;
        })
        .catch(error => {
          this.viewCampaignModalDialog = false;
          console.log(error);
          this.isLoading = false;
        });
    },
    handleDragDropUpdate(items) {
      if (items.length === 0) {
        return;
      }
      let groupID = items[0].groupID
      if (groupID) {
        this.lineUpItems = this.posts.map(p => {
          if (p.id === groupID) {
            p.reports = Array.isArray(items) ? items : []
          }
          return p
        })
      } else {
        this.lineUpItems = items
      }
      this.disableSaveArrange = false
    },
    handleDataTableDragDrop(event, items) {
      // check and save drag n drop update for table items/ grouped items
      if (items.length === 0) {
        return;
      }
      let tmpPosts = []
      let groupID = items[0].groupID
      if (groupID) {
        let group = this.posts.find(p => p.id === groupID)
        if (group) {
          tmpPosts = Array.isArray(group.reports) ? group.reports : []
        }
      } else {
        tmpPosts = this.posts
      }
      const movedItem = tmpPosts.splice(event.oldIndex, 1)[0]
      tmpPosts.splice(event.newIndex, 0, movedItem)
      if (groupID) {
        this.posts = this.posts.map(p => {
          if (p.id === groupID) {
            p.reports = tmpPosts.map(tmp => tmp)
          }
          return p
        })
      } else {
        this.posts = tmpPosts.map(tmp => tmp)
      }
      this.lineUpItems = []
      this.lineUpItems = this.posts
      this.disableSaveArrange = false
    },
    viewReport() {
      // this.updateLineUp()
      let routeData = this.$router.resolve({name: 'CampaignSummaryReports', query: { id: this.selectedCampaignID }})
      window.open(routeData.href, '_blank')
    },
    viewPayoutsReport() {
      let routeData = this.$router.resolve({name: 'Payouts Report', query: { id: this.selectedCampaignID }})
      window.open(routeData.href, '_blank')
    },
    async updateLineUp() {
      await this.lineUpItems.map((item, index) => {
        let data = {}
        if (item.reportGroup) {
          data.groupID = item.id
          data.lineUpIndex = index
          let reports = Array.isArray(item.reports) ? item.reports : []
          data.posts = reports.map((element, rindex) => {
            return Object.assign({}, { id: element.id, lineUpIndex: rindex })
          })
        } else {
          data = {
            reportID: item.id,
            campaignID: item.campaignID,
            lineUpIndex: index
          }
        }
        campaignAPIs.updateLineUpIndex(data)
      })
      this.$swal.fire({
        type: 'success',
        title: 'Saved!',
        showCancelButton: false,
        width: 300
      });
    },
    saveLineUp() {
      this.updateLineUp()
    },
    switchRevenue() {
      if (this.campaignData.revenueCalculation !== undefined) {
        if (this.campaignData.revenueCalculation === 'engagement') {
          this.swtRevenue = 'engagement'
          this.revenueSubText = 'by engagement'
        } else {
          this.swtRevenue = 'content'
          this.revenueSubText = 'by contents'
        }
      } else {
        this.swtRevenue = 'engagement'
        this.revenueSubText = 'by engagement'
      }
    },
    selectAllPosts($event) {
      if (($event.value && $event.items.length === 0) || !$event.value) {
        this.selectedPosts = [];
        return;
      }
      if (this.selectedPosts.length === 0) {
        this.selectedPosts = $event.items.filter(item => {
          if (item.reportGroup) return false
          return true
        })
      } else {
        this.selectedPosts = [];
      }
    },
    openReportGroupModal() {
      this.reportGroupDialog = true
    },
    deleteReportGroup(groupID, groupName) {
      // Display confirmation box
      this.$swal({
        title: 'Deleting',
        text: `Are you sure you want to delete this group (${groupName})?`,
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return campaignAPIs
            .deleteReportGroup(groupID)
            .then(response => {
              return response
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)

              // Show error message
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin')
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.quickReload()

          // Show success message
          this.$swal({
            title: 'Deleted',
            text: 'The group has been deleted successfully',
            type: 'success'
          })
        } else {
          // Do nothing for now
        }
      })
    },
    savedReportGroup() {
      this.selectedPosts = []
      this.quickReload()
    },
    getPaymentStatus(statusVal) {
      let statusText = 'Please Confirm Payout'
      Object.entries(this.paymentStatuses).forEach(item => {
        if (statusVal === item[1].value) {
          statusText = item[1].text
        }
      });
      return statusText
    },
    getIMSStatus(statusVal, paymentStatusVal) {
      if (this.imsStatuses.NEW.value === statusVal) {
        if (paymentStatusVal) {
          return '-'
        }
        return this.imsStatuses.NEW.text
      } else if (this.imsStatuses.SUBMITTED.value === statusVal) {
        return this.imsStatuses.SUBMITTED.text
      } else if (this.imsStatuses.NOT_SUBMITTED.value === statusVal) {
        return this.imsStatuses.NOT_SUBMITTED.text
      }
      return '-'

      // let item = '-'
      // Object.entries(this.imsStatuses).forEach(item => {
      //   if (item[1].value === statusVal) {
      //     item = item[1].text
      //     console.log(item)
      //   }
      // });
      // return item
    },
    openEditItem(item, itemName) {
      // if (item.payment_status === this.paymentStatuses.PROCESSING.value) {
      //   // disable edit in payment status and amount
      //   if (itemName === 'amount') {
      //     return false
      //   }
      // }
      item[itemName + 'Edit'] = true
      item.editReport = true
      this.posts = this.refreshJSON(this.posts)
      this.disableSaveEdit = false
      this.selectedPosts = []
    },
    saveEditingData() {
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.isEditing = true;
          let data = this.filteredPosts.filter(item => item.editReport && item.editReport === true)
          let groupedPosts = this.filteredPosts.filter(item => item.reportGroup && item.reportGroup === true)
          // for grouped posts
          groupedPosts.map(p => {
            let reports = Array.isArray(p.reports) ? p.reports : []
            reports.map(rp => {
              data.push(rp)
            })
          })
          data = data.map(item => {
            return Object.assign({}, {
              id: item.id,
              live_date: item.live_date,
              due_date: item.due_date,
              amount: item.amount,
              ims_status: item.ims_status,
              payment_status: item.payment_status,
              type: item.type
            })
          })
          // Submit request to save edited report data
          campaignAPIs
          .saveEditedReportData(data)
          .then(response => {
            // Update submitting status
            this.isEditing = false;
            this.cancelEdit()
            this.setPostIds()
            // Show success message
            this.$swal({
              text: 'Report Updated',
              type: 'success'
            });
          })
          .catch(error => {
            // Update submitting status
            this.isEditing = false;
            // Request failed.
            console.log('error', error);
            this.$swal({
              text: error,
              type: 'error'
            });
          });
        }
      });
    },
    cancelEdit() {
      this.filteredPosts = this.filteredPosts.map(inf => {
        inf = this.setDefaultEditFields(inf)
        if (inf.reportGroup) {
          let reports = Array.isArray(inf.reports) ? inf.reports : []
          inf.reports = reports.map(infg => {
            infg = this.setDefaultEditFields(infg)
            return infg
          })
        }
        return inf
      })
      this.disableSaveEdit = true
    },
    setDefaultEditFields(obj) {
      obj.liveDateEdit = false;
      obj.dueDateEdit = false;
      obj.amountEdit = false;
      // obj.bankRefEdit = false;
      obj.imsStatusEdit = false;
      obj.paymentStatusEdit = false;
      obj.editReport = false;
      obj.liveCal = false;
      obj.dueCal = false;
      return obj;
    },
    refreshJSON(json) {
      return JSON.parse(JSON.stringify(json || []))
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      let formattedDate = `${day}/${month}/${year}`
      if (formattedDate.includes('undefined')) {
        return date
      }
      return formattedDate;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    customSearch (value, search, item) {
      return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search))
    },
    renderVideo(publicID) {
      this.cld.videoPlayer(`cloud-player-${publicID}`, {
        transformation: { width: 320, height: 400 }
      });
    },
    getMedia(post) {
      post.internalView = true
      if (post.isStory) {
        post.type = 'story'
        post.embed_url = post.media_url
      }
      return campaignHelper.customMediaConfig(post, this.campaignData.campaignType)
    },
    getFiltered() {
      this.filteredPosts = this.posts.map(post => {
        if (post.reportGroup) {
          let reports = Array.isArray(post.reports) ? post.reports : []
          post.filteredReports = reports.map(gprpt => gprpt)
        }
        return post
      })
      if (this.postType && this.postType.toLowerCase() !== 'all') {
        // filter by post type (IG Post, Story, etc...)
        this.filteredPosts = this.posts.filter(post => {
          if (post.reportGroup) {
            let hasReports = false
            let reports = Array.isArray(post.reports) ? post.reports : []
            post.filteredReports = reports.filter(gpPost => {
              if (gpPost.typeName === this.postType) {
                hasReports = true
                return true
              } else return false
            })
            return hasReports
          } else if (post.typeName === this.postType) {
            return true
          }
          return false
        })
        // filtered = filtered.filter(post => post.typeName === this.postType)
      }
      if (this.searchMonth) {
        // filtered by months
        let splitMonth = this.searchMonth.split('-')
        let searchText = `${splitMonth[1]}/${splitMonth[0]}`
        this.filteredPosts = this.posts.filter(post => {
          if (post.reportGroup) {
            let hasReports = false
            let reports = Array.isArray(post.reports) ? post.reports : []
            post.filteredReports = reports.filter(gpPost => {
              if (gpPost.live_date && gpPost.live_date.includes(searchText)) {
                hasReports = true
                return true
              } else return false
            })
            return hasReports
          } else if (post.live_date && post.live_date.includes(searchText)) {
            return true
          }
          return false
        })
      }
      if (this.searchFilter) {
        // filtered by keyword
        this.filteredPosts = this.posts.filter(post => {
          if (post.reportGroup) {
            let hasReports = false
            let reports = Array.isArray(post.reports) ? post.reports : []
            post.filteredReports = reports.filter(gpPost => {
              if (gpPost.instagram && gpPost.instagram.toLowerCase().includes(this.searchFilter)) {
                hasReports = true
                return true
              } else return false
            })
            return hasReports
          } else if (post.instagram && post.instagram.toLowerCase().includes(this.searchFilter)) {
            return true
          }
          return false
        })
      }
      // recalculate total amounts
      // if (isFiltered) {
      //   this.totalCounts.contents = 0
      //   this.totalCounts.amount = 0
      //   filtered.map(element => {
      //     if (element.reportGroup) {
      //       element.reports.map(elementOne => {
      //         this.calculateTotals(elementOne)
      //       })
      //     } else {
      //       this.calculateTotals(element)
      //     }
      //   })
      // }
    },
    calculateTotals(element) {
      this.totalCounts.contents += 1
      if (element.amountLocked !== true) {
        this.totalCounts.amount += Number(element.amount || 0)
      }
    },
    searchMonthOk() {
      this.$refs.monthPicker.save(this.searchMonth);
      this.getFiltered()
    },
    customSort: function(items, index, isDesc) {
      items.sort((a, b) => {
        if (!(isNaN(a[index[0]]))) {
          if (!isDesc[0]) {
            return (a[index[0]] - b[index[0]]);
          } else {
            return (b[index[0]] - a[index[0]]);
          }
        } else {
          if (!isDesc[0]) {
            return (a[index[0]] < b[index[0]]) ? -1 : 1;
          } else {
            return (b[index[0]] < a[index[0]]) ? -1 : 1;
          }
        }
      })
      this.lineUpItems = Object.assign([], items)
      this.disableSaveArrange = false
      return items;
    },
    openEditHandleModal(post) {
      this.editReportHandleDialog = true
      this.editHandleReport = Object.assign({}, post)
    },
    getFbPost(url) {
      if (!url) return ''
      if (/facebook\.com\/plugins\/post\.php/i.test(url)) return url
      return `https://www.facebook.com/plugins/post.php?href=${encodeURIComponent(url)}&show_text=true&width=500`
    },
    async setMultipleInfs() {
      for (let item of this.posts) {
        let infID = null
        let resp = await influencerAPIs.getInfluencerByHandles({
          searchHandles: [
            item.instagram
          ]
        })
        if (resp.length) {
          resp = resp[0]
          infID = resp.id
        }
        if (!infID) {
          continue
        }
        let infs = []
        await this.$store.dispatch('influencer/getInfluencerDetail', {
          id: infID
        })
        if (this.infDetail.instagram) {
          infs.push({
            reportID: item.id,
            platform: 'Instagram',
            handle: this.infDetail.instagram.instagramHandle,
            instagramID: this.infDetail.instagram.instagramID,
            picture: this.infDetail.audience ? this.infDetail.audience.user_profile.picture : this.infDetail.instagram.picture,
            instagram: true
          })
        }
        if (this.infDetail.tiktok) {
          infs.push({
            reportID: item.id,
            platform: 'TikTok',
            handle: this.infDetail.tiktok.tiktokHandle,
            tiktokID: this.infDetail.tiktok.tiktokID,
            picture: this.infDetail.tiktokaudience ? this.infDetail.tiktokaudience.user_profile.picture : this.infDetail.tiktok.picture,
            tiktok: true
          })
        }
        if (this.infDetail.youtube) {
          infs.push({
            reportID: item.id,
            platform: 'Youtube',
            handle: this.infDetail.youtube.youtubeHandle,
            youtubeID: this.infDetail.youtube.youtubeID,
            picture: this.infDetail.youtubeaudience ? this.infDetail.youtubeaudience.user_profile.picture : this.infDetail.youtube.picture,
            youtube: true
          })
        }
        if (this.infDetail.xiaohongshu) {
          infs.push({
            reportID: item.id,
            platform: 'Xiaohongshu',
            handle: this.infDetail.xiaohongshu.xhsHandle,
            xhsID: this.infDetail.xiaohongshu.xhsID,
            picture: this.infDetail.xiaohongshu ? this.infDetail.xiaohongshu.profilePicture : '',
            xhs: true
          })
        }
        if (this.infDetail.facebook) {
          infs.push({
            reportID: item.id,
            platform: 'Facebook',
            handle: this.infDetail.facebook.handle,
            xhsID: this.infDetail.facebook.facebookId,
            picture: this.infDetail.facebook ? this.infDetail.facebook.profilePicture : '',
            facebook: true
          })
        }
        if (this.infDetail.linkedin) {
          infs.push({
            reportID: item.id,
            platform: 'LinkedIn',
            handle: this.infDetail.linkedin.linkedinHandle,
            picture: '',
            linkedin: true
          })
        }
        item.multipleInfs = infs
      }
      this.posts = Object.assign([], this.posts)
    },
    async changePlatform(obj, index) {
      this.isLoading = true
      let saveData = Object.assign({}, {
        id: obj.reportID,
        handle: obj.handle,
        platform: obj.platform
      })
      await this.$store.dispatch('campaign/updateReportHandle', {
        updateData: saveData
      })
      this.isLoading = false
      if (this.updatedReport) {
        this.$swal({
          text: 'Successfully Updated.',
          type: 'success'
        }).then(result => {
          this.quickReload()
        })
      } else {
        this.$swal({
          text: 'Error Updating Handle!',
          type: 'error'
        })
      }
    },
    openColSettingsModal() {
      this.tableColsItems = []
      let tmpStatuses = {}
      if (Object.keys(this.colStatuses).length) {
        tmpStatuses = Object.assign({}, this.colStatuses)
      } else {
        this.headers.map(header => {
          tmpStatuses[header.value] = true
        })
      }
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.headers)) {
        if (value.text) {
          this.tableColsItems.push({
            title: value.text,
            key: value.value,
            value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
          })
        }
      }
      this.colSettingsDialog = true
    },
    async updateTableCols(items) {
      let columns = this.colStatuses
      items.map(item => {
        columns[item.key] = item.value
      })
      let tableSettings = {}
      if (this.userProfile.tableSettings) {
        tableSettings = this.userProfile.tableSettings
      }
      tableSettings.reportCols = Object.assign({}, columns)
      let updateData = {
        id: this.currentUserID,
        tableSettings
      }
      await userAPIs.editUser(updateData)
      // localStorage.setItem('MasterListCols', JSON.stringify(columns))
      this.colStatuses = Object.assign({}, columns)
      this.colSettingsDialog = false
    },
    async getUserProfile() {
      let resp = await userAPIs.getUser(this.currentUserID)
      if (resp && resp.id) {
        this.userProfile = resp
      }
    },
    getAllCampaignPayouts() {
      influencerAPIs
        .getAllCampaignPayouts({
          campaignID: this.selectedCampaignID
        })
        .then(async (response) => {
          this.campaignPayouts = response.data
          // For now, we only retrieve Instagram info
          this.campaignPayouts = this.campaignPayouts.map(element => {
            let resultData = {
              campaignName: element.campaignName,
              influencerID: element.influencerID,
              createdAt: element.createdAt,
              toMakePaymentAt: moment(element.createdAt).add(30, 'days').format(),
              payoutAmount: element.payoutAmount || '',
              // createdAt: moment(element.createdAt, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('DD-MM-YYYY HH:mm')
              images: element.images || [],
              posts: element.posts || [],
              stories: element.stories || [],
              deliverablePosts: element.deliverablePosts || []
            }
            if (element.tiktok) {
              resultData.handle = element.tiktok ? element.tiktok.tiktokHandle : ''
              resultData.platform = 'tiktok'
            } else {
              resultData.handle = element.instagram ? element.instagram.instagramHandle : ''
              resultData.platform = 'instagram'
              resultData.xhsID = element.xhsID || ''
            }
            if (!resultData.handle) {
              if (element.handle) {
                resultData.handle = element.handle
                resultData.platform = element.platform || 'instagram'
                resultData.xhsID = element.xhsID || ''
              }
            }
            return Object.assign(
              {
                id: element.id,
                campaignID: element.campaignID,
                postID: element.postID
              },
              resultData
            )
          })
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    changeSettings(item) {
      this.campaignData = item;
      this.campaignSettingsDialog = !this.campaignSettingsDialog;
    },
    /**
     * Handles the 'loading-status' event emitted by the child component.
     * @param {boolean} status - True if loading started, false if loading finished.
    */
    handleLoadingStatus(status) {
      this.isLoading = status;
    },
    /**
     * Updates the local data variable to log the current scraping status.
     * This replaces the logToLocalStorage functionality.
     */
    logScrapingStatus(message) {
        this.scrapingStatusMessage = message; 
        console.log(`[STATUS] ${message}`);
    },

    async scrapComments(link, postID) {
      if (!link || !postID) return false;
      const post = this.posts.find(item => item.id === postID);
      const platform = getReportPlatform(post || {});
      if (!['instagram', 'tiktok'].includes(platform)) {
        this.$swal({ title: 'Info', text: 'Comment extraction supports Instagram and TikTok.', type: 'info' });
        return false;
      }
      this.isScrapLoading = true;
      this.updatePostScrapingStatus(postID, true, null);
      try {
        const result = await campaignAPIs.extractReportPost(link, platform, 'comments');
        const comments = result.comments;
        if (!Array.isArray(comments)) throw new Error('Comment extraction returned invalid data.');
        if (comments.length) {
          await campaignAPIs.updateReportsByIds([{ id: postID, comments }]);
          this.quickReload();
        }
        this.updatePostScrapingStatus(postID, false, comments);
        this.$swal({ title: 'Success', text: comments.length ? `${comments.length} comments saved.` : 'No comments were found.', type: 'info' });
        return comments;
      } catch (error) {
        this.updatePostScrapingStatus(postID, false, null);
        this.$swal({ title: 'Error', text: (error.response && error.response.data && error.response.data.message) || error.message || 'Comment extraction failed.', type: 'error' });
        return false;
      } finally {
        this.isScrapLoading = false;
      }
    },

    /**
     * Updates the status and results of the scraping job for a specific post.
     */
    updatePostScrapingStatus(postID, status, comments) {
        this.posts = this.posts.map(p => {
            if (p.id === postID) {
                return { 
                    ...p, 
                    // Using isScrapingComments for the per-post status
                    isScrapingComments: status, 
                    scrapedComments: comments 
                };
            }
            return p;
        });
        this.filteredPosts = this.posts.map(p => p); 
    },
    /**
     * Opens the comments dialog and passes the comments array.
     * Assumes the post object contains a 'comments' property (where scraper data is saved).
     * @param {Object} post - The post object containing the 'comments' array.
     */
    openCommentsDialog(post) {
      if (post.comments && Array.isArray(post.comments)) {
        this.selectedPostComments = post.comments;
        this.viewCommentsDialog = true;
      } else {
        this.selectedPostComments = [];
        this.$swal({ title: 'Info', text: 'No comments data found for this post.', type: 'info' });
      }
    }
  },
  computed: {
    ...mapState({
      paymentStatuses: state => state.payment.status,
      updatedReport: state => state.campaign.updatedReport,
      infDetail: state => state.influencer.infDetail
    }),
    ...mapGetters('payment', [
      'paymentStatusOptions'
    ]),
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    campaignStatusDisplay: function() {
      return config.campaignStatusDisplay;
    },
    currentCampaignStatusDisplay() {
      if (!this.campaignData || this.campaignData.status === undefined || this.campaignData.status === null) return 'N/A'
      const status = this.campaignStatusDisplay[this.campaignData.status]
      return status && status.display ? status.display : 'N/A'
    },
    minLiveDate() {
      let liveDates = this.refreshJSON(this.liveDates)
      let orderedDates = liveDates.sort(function(a, b) { return new Date(a) - new Date(b) })
      return orderedDates.length > 0 ? moment(orderedDates[0]).format('DD/MM/YYYY') : 0
    },
    maxLiveDate() {
      let liveDates = this.refreshJSON(this.liveDates)
      let orderedDates = liveDates.sort(function(a, b) { return new Date(a) - new Date(b) })
      return orderedDates.length > 0 ? moment(orderedDates[orderedDates.length - 1]).format('DD/MM/YYYY') : 0
    },
    outreachCurrent() {
      return Number(this.summary && this.summary.outreach ? this.summary.outreach : 0)
    },
    outreachTarget() {
      return Number(this.campaignData && this.campaignData.outreach ? this.campaignData.outreach : 0)
    },
    outreachRatio() {
      if (!this.outreachTarget || this.outreachTarget <= 0) {
        return 0
      }
      return this.outreachCurrent / this.outreachTarget
    },
    outreachGaugeRatio() {
      return Math.min(Math.max(this.outreachRatio, 0), 1)
    },
    outreachRatioPercent() {
      return (this.outreachRatio * 100).toFixed(1)
    },
    outreachNeedleRotation() {
      return -90 + (this.outreachGaugeRatio * 180)
    },
    outreachArcLength() {
      return Math.PI * 75
    },
    outreachArcOffset() {
      return this.outreachArcLength * (1 - this.outreachGaugeRatio)
    },
    outreachOdometerDigits() {
      const current = Math.max(0, Math.floor(this.outreachCurrent))
      const target = Math.max(0, Math.floor(this.outreachTarget))
      const maxDigits = Math.max(String(current).length, String(target).length, 6)
      return String(current).padStart(maxDigits, '0').split('')
    },
    contentsCurrent() {
      return Number(this.summary && this.summary.contents ? this.summary.contents : 0)
    },
    contentsTarget() {
      return Number(this.campaignData && this.campaignData.min_content ? this.campaignData.min_content : 0)
    },
    contentsRatio() {
      if (!this.contentsTarget || this.contentsTarget <= 0) {
        return 0
      }
      return this.contentsCurrent / this.contentsTarget
    },
    contentsGaugeRatio() {
      return Math.min(Math.max(this.contentsRatio, 0), 1)
    },
    contentsRatioPercent() {
      return (this.contentsRatio * 100).toFixed(1)
    },
    contentsProgressFillPercent() {
      return this.contentsGaugeRatio * 100
    },
    imsStatusOptions: function() {
      let data = [];
      Object.entries(this.imsStatuses).forEach(item => {
        data.push({
          status: item[1].value,
          display: item[1].text
        });
      });
      return data;
    },
    // paymentStatusOptions: function() {
    //   let data = [];
    //   Object.entries(this.paymentStatuses).forEach(item => {
    //     data.push({
    //       status: item[1].value,
    //       display: item[1].text
    //     });
    //   });
    //   return data;
    // },
    budget: function() {
      // return this.markupCOGSAmount ? this.markupCOGSAmount : Math.floor(this.campaignData.budget * 0.26)
      return Math.floor(this.campaignData.budget * 0.26)
    },
    markupCOGSAmount: function() {
      return campaignHelper.getMarkupCOGS(this.campaignData.ioNumbers, this.client)
    },
    cogsPercentage: function() {
      return this.campaignData ? ((this.totalCounts.amount / this.campaignData.budget) * 100).toFixed(2) : 0;
    },
    revenueByContents: function() {
      return this.summary.revenueByContents ? Number(this.summary.revenueByContents) : 0
    },
    revenueByEng: function() {
      return this.summary.revenue ? Number(this.summary.revenue) : 0
    },
    revenueByContentsPercent: function() {
      return (this.summary.revenueByContents_percentage && this.summary.revenueByContents_percentage !== 'NaN') ? (Math.floor(this.summary.revenueByContents_percentage)).toFixed(2) : 0
    },
    revenueEngPercent: function() {
      return (this.summary.revenue_percentage && this.summary.revenue_percentage !== 'NaN') ? (Math.floor(this.summary.revenue_percentage)).toFixed(2) : 0
    },
    UnRecognisedRevenueContent: function() {
      return this.campaignData ? (this.campaignData.budget - this.summary.revenueByContents).toFixed(2) : 0;
    },
    UnRecognisedRevenueContentPercentage: function() {
      return this.campaignData ? ((this.UnRecognisedRevenueContent / this.campaignData.budget) * 100).toFixed(2) : 0;
    },
    UnRecognisedRevenueEng: function() {
      return this.campaignData ? this.campaignData.budget - this.summary.revenue : 0;
    },
    UnRecognisedRevenueEngPercentage: function() {
      return this.campaignData ? ((this.UnRecognisedRevenueEng / this.campaignData.budget) * 100).toFixed(2) : 0;
    },
    outreachImpressionsTotal() {
      const outreach = Number(this.summary && this.summary.outreach ? this.summary.outreach : 0)
      const impressions = Number(this.summary && this.summary.impressions ? this.summary.impressions : 0)
      return outreach + impressions
    },
    numberOfReviewers: function() {
      return this.reviewers.size
    },
    computedHeaders() {
      let reportCols = null
      let headers = utils.func.refreshJSON(this.headers)
      headers = headers.map(h => {
        if (h.value === 'labels') {
          h.text = ''
        }
        return h
      })
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.reportCols) {
          reportCols = Object.assign({}, this.userProfile.tableSettings.reportCols)
        }
      }
      if (reportCols) {
        this.colStatuses = Object.assign({}, reportCols)
      } else {
        // default true if no col status in local storage
        headers.map(header => {
          if (!this.defaultHideCols.includes(header.value)) {
            this.colStatuses[header.value] = true
          }
        })
      }
      return headers.filter(h => {
        if (this.colStatuses[h.value]) {
          return true
        }
        return false
      });
    }
  },
  directives: {
    sortableDataTable: {
      bind (el, binding, vnode) {
        let items = vnode.child.items
        const options = {
          animation: 150,
          onUpdate: function (event) {
            vnode.child.$emit('sorted', event, items)
          }
        }
        Sortable.create(el.getElementsByTagName('tbody')[0], options)
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.report__table ::v-deep th.report-handle-column {
  min-width: 210px;
}

.campaing-infor {
  background: #076585; /* fallback for old browsers */
  background: -webkit-linear-gradient(to bottom, #076585, #fff); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to bottom, #076585, #fff); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.campaign-post {
  a:link,
  a:visited {
    color: white !important;
    background-color: transparent;
    text-decoration: none;
  }
}

.campaign-post-owner-content {
  flex: 1 1 0;
  min-width: 0;
  padding: 0 !important;
  max-width: 100%;
}

.campaign-post-owner-title {
  display: flex;
  align-items: center;
  min-width: 0;
  line-height: 24px;
}

.campaign-post-owner-handle {
  display: block;
  flex: 1 1 auto;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #f4f4f4 !important;

}

.campaign-post-type-action {
  align-self: center;
  flex: 0 0 auto;
  min-width: 0;
  max-width: 45%;
  margin: 0 0 0 6px !important;
}

.campaign-post-type-chip {
  max-width: 100%;
}

.campaign-post-type-action ::v-deep .v-chip {
  max-width: 100%;
}

.campaign-post-type-action ::v-deep .v-chip__content {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.campaign-post-type-title {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.campaign-post-header {
  padding: 12px !important;
}

.campaign-post-header-row {
  align-items: center;
  flex: 1 1 0;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  min-height: 40px;
}

.campaign-post-header-row ::v-deep .v-list-item__avatar {
  align-self: center;
  margin: 0 8px 0 0;
}

.linkedin-post-embed,
.twitter-post-embed {
  display: block;
  width: 100%;
  min-height: 300px;
  border: 0;
  border-radius: 2px;
  background: #fff;
}

.twitter-grid-column {
  min-width: 0;
}

.twitter-campaign-post {
  width: 100%;
  overflow: hidden;
}

.twitter-campaign-post .campaign-post-owner-content {
  max-width: 50%;
}

.twitter-embed-card-text {
  min-height: 0 !important;
  padding: 10px !important;
}

.twitter-embed-shell {
  width: 100%;
  height: 430px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  background: #000;
}

.twitter-embed-shell .twitter-post-embed {
  height: 100%;
  min-height: 0;
  border-radius: 0;
  background: #000;
}

.twitter-campaign-post ::v-deep .v-card__actions {
  flex-wrap: wrap;
  gap: 4px;
}

@media (max-width: 600px) {
  .twitter-embed-shell {
    height: 380px;
  }
}

.linkedin-campaign-post ::v-deep .v-expansion-panel:first-child tbody tr:nth-child(1),
.linkedin-campaign-post ::v-deep .v-expansion-panel:first-child tbody tr:nth-child(2),
.linkedin-campaign-post ::v-deep .v-expansion-panel:first-child tbody tr:nth-child(3),
.linkedin-campaign-post ::v-deep .v-expansion-panel:first-child tbody tr:nth-child(6),
.linkedin-campaign-post ::v-deep .v-expansion-panel:first-child tbody tr:nth-child(7),
.linkedin-campaign-post ::v-deep .v-expansion-panel:first-child tbody tr:nth-child(8),
.linkedin-campaign-post ::v-deep .v-expansion-panel:first-child tbody tr:nth-child(10),
.linkedin-campaign-post ::v-deep .v-expansion-panel:nth-child(2) {
  display: none !important;
}

.campaign-post ::v-deep .v-expansion-panel {
  background-color: #1f1f1f !important;
  color: #f4f4f4 !important;
}

.campaign-post ::v-deep .v-expansion-panel-header,
.campaign-post ::v-deep .v-expansion-panel-header .v-icon {
  color: #f4f4f4 !important;
}

.campaign-post ::v-deep .v-expansion-panel-content__wrap {
  background-color: #1f1f1f !important;
  padding: 8px 18px 12px;
}

.campaign-post ::v-deep .v-simple-table,
.campaign-post ::v-deep .v-simple-table > .v-data-table__wrapper,
.campaign-post ::v-deep .v-simple-table table,
.campaign-post ::v-deep .v-simple-table tbody,
.campaign-post ::v-deep .v-simple-table tr {
  background-color: #1f1f1f !important;
  color: #f4f4f4 !important;
}

.campaign-post ::v-deep .v-simple-table td {
  border-bottom: 1px solid rgba(244, 244, 244, 0.28) !important;
  color: #f4f4f4 !important;
  font-size: 12px;
  height: 26px;
}

.campaign-post ::v-deep .v-simple-table td:first-child {
  color: rgba(244, 244, 244, 0.82) !important;
}

.campaign-post ::v-deep .v-simple-table td:last-child {
  color: #ffffff !important;
  font-weight: 700;
  text-align: right;
}

.campaign-post ::v-deep .v-simple-table tr:hover {
  background-color: #282828 !important;
}

.v-card__text.headline {
  min-height: 300px
}

.media-iframe {
  box-sizing: content-box;
  border-radius: 2%;
  border: 1px solid #fff;
}

.media-iframe.list {
  margin-top: 20%;
}

.report__table .v-btn.red {
  color: #fff!important;
}

.outreach-kpi-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.contents-kpi-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.display-text {
  flex: 1;
}

.odometer-gauge {
  flex-shrink: 0;
  background: #363636;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 10px 12px;
}

.odometer-arc {
  position: relative;
  width: 170px;
  height: 86px;
  margin: 0 auto 6px;
  overflow: hidden;
}

.odometer-arc-svg {
  width: 100%;
  height: 100%;
}

.odometer-arc-track-path {
  fill: none;
  stroke: rgba(255, 255, 255, 0.2);
  stroke-width: 12;
  stroke-linecap: round;
}

.odometer-arc-progress-path {
  fill: none;
  stroke: #22c55e;
  stroke-width: 12;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.45s ease;
}

.odometer-arc-center {
  position: absolute;
  left: 50%;
  top: 13px;
  width: 144px;
  height: 144px;
  border-radius: 50%;
  transform: translateX(-50%);
  background: #363636;
}

.odometer-needle {
  position: absolute;
  left: 50%;
  bottom: 4px;
  width: 3px;
  height: 66px;
  background: #fff;
  border-radius: 4px;
  transform-origin: bottom center;
  transition: transform 0.45s ease;
  z-index: 2;
}

.odometer-meta {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 6px;
}

.odometer-percent {
  font-size: 18px;
  font-weight: 700;
}

.odometer-label {
  font-size: 12px;
  opacity: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.odometer-counter {
  display: flex;
  justify-content: center;
  gap: 4px;
}

.odometer-digit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  padding: 4px 5px;
  background: #0f171c;
  color: #8cffc1;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  font-family: 'Courier New', monospace;
}

.contents-progress-gauge {
  width: 220px;
  padding: 8px 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  background: #363636;
  flex-shrink: 0;
}

.contents-progress-head {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
}

.contents-progress-percent {
  font-size: 16px;
  font-weight: 700;
}

.contents-progress-track {
  position: relative;
  width: 100%;
  height: 16px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: #1a252c;
  overflow: hidden;
}

.contents-progress-fill {
  height: 100%;
  width: 0;
  border-radius: inherit;
  background: linear-gradient(90deg, #ef5350 0%, #66bb6a 100%);
  transition: width 0.45s ease;
}

.contents-progress-scale {
  margin-top: 6px;
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  opacity: 0.8;
}

@media (max-width: 960px) {
  .outreach-kpi-row,
  .contents-kpi-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .odometer-gauge {
    width: 100%;
  }

  .contents-progress-gauge {
    width: 100%;
  }
}

.cut-text {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 320px;
  white-space: nowrap;
}

.igPost-block {
  overflow: scroll;
  max-width: 350px;
  max-height: 350px;
}

.item-edit {
  min-width: 75px;
  min-height: 75px;
  padding-top: 30px;
}

.btn-reload {
  margin-top: 22px;
}
</style>



// WEBPACK FOOTER //
// CampaignReportInternal.vue?a4957cfe